"use strict";

window.PXUTheme.contentCreator.accordion = {
  init: function () {
    const $accordionHeading = $('.accordion > dt > a, [data-cc-accordion] > dt > a');
    $('.accordion > dd, [data-cc-accordion] > dd').attr('aria-hidden', true);
    $accordionHeading.attr('aria-expanded', false);
    $accordionHeading.on('click', function () {
      let state = $(this).attr('aria-expanded') === 'false' ? true : false;
      $(this).attr('aria-expanded', state);
      $(this).parent().next().attr('aria-hidden', !state);
      return false;
    });
    $accordionHeading.on('keydown', function (event) {
      let keyCode = event.keyCode || e.which;
      if (keyCode === 13) {
        $(this).trigger('activate');
      }
    });
  },
  unload: function () {
    $('.accordion > dt > a, [data-cc-accordion] > dt > a').off('click activate');
    $('.accordion > dt > a, [data-cc-accordion] > dt > a').off('keydown');
  }
};
window.PXUTheme.contentCreator.slideshow = {
  init: function () {
    //backwards compatibility with flexslider
    $('.slider, .flexslider').find('li').unwrap();
    $('.slider, .flexslider').flickity({
      pageDots: true,
      lazyLoad: 2
    });
  }
};
window.PXUTheme.animation = {
  init: function () {
    $('[data-scroll-class]').waypoint(function () {
      const animationClass = $(this.element).data('scroll-class');
      $(this.element).addClass('animated').addClass(animationClass);
    }, {
      offset: '70%'
    });
  },
  slideTransition: function ($el, animationName, callback) {
    $el.parents('.flickity-enabled').find('.animated').removeClass('animated ' + animationName);
    $el.addClass('animated').addClass(animationName);
  },
  unload: function ($target) {
    $target.data('scroll-class', '');
  }
};
const deferred = {};
window.PXUTheme.asyncView = {
  /**
   * Load the template given by the provided URL into the provided
   * view
   *
   * @param {string} url - The url to load.
   * @param {string} view - The view to load into.
   * @param {object} options - Config options.
   * @param {string} options.hash - A hash of the current page content.
   */
  load: function (url, view) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    let data;
    if (url in deferred) {
      return deferred[url];
    }
    const $deferred = $.Deferred();
    deferred[url] = $deferred;
    if (options.hash) {
      data = sessionStorage.getItem(url);
      if (data) {
        const deserialized = JSON.parse(data);
        if (options.hash === deserialized.options.hash) {
          delete deferred[url];
          return $deferred.resolve(deserialized).promise();
        }
      }
    }

    // NOTE The $.ajax request has the cache option set to false.
    // This is to prevent certain browsers from returning cached
    // versions of the url we are requesting.
    // See this PR for more info: https://github.com/pixelunion/shopify-asyncview/pull/4
    $.ajax({
      url,
      cache: false,
      data: `view=${view}`,
      dataType: 'html',
      headers: {
        'cache-control': 'no-cache'
      },
      success: response => {
        const el = document.createElement('div');
        el.innerHTML = response;
        const responseOptions = JSON.parse(el.querySelector('[data-options]').innerHTML);
        const htmls = el.querySelectorAll('[data-html]');
        let html = {};
        if (htmls.length === 1 && htmls[0].getAttribute('data-html') === '') {
          html = htmls[0].innerHTML;
        } else {
          for (let i = 0; i < htmls.length; i++) {
            html[htmls[i].getAttribute('data-html')] = htmls[i].innerHTML;
          }
        }
        if (options.hash) {
          try {
            sessionStorage.setItem(url, JSON.stringify({
              options: responseOptions,
              html
            }));
          } catch (error) {
            console.error(error);
          }
        }
        delete deferred[url];
        return $deferred.resolve({
          options: responseOptions,
          html
        });
      },
      error: () => {
        delete deferred[url];
        return $deferred.reject();
      }
    });
    return $deferred.promise();
  }
};
window.PXUTheme.addImageDimension = function (imageUrl, size) {
  var insertPosition = imageUrl.lastIndexOf(".");
  return imageUrl.substring(0, insertPosition) + size + imageUrl.substring(insertPosition);
};
window.PXUTheme.breadcrumbs = {
  init: function (pages) {
    // Show pagination if number of pages is greater than 1
    if (pages > 1) {
      const breadcrumbSpan = document.querySelector('[data-breadcrumb-text]');
      const currentPage = document.querySelector('.paginate').dataset.currentPage ? document.querySelector('.paginate').dataset.currentPage : 1;
      const totalPages = document.querySelector('.paginate').dataset.paginatePages;
      document.querySelector('.js-breadcrumb-text').classList.remove('is-hidden');
      breadcrumbSpan.innerHTML = `${window.PXUTheme.translation.page_text} ${currentPage} ${window.PXUTheme.translation.of_text} ${totalPages}`;
    }
  },
  unload: function ($target) {
    document.querySelector('.js-breadcrumb-text').classList.add('is-hidden');
  }
};
window.PXUTheme.debounce = function (func, wait, immediate) {
  let timeout = null;
  return () => {
    const context = this;
    const args = arguments;
    const later = () => {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(context, args);
    }
  };
};
window.PXUTheme.disclosure = {
  enable: function () {
    const $disclosure = $('[data-disclosure]');
    const $toggle = $('[data-disclosure-toggle]');
    const $disclosureWrap = $('.disclosure__list-wrap');
    const $mobileMenuDisclosureList = $('[data-disclosure-list]');
    const escapeCountrySelector = 'footer.footer__container [data-disclosure-country], body[data-site-header-layout="classic"] #mobile-header.mobile-header #msg-mobile-menu .selectors-form--mobile .disclosure[data-disclosure-country], body[data-site-header-layout="classic"] header.top-bar .top-bar__disclosure form#header__selector-form--top-bar .header-menu__disclosure .disclosure[data-disclosure-country]';
    const focusCountrySelector = escapeCountrySelector;

    // Check if current opened menu is offscreen
    function checkOffScreen($openedToggle) {
      if ($openedToggle.siblings('.disclosure__list-wrap').is(':off-right')) {
        $openedToggle.siblings('.disclosure__list-wrap').addClass('disclosure--left');
      }
    }
    function closeDisclosures(ignoreTarget, currentTarget) {
      if (ignoreTarget === true) {
        $toggle.not(currentTarget).removeClass('is-clicked');
        $toggle.not(currentTarget).attr('aria-expanded', 'false');
      } else {
        $toggle.removeClass('is-clicked');
        $toggle.attr('aria-expanded', 'false');
      }
      $disclosureWrap.removeClass('disclosure--left');
    }

    // Return owned country-list focus to its own toggle on ESC.
    $('body').on('keyup', function (e) {
      if (e.key === 'Escape' || e.which == '27') {
        const $returnToggle = $(document.activeElement)
          .closest(escapeCountrySelector)
          .find('[data-disclosure-toggle]')
          .first();
        if ($returnToggle.length) $returnToggle.attr('data-msg-disclosure-escape-closed', '');
        closeDisclosures();
        if ($returnToggle.length) {
          // Shared on the element so repeated enable() bindings also skip reopening.
          $returnToggle.data('msgEscapeFocusReturn', true);
          try {
            $returnToggle[0].focus({ preventScroll: true });
          } finally {
            $returnToggle.removeData('msgEscapeFocusReturn');
          }
        }
      }
    });

    function closeOwnedCountry(owner) {
      $(owner).find('[data-disclosure-toggle]').removeClass('is-clicked').attr('aria-expanded', 'false');
      $(owner).find('.disclosure__list-wrap').removeClass('disclosure--left');
    }

    // Pointer departure must not hide the owned country that still owns focus.
    $disclosure.on('mouseleave', function (e) {
      if ($(this).is(focusCountrySelector)) {
        if (!this.contains(document.activeElement)) closeOwnedCountry(this);
        return;
      }
      closeDisclosures();
    });

    // Keep legacy last-item behavior outside the owned country.
    $disclosure.find('.disclosure-list__item:last-child').on('focusout', function (e) {
      if ($(this).closest(focusCountrySelector).length) return;
      closeDisclosures();
    });

    // Any owned country focus exit closes only that disclosure. A null destination
    // needs settled focus; a newer focus/hover interaction cancels that stale check.
    $(focusCountrySelector).on('focusin mouseenter', function () {
      $(this).removeData('msgCountryFocusExit');
    }).on('focusout', function (e) {
      const owner = this;
      $(owner).removeData('msgCountryFocusExit');
      if (e.relatedTarget) {
        if (!owner.contains(e.relatedTarget)) closeOwnedCountry(owner);
        return;
      }
      const ticket = {};
      $(owner).data('msgCountryFocusExit', ticket);
      setTimeout(function () {
        if ($(owner).data('msgCountryFocusExit') !== ticket) return;
        $(owner).removeData('msgCountryFocusExit');
        if ($(owner).is(focusCountrySelector) && !owner.contains(document.activeElement)) closeOwnedCountry(owner);
      }, 0);
    });

    // On click/focus event for toggling options
    $toggle.on('mouseenter focus', function (e) {
      if (e.type === 'focus' && $(this).data('msgEscapeFocusReturn')) return;
      if (e.type === 'mouseenter') $(this).closest(focusCountrySelector).removeData('msgCountryFocusExit');
      $(this).removeAttr('data-msg-disclosure-escape-closed');
      // Close all other menus
      closeDisclosures(true, this);
      const $target = $(e.currentTarget);
      $target.attr('aria-expanded', 'true').addClass('is-clicked');
      checkOffScreen($target);
    });

    // A native button click (including Enter/Space) reopens an owned country
    // toggle after Escape, while preserving the existing open behavior.
    $(escapeCountrySelector).find('[data-disclosure-toggle]').on('click', function () {
      closeDisclosures(true, this);
      const $target = $(this);
      $target.removeAttr('data-msg-disclosure-escape-closed');
      $target.attr('aria-expanded', 'true').addClass('is-clicked');
      checkOffScreen($target);
    });

    // Mobile toggle logic
    $mobileMenuDisclosureList.on('touchstart', function (e) {
      const $target = $(e.currentTarget);
      $target.parents('.disclosure').addClass('is-clicked');
      closeDisclosures(true, this);
      if ($target.hasClass('is-clicked') == false) {
        $target.attr('aria-expanded', 'true').addClass('is-clicked');
        checkOffScreen($target);
      } else {
        $target.attr('aria-expanded', 'false').removeClass('is-clicked');
        $disclosureWrap.removeClass('disclosure--left');
      }
    });
    $mobileMenuDisclosureList.on('focusout', function (e) {
      closeDisclosures(true, this);
    });

    // Mobile form submitting
    $mobileMenuDisclosureList.on('change', function (e) {
      if (window.PXUTheme.media_queries.medium.matches || !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        const $target = $(e.currentTarget);
        const selectedValue = e.currentTarget.value;
        const disclosureInput = $target.parents('.selectors-form__item').find('[data-disclosure-input]');
        const selectorForm = $target.parents('.selectors-form');
        if (!$target.hasClass('custom-currency')) {
          disclosureInput.val(selectedValue);
          selectorForm.submit();
        } else {
          $target.trigger('click');
        }
      }
    });
  },
  unload: function () {
    $('[data-disclosure]').removeData('msgCountryFocusExit').off();
    $('[data-disclosure-toggle]').off();
    $('.disclosure__list-wrap').off();
  }
};
window.PXUTheme.dropdownMenu = function () {
  // Grab menu items
  const menuItems = $('.navbar-link');

  // Grab dropdowns
  const dropdowns = $('.navbar-dropdown');

  // Grab megamenus

  const megamenus = $('.has-mega-menu');

  // Listen for enter key
  menuItems.each(function (index, item) {
    let itemVisited = false;
    $(item).on('keydown', function (e) {
      // Check if enter key
      if (e.which === 13) {
        // Escape starts a new opening interaction for this exact trigger.
        const reopeningAfterEscape = $(this).closest('.navbar-item').hasClass('msg-nav-escape-closed');
        if (reopeningAfterEscape) itemVisited = false;
        // Prevent it from going to the link
        if (itemVisited === false) {
          e.preventDefault();
        }

        // Show dropdown
        $(this).closest('.navbar-item').removeClass('msg-nav-escape-closed').addClass('show-dropdown');
        if (reopeningAfterEscape) window.msgB80DesktopNavEscape.sync(this);

        // Reset itemVisited so that they can visit the link
        itemVisited = true;
      }
    });
    $(item).closest('.navbar-item').on('focusout', function (e) {
      if ($(this).find(e.relatedTarget).length === 0) {
        $(item).closest('.navbar-item').removeClass('show-dropdown');
      }
    });
  });

  // Listen for enter key
  dropdowns.each(function (index, item) {
    let itemVisited = false;
    $(item).on('keydown', function (e) {
      // Check if enter key
      if (e.which === 13) {
        // Prevent it from going to the link
        if (itemVisited === false) {
          e.preventDefault();
        }
        if ($(this).find('.has-submenu').length > 0) {
          $(this).addClass('show-nested-dropdown');
        }

        // Reset itemVisited so that they can visit the link
        itemVisited = true;
      }
    });
  });

  // Listen for enter key
  megamenus.each(function (index, item) {
    let itemVisited = false;
    $(item).on('keydown', function (e) {
      // Check if enter key
      if (e.which === 13) {
        // Prevent it from going to the link
        if (itemVisited === false) {
          e.preventDefault();
        }

        // Show megamenu
        $(this).find('.mega-menu').addClass('mega-menu--show');

        // Reset itemVisited so that they can visit the link
        itemVisited = true;
      }
    });

    // Hide mega menu on focusout
    $(item).on('focusout', function (e) {
      if ($(item).find(e.relatedTarget).length === 0) {
        $(item).find('.mega-menu').removeClass('mega-menu--show');
      }
    });
  });
};
window.PXUTheme.collapsibleRowUtil = {
  init: selector => {
    const headingSelector = selector || '.faq-accordion';
    const $faqHeading = $(`${headingSelector} > dt > button`);
    $(`${headingSelector} > dd`).attr('aria-hidden', true);
    $faqHeading.attr('aria-expanded', false);
    $faqHeading.off('click activate').on('click activate', e => {
      const $target = $(e.currentTarget);
      const $faqIcons = $target.find('.icon');
      const $plus = $target.find('.plus');
      const $state = $target.attr('aria-expanded') === 'false';
      $plus.toggleClass('collapsed');
      $target.attr('aria-expanded', $state);
      $target.parent().next().slideToggle(() => {
        $faqIcons.toggleClass('icon--active');
      });
      $target.parent().next().attr('aria-hidden', !$state);
      return false;
    });
  },
  unload: selector => {
    const headingSelector = selector || '.faq-accordion';
    $(`${headingSelector} > dt > button`).off('click activate');
    $(`${headingSelector} > dt > button`).off('keydown');
  }
};
window.PXUTheme.newsletterAjaxForm = {
  init: function () {
    // Selectors
    const $ajaxForm = $('.newsletter-form__wrapper .contact-form');
    $ajaxForm.each(function () {
      const $form = $(this);
      $form.on('submit', function (e) {
        if ($('input[name="challenge"]', $form).val() !== "true") {
          $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            success: function (data) {
              $form.fadeOut("slow", () => {
                $form.prev('.form__success-message').html(window.PXUTheme.translation.newsletter_form_success);
              });
            },
            error: function (data) {
              $('input[name="challenge"]', $form).val('true');
              $form.submit();
            }
          });
          e.preventDefault();
        }
      });
    });
  },
  unload: function () {
    const $ajaxForm = $('.newsletter-form__wrapper .contact-form');
    const $submitButton = $ajaxForm.find(':submit');
    $submitButton.off();
  }
};
window.PXUTheme.getSectionData = function ($section) {
  const sectionId = $section.attr('id').replace('shopify-section-', '');
  const $dataEl = $section.find(`[data-section-data][data-section-id=${sectionId}]`).first();
  if (!$dataEl) return {};

  // Load data from attribute, or innerHTML
  const data = $dataEl.data('section-data') || $dataEl.html();
  try {
    return JSON.parse(data);
  } catch (error) {
    console.warn(`Sections: invalid section data found. ${error.message}`);
    return {};
  }
};
window.PXUTheme.infiniteScroll = {
  init() {
    this.defaults = {
      grid: '[data-load-more--grid]',
      gridItems: '[data-load-more--grid-item]'
    };
    $('body').off('click', '[data-load-more]');
    $('body').on('click', '[data-load-more]', function (e) {
      e.preventDefault();
      const $button = $(this);
      const url = $button.attr('href');
      window.PXUTheme.infiniteScroll.loadNextPage(url, $button);
    });
    $('body').off('click', '[data-load-more-infinite]');
    $('body').on('click', '[data-load-more-infinite]', function (e) {
      window.PXUTheme.infiniteScroll.enableInfinite();
      $(this).remove();

      // Prevent link from going to next page
      e.stopPropagation();
      return false;
    });
    if ($('[data-load-infinite-scroll]').length) {
      window.PXUTheme.infiniteScroll.enableInfinite();
    }
  },
  loadNextPage(url, $button) {
    $.ajax({
      type: 'GET',
      dataType: 'html',
      url,
      beforeSend() {
        $button.addClass('is-loading');
      },
      success: data => {
        $button.removeClass('is-loading');
        const thumbnails = $(data).find(this.defaults.gridItems);
        const loadMoreButtonUrl = $(data).find('[data-load-more]').attr('href');
        $('[data-load-more]').attr('href', loadMoreButtonUrl);
        $(this.defaults.grid).first().append(thumbnails);

        // Initialize product reviews
        window.PXUTheme.productReviews.init();

        // When there are no additional pages, hide load more button
        if (typeof loadMoreButtonUrl === 'undefined') {
          $('[data-load-more]').addClass('is-hidden');
        }
      },
      error(x, t, m) {
        console.log(x);
        console.log(t);
        console.log(m);
        location.replace(`${location.protocol}//${location.host}`);
      }
    });
  },
  enableInfinite() {
    var infiniteScroll = new Waypoint.Infinite({
      element: $(this.defaults.grid)[0],
      items: '[data-load-more--grid-item]',
      more: '[data-load-infinite]',
      loadingClass: 'loading-in-progress',
      onBeforePageLoad() {
        $('[data-load-infinite]').removeClass('is-hidden');
      },
      onAfterPageLoad() {
        // Initialize product reviews
        window.PXUTheme.productReviews.init();
      }
    });
  },
  unload() {
    $('[data-load-more]').off();
    $('[data-load-infinite]').off();
    $('[data-load-more-infinite]').off();
  }
};
window.PXUTheme.flickityIosFix = function () {
  var touchingCarousel = false,
    touchStartCoords;
  document.body.addEventListener('touchstart', function (e) {
    if (e.target.closest('.flickity-slider')) {
      touchingCarousel = true;
    } else {
      touchingCarousel = false;
      return;
    }
    touchStartCoords = {
      x: e.touches[0].pageX,
      y: e.touches[0].pageY
    };
  });
  document.body.addEventListener('touchmove', function (e) {
    if (!(touchingCarousel && e.cancelable)) {
      return;
    }
    var moveVector = {
      x: e.touches[0].pageX - touchStartCoords.x,
      y: e.touches[0].pageY - touchStartCoords.y
    };
    if (Math.abs(moveVector.x) > 7) e.preventDefault();
  }, {
    passive: false
  });
};
window.PXUTheme.loadScript = function (name, url, callback) {
  if (window.PXUTheme[name]) {
    callback;
  } else {
    $.ajax({
      url,
      dataType: 'script',
      success: callback,
      async: false
    });
  }
};
window.PXUTheme.applyMasonry = function (selector, gutterSize) {
  let $galleryWrapper = $('.gallery__wrapper--vertical-masonry');
  if ($galleryWrapper.length > 0) {
    $galleryWrapper.imagesLoaded().progress(function () {
      $galleryWrapper.isotope({
        layoutMode: 'masonry',
        itemSelector: selector,
        percentPosition: true,
        masonry: {
          columnWidth: selector,
          gutter: gutterSize
        }
      });
    });
  }
};
window.PXUTheme.applyHorizontalMasonry = function () {
  let $galleryWrapper = $('.gallery__wrapper--horizontal-masonry');
  $galleryWrapper.find('.gallery__item').each(function (e) {
    var wrapper = $(this);
    var imgWidth, imgHeight;
    setTimeout(function () {
      imgWidth = wrapper.find('img').width();
      imgHeight = wrapper.find('img').height();
      wrapper.css("flex-basis", imgWidth * 200 / imgHeight);
      wrapper.css("flex-grow", imgWidth * 200 / imgHeight);
      wrapper.find("i").css("padding-bottom", imgHeight / imgWidth * 100 + '%');
    }, 100);
  });
};
window.PXUTheme.mobileMenu = {
  init: function () {
    if (this.setupClassicLifecycle) this.setupClassicLifecycle();
    if (this.classicLifecycle) return this.classicLifecycle.init();
    if (document.body && document.body.getAttribute('data-site-header-layout') === 'classic') return;
    this.$mobileMenuToggle = $('[data-show-mobile-menu]');
    this.$mobileMenuIcon = $('.mobile-menu__toggle-icon');
    this.$mobileDropDownToggle = $('.mobile-menu .close-dropdown');
    $('body').on('click', '[data-show-mobile-menu="false"]', function () {
      window.PXUTheme.mobileMenu.open();
    });
    $('body').on('click', '[data-show-mobile-menu="true"]', function () {
      window.PXUTheme.mobileMenu.close();
    });
    if (window.PXUTheme.jsHeader.enable_sticky === true) {
      this.enableSticky();
    }
  },
  open: function () {
    if (this.classicLifecycle) return this.classicLifecycle.open();
    if (document.body && document.body.getAttribute('data-site-header-layout') === 'classic') return;
    //Get current position on page
    let currentScrollPosition = window.scrollY;
    $('body').attr('data-current-position', currentScrollPosition);

    // Calculate height of mobile content area
    let announcementHeight = 0;
    let mobileHeaderHeight = parseInt($('.mobile-header').height());
    if (typeof window.PXUTheme.jsAnnouncementBar !== 'undefined' && window.PXUTheme.jsAnnouncementBar.enable_sticky) {
      announcementHeight = window.PXUTheme.jsAnnouncementBar.getAnnouncementHeight();
    }
    $('.mobile-menu').css({
      height: `calc(100vh - ${mobileHeaderHeight + announcementHeight}px)`
    });
    $('.mobile-menu__content').css({
      marginBottom: `${mobileHeaderHeight + announcementHeight}px`
    });
    this.$mobileMenuIcon.addClass('is-active');
    $('[data-show-mobile-menu]').attr('data-show-mobile-menu', true);
    if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
      window.PXUTheme.jsAjaxCart.hideMiniCart();
      window.PXUTheme.jsAjaxCart.hideDrawer();
    }

    //Set delay on menu open to get proper page position
    setTimeout(function () {
      $('body').addClass('mobile-menu--opened');
    }, 10);
  },
  close: function () {
    if (this.classicLifecycle) return this.classicLifecycle.close();
    if (document.body && document.body.getAttribute('data-site-header-layout') === 'classic') return;
    $('body').removeClass('mobile-menu--opened');

    // Once mobile menu is closed, return back to previous position on page
    let lastScrollPosition = $('body').data('current-position');
    window.scrollTo(0, lastScrollPosition);
    this.$mobileMenuIcon.removeClass('is-active');
    $('[data-show-mobile-menu]').attr('data-show-mobile-menu', false);
  },
  enableSticky: function () {
    window.PXUTheme.jsHeader.disableSticky();
    let $stickyEl = $('#mobile-header');
    let offset = 0;
    if (typeof window.PXUTheme.jsAnnouncementBar !== 'undefined' && window.PXUTheme.jsAnnouncementBar.enable_sticky) {
      offset = window.PXUTheme.jsAnnouncementBar.getAnnouncementHeight();
    }
    $stickyEl.addClass('sticky--enabled');
    $stickyEl.sticky({
      wrapperClassName: 'header-sticky-wrapper',
      zIndex: 40,
      topSpacing: offset
    }).on('sticky-start', () => {
      var headerheight = $('#mobile-header').height();
      var annoucementHeight = $('.announcement-sticky-wrapper').height();
      var totalHeight = headerheight + annoucementHeight;
      $stickyEl.parent().parent().find('.search-overlay').addClass('sticky-search').css('top', totalHeight + 'px');
    }).on('sticky-end', () => {
      $stickyEl.parent().parent().find('.search-overlay').removeClass('sticky-search').css('top', '100%');
      // Safety timeout for logo width transition which can throw calculated height off
      setTimeout(() => {
        $stickyEl.sticky('update');
      }, 250);
      $stickyEl.find('.sticky-menu-wrapper').removeClass('is-visible');
    });
  },
  disableSticky: function () {
    let $stickyEl = $('#mobile-header');
    $stickyEl.unstick();
    $stickyEl.removeClass('sticky--enabled');
    setTimeout(function () {
      $('.header-sticky-wrapper').css('height', 'auto');
    }, 250);
  },
  unload: function ($section) {
    if (this.classicLifecycle) return this.classicLifecycle.unload();
    if (document.body && document.body.getAttribute('data-site-header-layout') === 'classic') return;
    $('[data-mobilemenu-toggle]').off();
    $('.mobile-menu__toggle-icon').off();
    $('.mobile-menu .close-dropdown').off();
    this.disableSticky();
  }
};

/* B149: classic mobile navigation owns its timer, click binding and resize cleanup.
 * Other header layouts retain the original mobileMenu methods above. */
window.PXUTheme.mobileMenu.setupClassicLifecycle = function () {
  'use strict';
  var menu = window.PXUTheme.mobileMenu;
  var body = document.body;
  if (menu.classicLifecycle) {
    if (menu.classicLifecycle.root.isConnected && body && body.getAttribute('data-site-header-layout') === 'classic') return;
    menu.classicLifecycle.destroy();
  }
  if (!body || body.getAttribute('data-site-header-layout') !== 'classic') return;
  var section = document.querySelector('.header--classic');
  var header = section && section.querySelector('header#header.header');
  var mobile = section && section.querySelector('#mobile-header.mobile-header');
  var toggle = mobile && mobile.querySelector(':scope > button.mobile-menu__toggle-button[data-show-mobile-menu][aria-controls="msg-mobile-menu"]');
  var root = mobile && mobile.querySelector('#msg-mobile-menu[data-msg-mnav]');
  if (!header || !mobile || !toggle || !root) return;
  var media = window.PXUTheme.media_queries.large;
  var icon = mobile.querySelector('.mobile-menu__toggle-icon');
  var initialized = false, sticky = false, pending = null, generation = 0;
  var savedScroll = null, lastFocus = null, desktop = media.matches;
  var mainResizeWitness = null, mainResizeEpoch = 0;
  var mainResizeViewportListener = window.visualViewport || null;
  var OTHER_OWNER = '.fancybox-container, [role="dialog"], [role="alertdialog"], [aria-modal="true"], dialog, ' +
    '.search-overlay, .mobile-search, .ajax-cart, [data-ajax-cart-trigger], [data-show-search-trigger], iframe, object, embed';
  var WIDGET_OWNER = '[data-disclosure], select, [role="combobox"], [role="listbox"], [role="menu"], [role="tree"]';

  function visible(element) {
    if (!element || !element.isConnected || element.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.visibility !== 'collapse' &&
      Array.from(element.getClientRects()).some(function (rect) { return rect.width > 0 && rect.height > 0; });
  }
  function owner(element) {
    if (!element || !element.closest || element.shadowRoot || element.closest(OTHER_OWNER)) return null;
    // A closed-shadow custom element hides its inner Escape/focus owner.
    for (var node = element; node && node !== body; node = node.parentElement) {
      if (node.localName && node.localName.indexOf('-') !== -1) return null;
    }
    if (element === toggle || root.contains(element) || (mobile.contains(element) && element.closest('.mobile-logo, .mobile-logo__outer'))) return 'mobile';
    var topbar = document.querySelector('.shopify-section.shopify-section-group-header-group-classic.top-bar');
    if (topbar && topbar.contains(element)) return 'desktop';
    if (header.contains(element) && element.closest('.header__brand, .header__menu-items')) return 'desktop';
    return null;
  }
  function sync() {
    // The existing snippet remains the owner of inert/ARIA and subpanel reset.
    root.dispatchEvent(new Event('msg:menu-state'));
  }
  function focus(element) {
    if (visible(element)) element.focus({ preventScroll: true });
  }
  function cancelOpen() {
    clearMainResizeWitness();
    generation++;
    if (pending !== null) clearTimeout(pending);
    pending = null;
  }
  function init() {
    if (media.matches || !root.isConnected) return;
    if (!initialized) { toggle.addEventListener('click', click); initialized = true; }
    // Settings may arrive after the early resize listener. Do not bind the
    // sticky plugin twice; still undo jsHeader's later desktop-resize callback.
    if (window.PXUTheme.jsHeader.enable_sticky === true) {
      if (!sticky) { menu.enableSticky(); sticky = true; }
      else if (header.classList.contains('sticky--enabled')) window.PXUTheme.jsHeader.disableSticky();
    } else if (sticky) { menu.disableSticky(); sticky = false; }
  }
  function open() {
    clearMainResizeWitness();
    if (!initialized || media.matches || !visible(toggle) || pending !== null || body.classList.contains('mobile-menu--opened')) return;
    savedScroll = window.scrollY;
    body.setAttribute('data-current-position', String(savedScroll));
    var announcementHeight = 0;
    var mobileHeaderHeight = parseInt($(mobile).height(), 10) || 0;
    if (window.PXUTheme.jsAnnouncementBar && window.PXUTheme.jsAnnouncementBar.enable_sticky) {
      announcementHeight = window.PXUTheme.jsAnnouncementBar.getAnnouncementHeight();
    }
    $(root).css({ height: `calc(100vh - ${mobileHeaderHeight + announcementHeight}px)` });
    $(root).find('.mobile-menu__content').css({ marginBottom: `${mobileHeaderHeight + announcementHeight}px` });
    if (icon) icon.classList.add('is-active');
    toggle.setAttribute('data-show-mobile-menu', 'true');
    if (window.PXUTheme.jsAjaxCart) {
      window.PXUTheme.jsAjaxCart.hideMiniCart();
      window.PXUTheme.jsAjaxCart.hideDrawer();
    }
    var ticket = ++generation;
    pending = setTimeout(function () {
      if (ticket !== generation) return;
      pending = null;
      if (!initialized || media.matches || !visible(toggle)) { close({ restoreScroll: false, returnFocus: false }); return; }
      body.classList.add('mobile-menu--opened');
      sync();
    }, 10);
  }
  function close(options) {
    options = options || {};
    var opened = body.classList.contains('mobile-menu--opened');
    var shouldReturn = options.returnFocus !== false && owner(document.activeElement) === 'mobile' && root.contains(document.activeElement);
    cancelOpen();
    body.classList.remove('mobile-menu--opened');
    if (icon) icon.classList.remove('is-active');
    toggle.setAttribute('data-show-mobile-menu', 'false');
    sync();
    if (opened && savedScroll !== null && options.restoreScroll !== false) window.scrollTo(0, savedScroll);
    savedScroll = null;
    if (shouldReturn && !media.matches) focus(toggle);
  }
  function unload() {
    // A breakpoint cleanup must not restore a stale page position.
    close({ restoreScroll: false, returnFocus: false });
    toggle.removeEventListener('click', click);
    initialized = false;
    if (sticky) { menu.disableSticky(); sticky = false; }
  }
  function click() {
    if (pending !== null || body.classList.contains('mobile-menu--opened')) close();
    else open();
  }
  // B230: this call owns only the just-completed main-focus handoff. Measure
  // after close releases BODY layout; never reuse savedScroll or BODY offsets.
  function revealMainFocus(element, ticket, controller, mainObservation) {
    function current() {
      var search = window.PXUTheme.predictiveSearch;
      return generation === ticket && controller && menu.classicLifecycle === controller && controller.close === close && controller.root === root && initialized && !media.matches && body === document.body &&
        body.getAttribute('data-site-header-layout') === 'classic' && root.isConnected && mobile.isConnected && toggle.isConnected &&
        pending === null && !body.classList.contains('mobile-menu--opened') &&
        !body.classList.contains('klaviyo-prevent-body-scrolling') && !(search && search.mobileSearchIsOpen) &&
        !document.fullscreenElement && !document.webkitFullscreenElement && document.hasFocus() &&
        document.activeElement === element &&
        element.matches('main#template-page .klaviyo-form-KARvdB form[data-testid="klaviyo-form-KARvdB"] input[type="text"][autocomplete="given-name"]') &&
        !element.disabled && !element.closest(OTHER_OWNER) && visible(element) &&
        !Array.from(document.querySelectorAll('.fancybox-container, [role="dialog"], [role="alertdialog"], [aria-modal="true"], dialog[open]')).some(visible) && (!mainObservation || mainResizeObservationCurrent(mainObservation));
    }
    function rectangle(node) {
      var r = node.getBoundingClientRect();
      return [r.left, r.top, r.right, r.bottom, r.width, r.height].every(Number.isFinite) && r.width > 0 && r.height > 0 ? r : null;
    }
    function pinned(node) {
      for (; node && node !== body && node !== document.documentElement; node = node.parentElement) {
        if (/^(fixed|sticky)$/.test(window.getComputedStyle(node).position)) return true;
      }
      return false;
    }
    if (!current()) return;
    // The observed field wrapper includes the painted label even if the
    // provider supplies no labels collection. Never expand to the entire form.
    var group = element.closest('.klaviyo-textinput');
    if (!group || !visible(group) || group.closest('form[data-testid="klaviyo-form-KARvdB"]') !== element.closest('form[data-testid="klaviyo-form-KARvdB"]') ||
        group.querySelectorAll('input').length !== 1) return;
    var field = rectangle(element), footprint = rectangle(group);
    if (!field || !footprint) return;
    var rect = { left: Math.min(field.left, footprint.left), right: Math.max(field.right, footprint.right),
      top: Math.min(field.top, footprint.top), bottom: Math.max(field.bottom, footprint.bottom) };
    var labels = Array.from(element.labels || []);
    for (var i = 0; i < labels.length; i++) {
      if (!group.contains(labels[i]) || !visible(labels[i])) return;
      var label = rectangle(labels[i]);
      if (!label) return;
      rect.left = Math.min(rect.left, label.left); rect.right = Math.max(rect.right, label.right);
      rect.top = Math.min(rect.top, label.top); rect.bottom = Math.max(rect.bottom, label.bottom);
    }
    // A root-only correction must not enlist another scroller or pinned owner.
    var scroller = document.scrollingElement;
    if (scroller !== document.documentElement && scroller !== body) return;
    for (var node = element; node && node !== scroller; node = node.parentElement) {
      var s = window.getComputedStyle(node);
      if (node.shadowRoot || (node.localName && node.localName.indexOf('-') !== -1) ||
          /^(fixed|sticky)$/.test(s.position) ||
          (/(auto|scroll|hidden|clip)/.test(s.overflowY) && node.scrollHeight > node.clientHeight)) return;
    }
    var width = window.innerWidth, height = window.innerHeight, v = window.visualViewport;
    var left = 0, top = 0, right = width, bottom = height;
    if (v) {
      if (![v.width, v.height, v.offsetLeft, v.offsetTop].every(Number.isFinite) || v.width <= 0 || v.height <= 0) return;
      left = Math.max(left, v.offsetLeft); top = Math.max(top, v.offsetTop);
      right = Math.min(right, v.offsetLeft + v.width); bottom = Math.min(bottom, v.offsetTop + v.height);
    }
    if (![left, top, right, bottom].every(Number.isFinite) || right <= left || bottom <= top) return;
    var viewTop = top, viewBottom = bottom, style = window.getComputedStyle(element);
    var outline = style.outlineStyle !== 'none' ? Math.max(0, (parseFloat(style.outlineWidth) || 0) + (parseFloat(style.outlineOffset) || 0)) : 0;
    var gap = Math.max(8, outline + 2);
    // Retain the existing computed scroll-margin clearance (normally 80px).
    top += Math.max(gap, parseFloat(style.scrollMarginTop) || 0);
    bottom -= Math.max(gap, parseFloat(style.scrollMarginBottom) || 0);
    if (rect.left - gap < left || rect.right + gap > right) return;
    // This successor covers the captured normal-flow header only. The sticky
    // plugin caches a different announcement measurement as topSpacing; do not
    // infer that offset from live provider/header boxes or attempt its recovery.
    if (sticky || mobile.classList.contains('sticky--enabled') || pinned(mobile)) return;
    var headerBox = rectangle(mobile);
    if (!headerBox || (rect.top < headerBox.bottom + gap && rect.bottom > headerBox.top - gap)) return;
    var blockers = Array.from(document.querySelectorAll('.kl-teaser-WUte2K, #userwayAccessibilityIcon .usr'));
    for (var b = 0; b < blockers.length; b++) {
      if (!visible(blockers[b])) continue;
      var obstruction = rectangle(blockers[b]);
      if (!obstruction) return;
      if (obstruction.right <= rect.left - gap || obstruction.left >= rect.right + gap ||
          obstruction.bottom <= viewTop || obstruction.top >= viewBottom) continue;
      bottom = Math.min(bottom, obstruction.top - gap);
    }
    if (bottom - top < rect.bottom - rect.top) return;
    var delta = rect.top < top ? rect.top - top : rect.bottom > bottom ? rect.bottom - bottom : 0;
    var x = window.scrollX, y = window.scrollY;
    if (![x, y, scroller.scrollHeight, scroller.clientHeight].every(Number.isFinite)) return;
    // B251: observation-only calls share every current-owner and geometry guard
    // without scrolling. Normal handoff calls retain the original write path.
    if (mainObservation && mainObservation.measureOnly) {
      if (!current() || scroller !== document.scrollingElement || window.scrollX !== x || window.scrollY !== y) return null;
      return { element: element, group: group, form: element.closest('form[data-testid="klaviyo-form-KARvdB"]'),
        labels: labels.slice(), scroller: scroller, controller: controller, ticket: ticket,
        x: x, y: y, viewport: mainObservation.viewport, safe: delta === 0 };
    }
    // B238: round the absolute destination toward the requested reveal on the
    // reported device grid; keep strict bounds and both-edge checks below.
    // A missing or malformed DPR uses a one-CSS-pixel fallback grid.
    if (delta === 0) return;
    var scale = window.devicePixelRatio;
    if (!Number.isFinite(scale) || scale <= 0) scale = 1;
    var desired = (y + delta) * scale;
    var next = (delta > 0 ? Math.ceil(desired) : Math.floor(desired)) / scale;
    if (!Number.isFinite(next)) return;
    next = Math.max(0, Math.min(Math.max(0, scroller.scrollHeight - scroller.clientHeight), next));
    if (rect.top - (next - y) < top || rect.bottom - (next - y) > bottom || next === y) return;
    // Recheck after synchronous close listeners and layout reads. There is no
    // lease, timer, refocus, nested scroll, or later correction to revoke.
    // B283: resolve the method before live validation. A getter may deliver
    // revocation; final root reads may also replace the captured method.
    var scrollTo = window.scrollTo;
    if (typeof scrollTo !== 'function' || !current() || scroller !== document.scrollingElement || window.scrollX !== x || window.scrollY !== y || window.scrollTo !== scrollTo) return;
    // All live getters above precede this private scalar-only authority check.
    if (mainObservation && (mainObservation.epoch !== mainResizeEpoch ||
        (mainObservation.spent ? mainResizeWitness !== null : mainResizeWitness !== mainObservation.witness))) return;
    scrollTo.call(window, { left: x, top: next, behavior: 'instant' });
  }
  // B217: release only this Menu when the known embedded main given-name
  // input actually receives focus. A null Menu owner alone is not main content.
  function mainFocusHandoff(event) {
    var element = event.target;
    var search = window.PXUTheme.predictiveSearch;
    if (event.isTrusted !== true || element !== document.activeElement || !document.hasFocus() ||
        !initialized || media.matches || !root.isConnected || !mobile.isConnected || !toggle.isConnected ||
        body !== document.body || body.getAttribute('data-site-header-layout') !== 'classic' ||
        (!body.classList.contains('mobile-menu--opened') && pending === null) ||
        body.classList.contains('klaviyo-prevent-body-scrolling') || (search && search.mobileSearchIsOpen) ||
        document.fullscreenElement || document.webkitFullscreenElement ||
        !element || !element.matches || !element.matches('main#template-page .klaviyo-form-KARvdB form[data-testid="klaviyo-form-KARvdB"] input[type="text"][autocomplete="given-name"]') ||
        element.disabled || element.closest(OTHER_OWNER) || !visible(element)) return;
    // Retargeted focus and custom/shadow owners remain outside this handoff.
    if (event.composedPath && event.composedPath().some(function (node) { return node.nodeType === 11; })) return;
    for (var node = element; node && node !== body; node = node.parentElement) {
      if (node.shadowRoot || (node.localName && node.localName.indexOf('-') !== -1)) return;
    }
    // Known plugin-sticky ownership is outside this nonsticky successor.
    if (sticky || mobile.classList.contains('sticky--enabled')) return;
    var handoffGeneration = generation + 1, handoffController = menu.classicLifecycle, handoffResizeEpoch = mainResizeEpoch + 1;
    close({ restoreScroll: false, returnFocus: false });
    revealMainFocus(element, handoffGeneration, handoffController);
    seedMainResizeWitness(element, handoffGeneration, handoffController, handoffResizeEpoch);
  }
  // B251: one correction may preserve the first loaded viewport loss after a
  // verified main handoff. Ordinary focus, scrolling and resize cannot arm it.
  function clearMainResizeWitness() {
    mainResizeEpoch++;
    mainResizeWitness = null;
  }
  function mainResizeViewport() {
    var v = window.visualViewport;
    var values = [window.innerWidth, window.innerHeight, window.devicePixelRatio,
      v ? v.width : window.innerWidth, v ? v.height : window.innerHeight,
      v ? v.scale : 1, v ? v.offsetLeft : 0, v ? v.offsetTop : 0];
    if (!values.every(Number.isFinite) || values.slice(0, 6).some(function (n) { return n <= 0; })) return null;
    // B279: reuse the original finite viewport samples. Only outer dimensions
    // add reads; unavailable values disable the exception, not the old path.
    var outerWidth = null, outerHeight = null;
    try { outerWidth = window.outerWidth; outerHeight = window.outerHeight; }
    catch (b279Unavailable) { outerWidth = null; outerHeight = null; }
    return { visual: v || null, left: values[6], top: values[7], signature: values.join(':'),
      dpr: values[2], width: values[3], height: values[4], scale: values[5],
      outerWidth: outerWidth, outerHeight: outerHeight };
  }
  function mainResizeObservationCurrent(observation) {
    var witness = observation.witness;
    var matches = document.querySelectorAll('main#template-page .klaviyo-form-KARvdB form[data-testid="klaviyo-form-KARvdB"] input[type="text"][autocomplete="given-name"]');
    if (matches.length !== 1 || matches[0] !== observation.element) return false;
    if (witness) {
      var element = witness.element, labels = Array.from(element.labels || []);
      if (element.closest('.klaviyo-textinput') !== witness.group ||
          element.closest('form[data-testid="klaviyo-form-KARvdB"]') !== witness.form ||
          labels.length !== witness.labels.length || !labels.every(function (label, i) { return label === witness.labels[i]; })) return false;
    }
    // Identity/geometry reads can cause synchronous reentry. Check authority last.
    var view = mainResizeViewport();
    return view && view.visual === observation.viewport.visual && view.signature === observation.viewport.signature &&
      (!observation.zoomGrid || (view.outerWidth === observation.viewport.outerWidth && view.outerHeight === observation.viewport.outerHeight)) &&
      document.visibilityState === 'visible' && document.activeElement === observation.element && observation.scroller === document.scrollingElement &&
      window.scrollX === observation.x && window.scrollY === observation.y &&
      (observation.spent ? mainResizeWitness === null : mainResizeWitness === witness) && observation.epoch === mainResizeEpoch;
  }
  function mainResizeObservation(witness) {
    var viewport = mainResizeViewport();
    if (!viewport) return null;
    return { measureOnly: true, epoch: mainResizeEpoch, viewport: viewport,
      scroller: document.scrollingElement, x: window.scrollX, y: window.scrollY, element: witness ? witness.element : document.activeElement, witness: witness || null };
  }
  function seedMainResizeWitness(element, ticket, controller, handoffEpoch) {
    // Invoked only at the completed genuine handoff; a void reveal is not proof.
    if (handoffEpoch !== mainResizeEpoch) return;
    var observation = mainResizeObservation(null);
    if (!observation) return;
    var snapshot = revealMainFocus(element, ticket, controller, observation);
    if (snapshot && snapshot.safe && observation.epoch === handoffEpoch &&
        mainResizeObservationCurrent(observation) && handoffEpoch === mainResizeEpoch) mainResizeWitness = snapshot;
  }
  // B279 temporary experiment: one exactly predicted representation change,
  // never a nearby-scroll tolerance, observed-root rounding, or new lifetime.
  function mainResizeZoomGridMatch(witness, observation, event) {
    var before = witness.viewport, after = observation.viewport;
    try {
      // Trust was already checked by the original resize precondition.
      if (event.type !== 'resize' || event.currentTarget !== window || event.target !== window ||
          before.dpr !== 2 || after.dpr !== 2.5 || before.visual !== after.visual || !after.visual ||
          before.scale !== 1 || after.scale !== 1 || before.left !== 0 || before.top !== 0 || after.left !== 0 || after.top !== 0 ||
          ![witness.y, observation.y, before.outerWidth, before.outerHeight, after.outerWidth, after.outerHeight].every(Number.isFinite) ||
          before.outerWidth <= 0 || before.outerHeight <= 0 || before.outerWidth !== after.outerWidth || before.outerHeight !== after.outerHeight ||
          witness.y < 0 || !Number.isSafeInteger(witness.y * before.dpr) ||
          before.signature === after.signature ||
          after.width !== Math.fround(before.width * before.dpr / after.dpr) ||
          after.height !== Math.fround(before.height * before.dpr / after.dpr)) return false;
      var predicted = Math.fround(Math.round(witness.y * after.dpr) / after.dpr);
      if (!Number.isFinite(predicted) || predicted === witness.y || observation.y !== predicted) return false;
      // Actual observation x/y are untouched. Every downstream owner, geometry,
      // exact live-position and final epoch check still runs before any write.
      observation.zoomGrid = true;
      return true;
    } catch (b279Refusal) { return false; }
  }
  function resizeMainFocus(event) {
    var witness = mainResizeWitness;
    if (!witness) return;
    var observation = mainResizeObservation(witness);
    if (!event || event.isTrusted !== true || !observation || media.matches ||
        observation.scroller !== witness.scroller || observation.x !== witness.x || observation.y !== witness.y && !mainResizeZoomGridMatch(witness, observation, event) ||
        observation.viewport.visual !== witness.viewport.visual || observation.viewport.left !== witness.viewport.left ||
        observation.viewport.top !== witness.viewport.top) { clearMainResizeWitness(); return; }
    var snapshot = revealMainFocus(witness.element, witness.ticket, witness.controller, observation);
    if (!snapshot || !mainResizeObservationCurrent(observation)) { clearMainResizeWitness(); return; }
    if (snapshot.safe) {
      // Safe no-op width changes may keep the same unspent handoff lifetime.
      mainResizeWitness = snapshot;
      return;
    }
    if (observation.viewport.signature === witness.viewport.signature) { clearMainResizeWitness(); return; }
    // Spend before invoking geometry again. A refusal or failed landing is still
    // the only attempt: no resize/scroll/retab rearm and no queued retry.
    mainResizeWitness = null;
    mainResizeEpoch++;
    observation.epoch = mainResizeEpoch;
    observation.spent = true;
    observation.measureOnly = false;
    revealMainFocus(witness.element, witness.ticket, witness.controller, observation);
  }
  function forgetMainScroll() {
    // A queued notification of the handoff's own final position is harmless.
    // This is exact state comparison, never an "ignore next scroll" exemption.
    if (!mainResizeWitness || document.scrollingElement !== mainResizeWitness.scroller ||
        window.scrollX !== mainResizeWitness.x || window.scrollY !== mainResizeWitness.y) clearMainResizeWitness();
  }
  function forgetMainScrollKey(event) {
    if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'PageUp', 'PageDown', 'Home', 'End', ' ', 'Spacebar', 'Tab', 'Escape'].indexOf(event.key) !== -1) clearMainResizeWitness();
  }
  function forgetHiddenMainFocus() {
    if (document.visibilityState !== 'visible') clearMainResizeWitness();
  }
  function remember(event) {
    clearMainResizeWitness();
    var region = owner(event.target);
    lastFocus = region ? { element: event.target, region: region } : null;
    mainFocusHandoff(event);
  }
  function forgetBlur(event) {
    clearMainResizeWitness();
    if (!lastFocus || event.target !== lastFocus.element || event.relatedTarget) return;
    // Preserve only the precise resize-caused disappearance. Explicit blur of a
    // visible control must not make a later breakpoint steal unrelated focus.
    if (visible(event.target) || (lastFocus.region === 'desktop') === media.matches) lastFocus = null;
  }
  function resize(event) {
    var next = media.matches;
    if (next === desktop) { resizeMainFocus(event); return; }
    clearMainResizeWitness();
    var active = document.activeElement;
    var region = owner(active);
    var previousRegion = desktop ? 'desktop' : 'mobile';
    var lost = region === previousRegion && !visible(active);
    if (!region && (active === body || active === document.documentElement) && lastFocus &&
        lastFocus.region === previousRegion && lastFocus.element.isConnected && !visible(lastFocus.element)) lost = true;
    desktop = next;
    lastFocus = null;
    if (next) unload(); else init();
    if (!lost || !document.hasFocus()) return;
    if (!next) { focus(toggle); return; }
    var targets = header.querySelectorAll('.header__brand a[href], .header__menu-items > .navbar-item > label > a[href]');
    for (var i = 0; i < targets.length; i++) {
      if (visible(targets[i]) && !targets[i].closest(OTHER_OWNER)) { focus(targets[i]); break; }
    }
  }
  function escape(event) {
    if (event.key !== 'Escape' || event.defaultPrevented || event.repeat || event.isComposing ||
        document.fullscreenElement || document.webkitFullscreenElement ||
        owner(event.target) !== 'mobile' || (event.target !== toggle && !root.contains(event.target)) || event.target.closest(WIDGET_OWNER) || (!body.classList.contains('mobile-menu--opened') && pending === null)) return;
    if (event.composedPath && event.composedPath().some(function (node) { return node.nodeType === 11; })) return;
    event.preventDefault();
    close();
  }
  function forgetPointer(event) { clearMainResizeWitness(); if (!owner(event.target)) lastFocus = null; }
  function forgetWindow() { clearMainResizeWitness(); lastFocus = null; }
  function destroy() {
    unload();
    document.removeEventListener('focusin', remember);
    document.removeEventListener('focusout', forgetBlur);
    document.removeEventListener('pointerdown', forgetPointer, true);
    window.removeEventListener('blur', forgetWindow);
    window.removeEventListener('resize', resize);
    window.removeEventListener('scroll', forgetMainScroll, true);
    window.removeEventListener('pagehide', clearMainResizeWitness);
    document.removeEventListener('visibilitychange', forgetHiddenMainFocus);
    document.removeEventListener('wheel', clearMainResizeWitness, true);
    document.removeEventListener('touchstart', clearMainResizeWitness, true);
    document.removeEventListener('keydown', forgetMainScrollKey, true);
    if (mainResizeViewportListener) mainResizeViewportListener.removeEventListener('scroll', clearMainResizeWitness);
    if (media.removeEventListener) media.removeEventListener('change', resize);
    else if (media.removeListener) media.removeListener(resize);
    menu.classicLifecycle = null;
  }
  menu.classicLifecycle = { root: root, init: init, open: open, close: close, unload: unload, escape: escape, destroy: destroy };
  document.addEventListener('focusin', remember);
  document.addEventListener('focusout', forgetBlur);
  document.addEventListener('pointerdown', forgetPointer, true);
  window.addEventListener('blur', forgetWindow);
  // Undebounced: app.js still invokes init/unload after 250 ms; both are safe to repeat.
  window.addEventListener('resize', resize);
  window.addEventListener('scroll', forgetMainScroll, true);
  window.addEventListener('pagehide', clearMainResizeWitness);
  document.addEventListener('visibilitychange', forgetHiddenMainFocus);
  document.addEventListener('wheel', clearMainResizeWitness, { passive: true, capture: true });
  document.addEventListener('touchstart', clearMainResizeWitness, { passive: true, capture: true });
  document.addEventListener('keydown', forgetMainScrollKey, true);
  if (mainResizeViewportListener) mainResizeViewportListener.addEventListener('scroll', clearMainResizeWitness);
  if (media.addEventListener) media.addEventListener('change', resize);
  else if (media.addListener) media.addListener(resize);
  if (owner(document.activeElement)) remember({ target: document.activeElement });
};
window.PXUTheme.mobileMenu.setupClassicLifecycle();
// Bind the existing classic Menu before unrelated resources finish loading.
// Deferred theme scripts have executed by DOMContentLoaded; later init is guarded.
document.addEventListener('DOMContentLoaded', function () {
  var menu = window.PXUTheme && window.PXUTheme.mobileMenu;
  var controller = menu && menu.classicLifecycle;
  if (controller && controller.root.isConnected && window.PXUTheme.jsHeader &&
      document.body && document.body.getAttribute('data-site-header-layout') === 'classic') {
    controller.init();
  }
}, { once: true });
document.addEventListener('shopify:section:load', function () {
  window.PXUTheme.mobileMenu.setupClassicLifecycle();
});
document.addEventListener('shopify:section:unload', function (event) {
  var controller = window.PXUTheme.mobileMenu.classicLifecycle;
  if (controller && event.target.contains(controller.root)) controller.destroy();
});

/* option_selection.js */
function floatToString(t, e) {
  var o = t.toFixed(e).toString();
  return o.match(/^\.\d+/) ? "0" + o : o;
}
if ("undefined" == typeof Shopify) var Shopify = {};
Shopify.each = function (t, e) {
  for (var o = 0; o < t.length; o++) e(t[o], o);
}, Shopify.map = function (t, e) {
  for (var o = [], i = 0; i < t.length; i++) o.push(e(t[i], i));
  return o;
}, Shopify.arrayIncludes = function (t, e) {
  for (var o = 0; o < t.length; o++) if (t[o] == e) return !0;
  return !1;
}, Shopify.uniq = function (t) {
  for (var e = [], o = 0; o < t.length; o++) Shopify.arrayIncludes(e, t[o]) || e.push(t[o]);
  return e;
}, Shopify.isDefined = function (t) {
  return "undefined" == typeof t ? !1 : !0;
}, Shopify.getClass = function (t) {
  return Object.prototype.toString.call(t).slice(8, -1);
}, Shopify.extend = function (t, e) {
  function o() {}
  o.prototype = e.prototype, t.prototype = new o(), t.prototype.constructor = t, t.baseConstructor = e, t.superClass = e.prototype;
}, Shopify.locationSearch = function () {
  return window.location.search;
}, Shopify.locationHash = function () {
  return window.location.hash;
}, Shopify.replaceState = function (t) {
  window.history.replaceState({}, document.title, t);
}, Shopify.urlParam = function (t) {
  var e = RegExp("[?&]" + t + "=([^&#]*)").exec(Shopify.locationSearch());
  return e && decodeURIComponent(e[1].replace(/\+/g, " "));
}, Shopify.newState = function (t, e) {
  var o;
  return o = Shopify.urlParam(t) ? Shopify.locationSearch().replace(RegExp("(" + t + "=)[^&#]+"), "$1" + e) : "" === Shopify.locationSearch() ? "?" + t + "=" + e : Shopify.locationSearch() + "&" + t + "=" + e, o + Shopify.locationHash();
}, Shopify.setParam = function (t, e) {
  Shopify.replaceState(Shopify.newState(t, e));
}, Shopify.Product = function (t) {
  Shopify.isDefined(t) && this.update(t);
}, Shopify.Product.prototype.update = function (t) {
  for (let property in t) this[property] = t[property];
}, Shopify.Product.prototype.optionNames = function () {
  return "Array" == Shopify.getClass(this.options) ? this.options : [];
}, Shopify.Product.prototype.optionValues = function (t) {
  if (!Shopify.isDefined(this.variants)) return null;
  var e = Shopify.map(this.variants, function (e) {
    var o = "option" + (t + 1);
    return void 0 == e[o] ? null : e[o];
  });
  return null == e[0] ? null : Shopify.uniq(e);
}, Shopify.Product.prototype.getVariant = function (t) {
  var e = null;
  return t.length != this.options.length ? e : (Shopify.each(this.variants, function (o) {
    for (var i = !0, r = 0; r < t.length; r++) {
      var n = "option" + (r + 1);
      o[n] != t[r] && (i = !1);
    }
    return 1 == i ? void (e = o) : void 0;
  }), e);
}, Shopify.Product.prototype.getVariantById = function (t) {
  for (var e = 0; e < this.variants.length; e++) {
    var o = this.variants[e];
    if (t == o.id) return o;
  }
  return null;
}, Shopify.money_format = "${{amount}}", Shopify.formatMoney = function (t, e) {
  function o(t, e) {
    return "undefined" == typeof t ? e : t;
  }
  function i(t, e, i, r) {
    if (e = o(e, 2), i = o(i, ","), r = o(r, "."), isNaN(t) || null == t) return 0;
    t = (t / 100).toFixed(e);
    var n = t.split("."),
      a = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i),
      s = n[1] ? r + n[1] : "";
    return a + s;
  }
  "string" == typeof t && (t = t.replace(".", ""));
  var r = "",
    n = /\{\{\s*(\w+)\s*\}\}/,
    a = e || this.money_format;
  switch (a.match(n)[1]) {
    case "amount":
      r = i(t, 2);
      break;
    case "amount_no_decimals":
      r = i(t, 0);
      break;
    case "amount_with_space_separator":
      r = i(t, 2, " ", ",");
      break;
    case "amount_with_period_and_space_separator":
      r = i(t, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      r = i(t, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      r = i(t, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      r = i(t, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      r = i(t, 0, " ", ".");
  }
  return a.replace(n, r);
}, Shopify.OptionSelectors = function (t, e) {
  return this.selectorDivClass = "selector-wrapper", this.selectorClass = "single-option-selector", this.variantIdFieldIdSuffix = "-variant-id", this.variantIdField = null, this.historyState = null, this.selectors = [], this.domIdPrefix = t, this.product = new Shopify.Product(e.product), this.onVariantSelected = Shopify.isDefined(e.onVariantSelected) ? e.onVariantSelected : function () {}, this.replaceSelector(t), this.initDropdown(), e.enableHistoryState && (this.historyState = new Shopify.OptionSelectors.HistoryState(this)), !0;
}, Shopify.OptionSelectors.prototype.initDropdown = function () {
  var t = {
      initialLoad: !0
    },
    e = this.selectVariantFromDropdown(t);
  if (!e) {
    var o = this;
    setTimeout(function () {
      o.selectVariantFromParams(t) || o.fireOnChangeForFirstDropdown.call(o, t);
    });
  }
}, Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function (t) {
  this.selectors[0].element.onchange(t);
}, Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function (t) {
  var e = this.selectVariantFromParams(t);
  e || this.selectVariantFromDropdown(t);
}, Shopify.OptionSelectors.prototype.replaceSelector = function (t) {
  var e = document.getElementById(t),
    o = e.parentNode;
  Shopify.each(this.buildSelectors(), function (t) {
    o.insertBefore(t, e);
  }), e.style.display = "none", this.variantIdField = e;
}, Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function (t) {
  var e = document.getElementById(this.domIdPrefix).querySelector("[selected]");
  if (e || (e = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')), !e) return !1;
  var o = e.value;
  return this.selectVariant(o, t);
}, Shopify.OptionSelectors.prototype.selectVariantFromParams = function (t) {
  var e = Shopify.urlParam("variant");
  return this.selectVariant(e, t);
}, Shopify.OptionSelectors.prototype.selectVariant = function (t, e) {
  var o = this.product.getVariantById(t);
  if (null == o) return !1;
  for (var i = 0; i < this.selectors.length; i++) {
    var r = this.selectors[i].element,
      n = r.getAttribute("data-option"),
      a = o[n];
    null != a && this.optionExistInSelect(r, a) && (r.value = a);
  }
  return "undefined" != typeof jQuery ? jQuery(this.selectors[0].element).trigger("change", e) : this.selectors[0].element.onchange(e), !0;
}, Shopify.OptionSelectors.prototype.optionExistInSelect = function (t, e) {
  for (var o = 0; o < t.options.length; o++) if (t.options[o].value == e) return !0;
}, Shopify.OptionSelectors.prototype.insertSelectors = function (t, e) {
  Shopify.isDefined(e) && this.setMessageElement(e), this.domIdPrefix = "product-" + this.product.id + "-variant-selector";
  var o = document.getElementById(t);
  Shopify.each(this.buildSelectors(), function (t) {
    o.appendChild(t);
  });
}, Shopify.OptionSelectors.prototype.buildSelectors = function () {
  for (var t = 0; t < this.product.optionNames().length; t++) {
    var e = new Shopify.SingleOptionSelector(this, t, this.product.optionNames()[t], this.product.optionValues(t));
    e.element.disabled = !1, this.selectors.push(e);
  }
  var o = this.selectorDivClass,
    i = this.product.optionNames(),
    r = Shopify.map(this.selectors, function (t) {
      var e = document.createElement("div");
      if (e.setAttribute("class", o), i.length > 1) {
        var r = document.createElement("label");
        r.htmlFor = t.element.id, r.innerHTML = t.name, e.appendChild(r);
      }
      return e.appendChild(t.element), e;
    });
  return r;
}, Shopify.OptionSelectors.prototype.selectedValues = function () {
  for (var t = [], e = 0; e < this.selectors.length; e++) {
    var o = this.selectors[e].element.value;
    t.push(o);
  }
  return t;
}, Shopify.OptionSelectors.prototype.updateSelectors = function (t, e) {
  var o = this.selectedValues(),
    i = this.product.getVariant(o);
  i ? (this.variantIdField.disabled = !1, this.variantIdField.value = i.id) : this.variantIdField.disabled = !0, this.onVariantSelected(i, this, e), null != this.historyState && this.historyState.onVariantChange(i, this, e);
}, Shopify.OptionSelectorsFromDOM = function (t, e) {
  var o = e.optionNames || [],
    i = e.priceFieldExists || !0,
    r = e.delimiter || "/",
    n = this.createProductFromSelector(t, o, i, r);
  e.product = n, Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, t, e);
}, Shopify.extend(Shopify.OptionSelectorsFromDOM, Shopify.OptionSelectors), Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function (t, e, o, i) {
  if (!Shopify.isDefined(o)) var o = !0;
  if (!Shopify.isDefined(i)) var i = "/";
  var r = document.getElementById(t),
    n = r.childNodes,
    a = (r.parentNode, e.length),
    s = [];
  Shopify.each(n, function (t, r) {
    if (1 == t.nodeType && "option" == t.tagName.toLowerCase()) {
      var n = t.innerHTML.split(new RegExp("\\s*\\" + i + "\\s*"));
      0 == e.length && (a = n.length - (o ? 1 : 0));
      var p = n.slice(0, a),
        l = o ? n[a] : "",
        c = (t.getAttribute("value"), {
          available: t.disabled ? !1 : !0,
          id: parseFloat(t.value),
          price: l,
          option1: p[0],
          option2: p[1],
          option3: p[2]
        });
      s.push(c);
    }
  });
  var p = {
    variants: s
  };
  if (0 == e.length) {
    p.options = [];
    for (var l = 0; a > l; l++) p.options[l] = "option " + (l + 1);
  } else p.options = e;
  return p;
}, Shopify.SingleOptionSelector = function (t, e, o, i) {
  this.multiSelector = t, this.values = i, this.index = e, this.name = o, this.element = document.createElement("select");
  for (var r = 0; r < i.length; r++) {
    var n = document.createElement("option");
    n.value = i[r], n.innerHTML = i[r], this.element.appendChild(n);
  }
  return this.element.setAttribute("class", this.multiSelector.selectorClass), this.element.setAttribute("data-option", "option" + (e + 1)), this.element.id = t.domIdPrefix + "-option-" + e, this.element.onchange = function (o, i) {
    i = i || {}, t.updateSelectors(e, i);
  }, !0;
}, Shopify.Image = {
  preload: function (t, e) {
    for (var o = 0; o < t.length; o++) {
      var i = t[o];
      this.loadImage(this.getSizedImageUrl(i, e));
    }
  },
  loadImage: function (t) {
    new Image().src = t;
  },
  switchImage: function (t, e, o) {
    if (t && e) {
      var i = this.imageSize(e.src),
        r = this.getSizedImageUrl(t.src, i);
      o ? o(r, t, e) : e.src = r;
    }
  },
  imageSize: function (t) {
    var e = t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);
    return null != e ? e[1] : null;
  },
  getSizedImageUrl: function (t, e) {
    if (null == e) return t;
    if ("master" == e) return this.removeProtocol(t);
    var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
    if (null != o) {
      var i = t.split(o[0]),
        r = o[0];
      return this.removeProtocol(i[0] + "_" + e + r);
    }
    return null;
  },
  removeProtocol: function (t) {
    return t.replace(/http(s)?:/, "");
  }
}, Shopify.OptionSelectors.HistoryState = function (t) {
  this.browserSupports() && this.register(t);
}, Shopify.OptionSelectors.HistoryState.prototype.register = function (t) {
  window.addEventListener("popstate", function (e) {
    t.selectVariantFromParamsOrDropdown({
      popStateCall: !0
    });
  });
}, Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function (t, e, o) {
  this.browserSupports() && (!t || o.initialLoad || o.popStateCall || Shopify.setParam("variant", t.id));
}, Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function () {
  return window.history && window.history.replaceState;
};

/*============================================================================
Product media controls
==============================================================================*/

window.PXUTheme.productMedia = {
  models: [],
  setupMedia: function () {
    const config = {
      // Default control list
      controls: ['zoom-in', 'zoom-out', 'fullscreen'],
      focusOnPlay: false
    };
    $('model-viewer').each(function (index, model) {
      model = new Shopify.ModelViewerUI(model, config);
      window.PXUTheme.productMedia.models.push(model);
    });
    $('.product-gallery__model model-viewer').on('mousedown', function () {
      window.PXUTheme.productMedia.hideModelIcon(this);
    });
  },
  showModelIcon: function (slide) {
    $(slide).find('.button--poster, .model-icon-button-control').show();
  },
  hideModelIcon: function (slide) {
    $(slide).find('.button--poster, .model-icon-button-control').hide();
  }
};
window.PXUTheme.productReviews = {
  init: function () {
    if ($('#shopify-product-reviews').length || $('.shopify-product-reviews-badge').length) {
      SPR.$(document).ready(function () {
        return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges();
      });
    }
  },
  productReviewScroll: function () {
    if ($('#shopify-product-reviews').length && $('.shopify-product-reviews-badge').length) {
      $('.spr-badge-container').on('click', function () {
        window.PXUTheme.scrollToTop('#shopify-product-reviews');
      });
    }
  },
  unload: function () {
    $('.spr-badge-container').off();
  }
};
window.PXUTheme.quantityBox = {
  cartEnterCaptureHandler: null,
  init: function () {
    if (!window.PXUTheme.quantityBox.cartEnterCaptureHandler) {
      window.PXUTheme.quantityBox.cartEnterCaptureHandler = function (e) {
        const isEnter = e.key === 'Enter' || e.keyCode === 13;
        if (!isEnter || !e.target) {
          return;
        }
        const $target = $(e.target);
        const isCartQuantityInput = $target.hasClass('quantity-input') &&
          $target.parents('[data-line-item]').length > 0;
        if (!isCartQuantityInput) {
          return;
        }
        e.preventDefault();
        window.PXUTheme.quantityBox.commitCartInputQuantity($target);
      };
      document.addEventListener('keydown', window.PXUTheme.quantityBox.cartEnterCaptureHandler, true);
    }
    $('body').on('click', '[data-update-quantity]:not([disabled])', function () {
      window.PXUTheme.quantityBox.updateQuantity($(this));
    });
    $('body').on('keyup keydown change', '.quantity-input', function (e) {
      window.PXUTheme.quantityBox.handleQuantityInputEvent(e, $(this));
    });
  },
  handleQuantityInputEvent: function (e, $input) {
    const isCartInput = $input.parents('[data-line-item]').length > 0;
    if (!isCartInput) {
      window.PXUTheme.quantityBox.updateQuantity($input);
      return;
    }

    if (e.type !== 'change') {
      return;
    }
    window.PXUTheme.quantityBox.commitCartInputQuantity($input);
  },
  commitCartInputQuantity: function ($input) {
    const quantity = String($input.val());
    if ($input.data('lastCommittedQuantity') === quantity) {
      return false;
    }
    $input.data('lastCommittedQuantity', quantity);
    window.PXUTheme.quantityBox.updateQuantity($input);
    $input.data('lastCommittedQuantity', String($input.val()));
    return true;
  },
  moveFocusBeforeQuantityControlDisable: function ($control, $input, willDisable) {
    if (willDisable && $control.is(':focus')) {
      $input.trigger('focus');
    }
  },
  updateQuantityControls: function ($el) {
    const $quantityBox = $el.parents('.product-quantity-box');
    const $input = $('.quantity-input', $quantityBox);
    let val = parseInt($input.val());
    let valMax = 100000000000000000;
    if ($input.attr('max') != null) {
      valMax = $input.attr('max');
    }
    if (val === 1 || val === 0) {
      $('.quantity-minus', $quantityBox).attr('disabled', true);
      $('.quantity-plus', $quantityBox).attr('disabled', false);
    } else if (val >= valMax) {
      $('.quantity-plus', $quantityBox).attr('disabled', true);
      $('.quantity-minus', $quantityBox).attr('disabled', false);
      $input.val(valMax);
    } else {
      $('.quantity-minus', $quantityBox).attr('disabled', false);
      $('.quantity-plus', $quantityBox).attr('disabled', false);
    }
  },
  updateQuantity: function ($el) {
    const $quantityBox = $el.parents('.product-quantity-box');
    const $input = $('.quantity-input', $quantityBox);
    const lineID = $quantityBox.parents('[data-line-item]').data('line-item');
    const focusTarget = $el.hasClass('quantity-input') ? 'input' : $el.data('update-quantity') || 'input';
    const isCartInput = $el.parents('[data-line-item]').length > 0;
    const renderedQuantity = parseInt($input.prop('defaultValue'));
    const rawInputValue = String($input.val()).trim();
    const numericCartValue = Number(rawInputValue);
    const validCartInteger = rawInputValue !== '' &&
      /^[+-]?\d+$/.test(rawInputValue) &&
      Number.isFinite(numericCartValue) &&
      Number.isInteger(numericCartValue);
    let val = isCartInput ? numericCartValue : parseInt(rawInputValue);
    let valMax = 100000000000000000;
    let valMin = parseInt($input.attr('min')) || 0;
    let correctionMessage = '';
    if ($input.attr('max') != null) {
      valMax = parseInt($input.attr('max'));
    }
    const previousCartQuantity = Number.isNaN(renderedQuantity)
      ? Number.isNaN(val) ? valMin : val
      : renderedQuantity;
    if (isCartInput && !validCartInteger) {
      val = Math.min(Math.max(previousCartQuantity, valMin), valMax);
      $input.val(val);
      correctionMessage = `Invalid quantity. Quantity changed to ${val}.`;
    } else if (val < valMin) {
      val = valMin;
      $input.val(valMin);
      correctionMessage = `Minimum quantity is ${valMin}. Quantity changed to ${valMin}.`;
      if (!isCartInput) {
        return false;
      }
    } else if (val > valMax) {
      val = valMax;
      $input.val(valMax);
      correctionMessage = `Maximum quantity is ${valMax}. Quantity changed to ${valMax}.`;
      if (!isCartInput) {
        return false;
      }
    }
    if ($el.data('update-quantity') === 'plus') {
      // Increase quantity input by one
      if (val < valMax) {
        val++;
        $input.val(val);
      }
    } else if ($el.data('update-quantity') === 'minus') {
      // Decrease quantity by one
      if (val > valMin) {
        val--;
        $input.val(val);
      }
    }

    // Update quantity if within cart (vs on the product page)
    if (isCartInput) {
      const lineID = $quantityBox.data('line-item-key');
      window.PXUTheme.quantityBox.updateCart(
        lineID,
        val,
        focusTarget,
        previousCartQuantity,
        correctionMessage
      );
    }

    // Keep focus on an available control before disabling the active control.
    const updateDirection = $el.data('update-quantity');
    const controlWillBeDisabled = (updateDirection === 'minus' && val <= valMin) ||
      (updateDirection === 'plus' && val >= valMax);
    window.PXUTheme.quantityBox.moveFocusBeforeQuantityControlDisable($el, $input, controlWillBeDisabled);

    // Call to update quantity controls
    window.PXUTheme.quantityBox.updateQuantityControls($el);
  },
  ensureCartStatus: function () {
    let $status = $('#cart-quantity-status');
    if (!$status.length) {
      $('body').append('<p id="cart-quantity-status" class="is-sr-only" role="status" aria-live="polite" aria-atomic="true"></p>');
      $status = $('#cart-quantity-status');
    }
    return $status;
  },
  formatCartSubtotal: function (totalPrice) {
    const moneyFormat = $('body').attr('data-money-format') || Shopify.money_format;
    return Shopify.formatMoney(totalPrice, moneyFormat).replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
  },
  setCartStatus: function (message) {
    const $status = window.PXUTheme.quantityBox.ensureCartStatus();
    window.clearTimeout(window.PXUTheme.quantityBox.cartStatusTimer);
    $status.text('');
    window.PXUTheme.quantityBox.cartStatusTimer = window.setTimeout(function () {
      $status.text(message);
    }, 50);
  },
  announceCartUpdate: function (cart, lineItem, requestedQuantity, correctionMessage) {
    const actualQuantity = lineItem && typeof lineItem.quantity !== 'undefined' ? lineItem.quantity : requestedQuantity;
    const productTitle = lineItem && (lineItem.title || lineItem.product_title) ? lineItem.title || lineItem.product_title : 'Item';
    const subtotal = window.PXUTheme.quantityBox.formatCartSubtotal(cart.total_price);
    const stockCapped = Number(requestedQuantity) > Number(actualQuantity);
    const resultMessage = stockCapped
      ? `${productTitle} quantity limited to ${actualQuantity} based on available stock. Cart subtotal ${subtotal}.`
      : `${productTitle} quantity ${actualQuantity}. Cart subtotal ${subtotal}.`;
    const message = correctionMessage && !stockCapped
      ? `${correctionMessage} ${resultMessage}`
      : resultMessage;
    window.PXUTheme.quantityBox.setCartStatus(message);
  },
  restoreCartQuantityFocus: function (lineID, focusTarget) {
    window.setTimeout(function () {
      const $quantityBox = $(`[data-line-item="${lineID}"]`).find('.product-quantity-box').first();
      const targetSelector = focusTarget === 'plus'
        ? '.quantity-plus'
        : focusTarget === 'minus'
          ? '.quantity-minus'
          : '.quantity-input';
      let $focusTarget = $quantityBox.find(targetSelector).first();

      if (!$focusTarget.length || $focusTarget.is('[disabled]')) {
        $focusTarget = $quantityBox.find('.quantity-input').first();
      }
      if ($focusTarget.length) {
        if (!$focusTarget.is('button, input, select, textarea, a[href], [tabindex]')) {
          $focusTarget.attr('tabindex', '-1');
        }
        $focusTarget.trigger('focus');
      }
    }, 0);
  },
  cartUpdateQueues: {},
  updateCart: function (lineID, quantity, focusTarget, previousQuantity, correctionMessage) {
    window.PXUTheme.quantityBox.ensureCartStatus();
    $('.quantity-warning').removeClass('animated bounceIn');
    const request = {
      quantity: quantity,
      focusTarget: focusTarget,
      correctionMessage: correctionMessage || ''
    };
    let queue = window.PXUTheme.quantityBox.cartUpdateQueues[lineID];
    if (!queue) {
      const confirmedQuantity = Number(previousQuantity);
      queue = {
        active: false,
        confirmedQuantity: Number.isFinite(confirmedQuantity) ? confirmedQuantity : Number(quantity),
        pending: null
      };
      window.PXUTheme.quantityBox.cartUpdateQueues[lineID] = queue;
    }
    if (queue.active) {
      queue.pending = request;
      return;
    }
    window.PXUTheme.quantityBox.performCartUpdate(lineID, request, queue);
  },
  continueCartUpdateQueue: function (lineID, queue) {
    queue.active = false;
    if (queue.pending) {
      const nextRequest = queue.pending;
      queue.pending = null;
      window.PXUTheme.quantityBox.performCartUpdate(lineID, nextRequest, queue);
      return true;
    }
    delete window.PXUTheme.quantityBox.cartUpdateQueues[lineID];
    return false;
  },
  resyncCartAfterUpdateError: function (lineID, request, queue, message) {
    const providerMessage = /[.!?]$/.test(message) ? message : `${message}.`;
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      cache: false,
      dataType: 'json',
      success: function (cart) {
        const updatedLineItem = cart.items[lineID - 1] || null;
        const actualLineQuantity = updatedLineItem ? Number(updatedLineItem.quantity) : 0;
        const productTitle = updatedLineItem && (updatedLineItem.title || updatedLineItem.product_title)
          ? updatedLineItem.title || updatedLineItem.product_title
          : 'Item';
        const subtotal = window.PXUTheme.quantityBox.formatCartSubtotal(cart.total_price);
        const visibleMessage = `${providerMessage} Actual quantity is ${actualLineQuantity}. Cart subtotal ${subtotal}.`;
        const statusMessage = `Cart quantity update reported an issue. ${providerMessage} ${productTitle} quantity ${actualLineQuantity}. Cart subtotal ${subtotal}.`;
        const stockCapped = Number(request.quantity) > actualLineQuantity;
        const hasPendingUpdate = Boolean(queue.pending);

        $('.cart__form').data('currentDiscount', cart.total_discount);
        if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
          window.PXUTheme.jsAjaxCart.updateView();
        }
        if (window.PXUTheme.jsCart) {
          window.PXUTheme.jsCart.updateView(cart, lineID);
        }

        const $updatedLine = $(`[data-line-item="${lineID}"]`);
        const $updatedQuantityBox = $updatedLine.find('.product-quantity-box').first();
        const $updatedInput = $updatedQuantityBox.find('.quantity-input').first();
        const $quantityWarning = $updatedLine.find('.quantity-warning').first();
        $quantityWarning.text(visibleMessage).addClass('animated bounceIn');
        if ($updatedInput.length) {
          $updatedInput.removeData('lastCommittedQuantity');
          window.PXUTheme.quantityBox.updateQuantityControls($updatedInput);
        }
        if (stockCapped) {
          const $updatedPlus = $updatedQuantityBox.find('.quantity-plus').first();
          window.PXUTheme.quantityBox.moveFocusBeforeQuantityControlDisable(
            $updatedPlus,
            $updatedInput,
            request.focusTarget === 'plus'
          );
          $updatedPlus.attr('disabled', true);
        }

        queue.confirmedQuantity = actualLineQuantity;
        window.PXUTheme.quantityBox.setCartStatus(statusMessage);
        if (hasPendingUpdate) {
          $updatedInput.trigger('focus');
          window.PXUTheme.quantityBox.continueCartUpdateQueue(lineID, queue);
          return;
        }
        window.PXUTheme.quantityBox.restoreCartQuantityFocus(lineID, request.focusTarget);
        window.PXUTheme.quantityBox.continueCartUpdateQueue(lineID, queue);
      },
      error: function () {
        const $line = $(`[data-line-item="${lineID}"]`);
        const $input = $line.find('.quantity-input').first();
        const restoredQuantity = Number(queue.confirmedQuantity);
        const recoveryFocusTarget = queue.pending ? queue.pending.focusTarget : request.focusTarget;
        const pendingMessage = queue.pending ? ' Pending quantity changes were not sent.' : '';
        let restoredMessage = '';
        if (Number.isFinite(restoredQuantity)) {
          $input.val(restoredQuantity).prop('defaultValue', restoredQuantity);
          window.PXUTheme.quantityBox.updateQuantityControls($input);
          restoredMessage = ` Displayed quantity restored to ${restoredQuantity} temporarily.`;
        }
        const recoveryMessage = `${providerMessage} Cart status could not be confirmed.${restoredMessage}${pendingMessage} Reload the cart before trying again.`;
        $line.find('.quantity-warning').first().text(`Quantity update could not be confirmed. ${recoveryMessage}`).addClass('animated bounceIn');
        $input.removeData('lastCommittedQuantity');
        window.PXUTheme.quantityBox.restoreCartQuantityFocus(lineID, recoveryFocusTarget);
        window.PXUTheme.quantityBox.setCartStatus(`Cart quantity update could not be confirmed. ${recoveryMessage}`);
        queue.pending = null;
        window.PXUTheme.quantityBox.continueCartUpdateQueue(lineID, queue);
      }
    });
  },
  performCartUpdate: function (lineID, request, queue) {
    const quantity = request.quantity;
    const focusTarget = request.focusTarget;
    const correctionMessage = request.correctionMessage;
    queue.active = true;
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: `quantity=${quantity}&line=${lineID}`,
      dataType: 'json',
      success: function (cart) {
        let newQuantity = 0;
        let updatedLineItem = null;
        let itemsLeftText = '';
        let warningText = '';
        const $currentDiscount = $('.cart__form').data('currentDiscount');

        //check to see if there are correct amount of products in array
        const cartItemsLineID = lineID - 1;
        if (typeof cart.items[cartItemsLineID] !== "undefined") {
          updatedLineItem = cart.items[cartItemsLineID];
          newQuantity = updatedLineItem.quantity;
        }
        if (updatedLineItem) {
          for (let i = 0; i < cart.items.length; i++) {
            if (i != cartItemsLineID) {
              if (cart.items[i].id == updatedLineItem.id) {
                newQuantity += cart.items[i].quantity;
              }
            }
          }
        }
        const actualLineQuantity = updatedLineItem ? updatedLineItem.quantity : quantity;
        const stockCapped = Number(quantity) > Number(actualLineQuantity);
        if (stockCapped) {
          warningText = `Only ${actualLineQuantity} available. Quantity changed to ${actualLineQuantity}.`;
        } else if (correctionMessage) {
          warningText = correctionMessage;
        } else if (quantity > 0 && quantity != newQuantity) {
          //Check if total discount has changed
          if (cart.total_discount <= $currentDiscount) {
            if (newQuantity == 1) {
              itemsLeftText = window.PXUTheme.translation.product_count_one;
            } else {
              itemsLeftText = window.PXUTheme.translation.product_count_other;
            }
            warningText = `${newQuantity} ${itemsLeftText}`;
          }
        }

        //Update total discount value
        $('.cart__form').data('currentDiscount', cart.total_discount);

        if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
          window.PXUTheme.jsAjaxCart.updateView();
        }
        if (window.PXUTheme.jsCart) {
          window.PXUTheme.jsCart.updateView(cart, lineID);
        }
        const $updatedLine = $(`[data-line-item="${lineID}"]`);
        const $updatedQuantityBox = $updatedLine.find('.product-quantity-box').first();
        const $updatedInput = $updatedQuantityBox.find('.quantity-input').first();
        const $quantityWarning = $updatedLine.find('.quantity-warning').first();
        const hasPendingUpdate = Boolean(queue.pending);

        $quantityWarning.text('');
        if (warningText && !hasPendingUpdate) {
          $quantityWarning.text(warningText).addClass('animated bounceIn');
        }
        if ($updatedInput.length) {
          window.PXUTheme.quantityBox.updateQuantityControls($updatedInput);
        }
        if (stockCapped) {
          const $updatedPlus = $updatedQuantityBox.find('.quantity-plus').first();
          window.PXUTheme.quantityBox.moveFocusBeforeQuantityControlDisable(
            $updatedPlus,
            $updatedInput,
            focusTarget === 'plus'
          );
          $updatedPlus.attr('disabled', true);
        }
        queue.confirmedQuantity = Number(actualLineQuantity);
        if (hasPendingUpdate) {
          $updatedInput.trigger('focus');
          window.PXUTheme.quantityBox.continueCartUpdateQueue(lineID, queue);
          return;
        }
        window.PXUTheme.quantityBox.restoreCartQuantityFocus(lineID, focusTarget);
        window.PXUTheme.quantityBox.announceCartUpdate(cart, updatedLineItem, quantity, correctionMessage);
        window.PXUTheme.quantityBox.continueCartUpdateQueue(lineID, queue);
      },
      error: function (XMLHttpRequest, textStatus) {
        let response = XMLHttpRequest.responseJSON;
        if (!response && XMLHttpRequest.responseText) {
          try {
            response = JSON.parse(XMLHttpRequest.responseText);
          } catch (error) {
            response = null;
          }
        }
        const message = response && (response.description || response.message)
          ? response.description || response.message
          : 'We could not update this quantity. Try again.';
        window.PXUTheme.quantityBox.resyncCartAfterUpdateError(lineID, request, queue, message);
      }
    });
  },
  unload: function ($target) {
    $('.quantity-input').off();
    $('[data-update-quantity]').off();
  }
};
window.PXUTheme.queryParameters = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      window.PXUTheme.queryParameters[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}
window.PXUTheme.responsiveVideo = {
  init: function () {
    // Find youtube iframes
    var $videoIframes = $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]');

    // For each iframe, if parent is a responsive video wrapper do nothing
    // If no parent responsive video wrapper, then wrap iframe in responsive video wrapper

    $videoIframes.each(function (index, iframe) {
      // Update selector
      var $iframe = $(iframe);
      if (!$iframe.parents('.plyr__video-wrapper').length && !$iframe.parents('.lazyframe').length) {
        $iframe.wrap('<div class="lazyframe" data-ratio="16:9"></div>');
      }
    });
  }
};
function selectCallback(productEl, product, variant, state) {
  const $product = $(productEl);
  const $notifyForm = $('.product__notify-form', $product);
  const $productForm = $('.product_form, .shopify-product-form', $product);
  const variantInventory = $productForm.data('variant-inventory');
  const $productFormInput = $productForm.find('.quantity-input');
  const $notifyFormInputs = $('.notify_form__inputs');
  const notifyEmail = window.PXUTheme.translation.notify_form_email;
  const notifyEmailValue = window.PXUTheme.translation.contact_email;
  const notifySend = window.PXUTheme.translation.notify_form_send;
  const notifyUrl = $notifyFormInputs.data('url');
  let notifyMessage = '';
  let notifyEmailInput = '';
  if (variant) {
    if (variant.title != null) {
      // Escape variant titles
      const variantTitle = variant.title.toLowerCase() === 'default title' ? variant.name.replace(/"/g, '&quot;') : variant.title.replace(/"/g, '&quot;');
      notifyMessage = `${window.PXUTheme.translation.email_content}${variantTitle} | ${notifyUrl}?variant=${variant.id}`;
    }
  } else {
    notifyMessage = `${window.PXUTheme.translation.email_content} | ${notifyUrl}`;
  }
  if ($notifyFormInputs.hasClass('customer--true')) {
    notifyEmailInput = `<input required type="email" class="notify_email input" name="contact[email]" id="contact[email]" aria-label="${notifyEmail}" autocomplete="email" placeholder="${notifyEmail}" value="${window.PXUTheme.translation.customer_email}" />`;
  } else {
    notifyEmailInput = `<input required type="email" class="notify_email input" name="contact[email]" id="contact[email]" aria-label="${notifyEmail}" autocomplete="email" placeholder="${notifyEmail}" value="${notifyEmailValue}" />`;
  }
  const notifyFormHTML = `
    <input type="hidden" name="challenge" value="false" />
    <input type="hidden" name="contact[body]" class="notify_form_message" data-body="${notifyMessage}" value="${notifyMessage}" />
    <div class="field has-addons">
      <div class="control">
        ${notifyEmailInput}
      </div>
      <div class="control">
        <input class="action_button button" type="submit" value="${notifySend}" />
      </div>
    </div>`;

  // Image Variant feature
  if (variant && variant.featured_image && $product.is(':visible')) {
    const $sliders = $('.product-gallery__main, .js-gallery-modal', $product);
    $sliders.each((_index, value) => {
      const $slider = $(value);
      const $sliderInstance = $slider.data('flickity');
      const index = $(`img[data-image-id=${variant.featured_media.id}]`).data('index');
      if ($slider.is(':visible') && $sliderInstance !== undefined) {
        $sliderInstance.select(index, false, true);
      }
    });
  }

  // Emits custom event
  const $selectDropdown = $productForm.find('[data-variant-selector]');
  $selectDropdown.trigger('selectedVariantChanged');
  $('.cart-warning', $product).text('');
  if (variant) {
    $('.sku', $product).text(variant.sku);
    $('.notify_form_message', $product).attr('value', `${$('.notify_form_message', $product).data('body')} - ${variant.title}`);
  }
  if (variant && variant.available) {
    const variantWithInventory = {
      ...variant,
      ...(variantInventory ? variantInventory.find(v => v.id === variant.id) || {} : {})
    };
    if (variantWithInventory.inventory_management && variantWithInventory.inventory_quantity > 0) {
      if (window.PXUTheme.theme_settings.display_inventory_left) {
        let itemsLeftText = window.PXUTheme.translation.product_count_other;
        if (variantWithInventory.inventory_quantity === 1) {
          itemsLeftText = window.PXUTheme.translation.product_count_one;
        }
        const inventoryThreshold = window.PXUTheme.theme_settings.inventory_threshold;
        if (variantWithInventory.inventory_quantity <= inventoryThreshold) {
          $('.items_left', $product).html(`${variantWithInventory.inventory_quantity} ${itemsLeftText}`);
        } else {
          $('.items_left', $product).html('');
        }
      }
      if (variantWithInventory.inventory_policy === 'deny') {
        $('[data-max-inventory-management]', $product).attr('max', variantWithInventory.inventory_quantity);

        // Check to see if quantity selector should be disabled based on inventory remaining
        window.PXUTheme.quantityBox.updateQuantityControls($productFormInput);
      }
    } else {
      $('.items_left', $product).text('');
      $('[data-max-inventory-management]', $product).removeAttr('max');
    }
    $('.sold_out', $product).text('');
    $('[data-add-to-cart-trigger]', $product).removeClass('disabled').removeAttr('disabled').attr('data-options-unselected', null).find('span:not(.icon)').text($('[data-add-to-cart-trigger]', $product).data('label'));

    // Initialize shopify payment buttons
    if (Shopify.PaymentButton) {
      Shopify.PaymentButton.init();
    }
    $('.shopify-payment-button', $product).show();
    $('.purchase-details__quantity', $product).show();
    $notifyForm.hide();
    $notifyFormInputs.empty();
    $notifyFormInputs.append(notifyFormHTML);
    if (window.PXUTheme.currencyConverter) {
      window.PXUTheme.currencyConverter.convertCurrencies();
    }
  } else {
    // No purchasable variant. Three contexts:
    // - a variant is selected but sold out -> "Sold out"
    // - options are not fully selected yet (e.g. auto-select disabled) -> prompt to choose
    // - a complete selection maps to no available variant -> "Unavailable"
    const notSelected = !variant && state === 'not-selected';
    let message;
    if (variant) {
      message = window.PXUTheme.translation.soldOut;
    } else if (notSelected) {
      message = window.PXUTheme.translation.select_variant;
    } else {
      message = window.PXUTheme.translation.unavailable;
    }
    $('.items_left', $product).text('');
    $('[data-max-inventory-management]', $product).removeAttr('max');
    // Don't surface a sold-out style notice when the shopper simply hasn't chosen options yet.
    if (!notSelected) $('.sold_out', $product).text(message);
    $('[data-add-to-cart-trigger]', $product).addClass('disabled').attr('disabled', 'disabled').attr('data-options-unselected', notSelected ? 'true' : null).find('span:not(.icon)').text(message);
    $('.shopify-payment-button', $product).hide();
    $('.purchase-details__quantity', $product).hide();
    $notifyForm.hide();
    $notifyFormInputs.empty();
    if (variant && !variant.available) {
      $notifyForm.fadeIn();
      $notifyFormInputs.empty();
      $notifyFormInputs.append(notifyFormHTML);
    }
  }
}
window.selectCallback = selectCallback;

/* eslint-disable */
window.PXUTheme.predictiveSearch = {
  vars: {
    term: '',
    searchResourceType: null
  },
  resultStates: new WeakMap(),
  mobileSearchFocusTimer: null,
  mobileSearchFocusGeneration: null,
  mobileSearchIsOpen: false,
  mobileSearchLastTouchAt: 0,
  mobileSearchLastTouchTarget: null,
  mobileSearchBodyWidth: null,
  init: function () {
    if (this.setupClassicMobileSearch) this.setupClassicMobileSearch();
    this.unload();
    if (this.classicMobileSearch) this.classicMobileSearch.resume();
    $('[data-show-search-trigger], [data-autocomplete-true] input')
      .off('.pxuMobileSearchOpen')
      .on('click.pxuMobileSearchOpen touchstart.pxuMobileSearchOpen', function (e) {
        if (!isScreenSizeLarge()) {
          e.stopPropagation();

          const predictiveSearch = window.PXUTheme.predictiveSearch;
          const eventTime = Date.now();

          if (e.type === 'touchstart') {
            predictiveSearch.mobileSearchLastTouchAt = eventTime;
            predictiveSearch.mobileSearchLastTouchTarget = e.currentTarget;
          } else if (e.type === 'click') {
            const isCompatibilityClick = predictiveSearch.mobileSearchLastTouchTarget === e.currentTarget &&
              eventTime - predictiveSearch.mobileSearchLastTouchAt <= 750;
            predictiveSearch.mobileSearchLastTouchAt = 0;
            predictiveSearch.mobileSearchLastTouchTarget = null;

            if (isCompatibilityClick) {
              return;
            }
          }

          if (predictiveSearch.mobileSearchIsOpen) {
            return;
          }

          predictiveSearch.mobileSearchFocusGeneration = window.PXUTheme.jsHeader.captureSearchReturnFocus(e.currentTarget);
          const formType = $(this).closest('form').find('[name="type"]').val();
          predictiveSearch.showMobileSearch(formType);
        }
      });
    $('.search-form .search__fields input[type="text"], .search-form .field input[type="text"]').on('focus', e => {
      const dataSearchResourceType = e.target.closest('[data-search-resource-type]');
      if (dataSearchResourceType) {
        window.PXUTheme.predictiveSearch.vars.searchResourceType = dataSearchResourceType.getAttribute('data-search-resource-type');
      }

      // Set the cursor at the end of the input field for better UX,
      // otherwise it may be at the beginning of the input field when the input gets focus.
      const searchInputEl = e.target;
      const searchInputVal = searchInputEl.value.trim();
      searchInputEl.setSelectionRange(searchInputVal.length, searchInputVal.length);
      window.PXUTheme.predictiveSearch.getResults(searchInputVal, $(e.target.closest('.search-form')));
    });

    // Clicking outside makes the results disappear.
    $(document).off('.pxuSearchResults').on('click.pxuSearchResults focusout.pxuSearchResults', function (e) {
      if (window.PXUTheme.media_queries.large.matches) {
        const searchForm = $(e.target).parents('.search-form');
        if (searchForm.length === 0) {
          // Opening Search also bubbles a click from its outside trigger.
          // Keep the fresh focus-triggered request for that new session.
          if (e.type === 'click' && $(e.target).closest('[data-show-search-trigger]').length) return;
          window.PXUTheme.predictiveSearch.clearResults();

          // This is for when the 'Vertical' header layout or the 'Search focus' header layout is in use,
          // since unlockBodyScroll won't get called in jsHeader.
          if ((window.PXUTheme.theme_settings.header_layout === 'vertical' || window.PXUTheme.theme_settings.header_layout === 'search_focus') && document.documentElement.classList.contains('scroll-locked')) {
            window.PXUTheme.predictiveSearch.unlockBodyScroll();
          }
        }
      }
    });
    $("[data-autocomplete-true] form").on("submit", function (e) {
      const query = $(this).find('input[name="q"]').val().trim();
      if (!query) e.preventDefault();
    });
    $('[data-autocomplete-true] form').each(function () {
      const $this = $(this);
      const input = $this.find('input[name="q"]');
      const resultWrapper = `<div class="search__results-wrapper"></div>`;
      $(resultWrapper).appendTo($this);
      window.PXUTheme.predictiveSearch.initResultState(this);
      input.attr('autocomplete', 'off').on('input', () => {
        window.PXUTheme.predictiveSearch.queueResults(this);
      });
    });
    const classicResize = document.body && document.body.getAttribute('data-site-header-layout') === 'classic';
    const searchResultsResize = window.PXUTheme.debounce(() => {
      if (classicResize && this.classicSearchResultsResize !== searchResultsResize) return;
      if (window.PXUTheme.theme_settings.header_layout === 'vertical') {
        window.PXUTheme.predictiveSearch.alignVerticalSearch();
      }
      this.resizeSearchResults();
    }, 150);
    if (classicResize) this.classicSearchResultsResize = searchResultsResize;
    window.addEventListener('resize', searchResultsResize);
    $('body')
      .off('keyup.pxuPredictiveSearch keydown.pxuPredictiveSearch')
      .on('keydown.pxuPredictiveSearch', e => this.onKeyDown(e));
  },
  onKeyDown: function (e) {
    if (this.classicMobileSearch && this.classicMobileSearch.deferEscape(e)) return;
    if ((e.key !== 'Escape' && e.code !== 'Escape') || e.repeat ||
        (e.originalEvent && e.originalEvent.repeat) ||
        (e.isDefaultPrevented && e.isDefaultPrevented())) return;

    // Resolve ownership before a dialog closes and returns focus elsewhere.
    // Escape in Quick View, a gallery, a menu or a disclosure is not Search.
    const $target = $(e.target);
    const $lightbox = $target.closest('.fancybox-container');
    const header = window.PXUTheme.jsHeader;
    let $forms;
    let owner;
    let instance;

    if ($lightbox.length) {
      instance = $.fancybox && $.fancybox.getInstance();
      if (!$lightbox.hasClass('search__lightbox') || !instance || instance.isClosing ||
          instance.$refs.container[0] !== $lightbox[0]) return;
      $forms = $lightbox.find('.js-search-popup form.search-form');
      owner = 'popup';
    } else {
      let $mobile = $target.closest('.mobile-search');
      // Android delays input focus. The exact pending opener still owns this
      // Search session, so Escape can cancel it before the timer runs.
      if (!$mobile.length && this.mobileSearchIsOpen && this.mobileSearchFocusTimer !== null &&
          this.mobileSearchFocusGeneration === header.searchReturnFocusGeneration &&
          e.target === header.searchReturnFocusElement) {
        $mobile = $('.mobile-search');
      }
      const $overlay = $target.closest('[data-search-type="overlay"]');
      if ($mobile.length) {
        if (!this.mobileSearchIsOpen || !$mobile.is(':visible')) return;
        $forms = $mobile.find('form.search-form');
        owner = 'mobile';
      } else if ($overlay.length) {
        if (!$overlay.hasClass('is-opened') || !$overlay.is(':visible')) return;
        $forms = $overlay.find('form.search-form');
        owner = 'overlay';
      } else {
        if ($target.closest('.js-search-popup').length) return;
        $forms = $target.closest('form.search-form');
        if (!$forms.length || !$forms.is(':visible')) return;
        owner = 'inline';
      }
    }
    if (!$forms.find('[data-q]').length) return;

    $forms.find('[data-q]').val('');
    this.vars.term = '';
    this.clearResults($forms);

    if (owner === 'mobile') {
      this.hideMobileSearch();
    } else if (owner === 'overlay') {
      header.hideSearch();
    } else if (owner === 'popup') {
      // Fancybox handles other targets at document keydown. Its handler skips
      // these controls/modifiers; close only this verified instance for them.
      if ($target.is('input,textarea,video,audio,select') || e.ctrlKey || e.altKey || e.shiftKey) {
        instance.close(e);
      }
    } else if ($forms.closest('.jsHeader').length &&
        (header.header_layout === 'vertical' || header.header_layout === 'search_focus')) {
      this.unlockBodyScroll();
    }
  },
  resizeSearchResults: function () {
    let inputFieldEl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.querySelector('[data-autocomplete-true]');
    const innerHeight = window.innerHeight;
    const inputFieldElBottom = inputFieldEl.getBoundingClientRect().bottom;
    const offset = isScreenSizeLarge() ? 30 : 10;
    const resultsMaxHeight = `${innerHeight - inputFieldElBottom - offset}px`;
    const resultsContainerEl = inputFieldEl.closest('[data-autocomplete-true]').querySelector('.search__results-wrapper');
    resultsContainerEl.style.setProperty('--results-max-height', resultsMaxHeight);
  },
  initResultState: function (form) {
    // Keep the empty live region in the form before any response arrives.
    // It must not be replaced with the transient results markup.
    const status = document.createElement('div');
    status.className = 'search__status visually-hidden';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    form.appendChild(status);
    this.resultStates.set(form, {
      input: form.querySelector('[data-q]'),
      status: status,
      generation: 0,
      timer: null
    });
  },
  invalidateResults: function (form) {
    const state = this.resultStates.get(form);
    if (!state) return null;
    state.generation += 1;
    if (state.timer !== null) clearTimeout(state.timer);
    state.timer = null;
    state.status.textContent = '';
    return state;
  },
  queueResults: function (form) {
    // Invalidate immediately, not after the debounce: an older response can
    // otherwise arrive while the new query is waiting for its timer.
    const state = this.invalidateResults(form);
    if (!state || !state.input) return;
    const term = state.input.value.trim();
    this.vars.term = term;
    if (!term) {
      this.getResults(term, $(form));
      return;
    }
    const generation = state.generation;
    state.timer = setTimeout(() => {
      state.timer = null;
      if (this.isCurrentResult(form, state, generation, term)) {
        this.getResults(term, $(form));
      }
    }, 200);
  },
  isCurrentResult: function (form, state, generation, term) {
    return this.resultStates.get(form) === state &&
      state.generation === generation && form.isConnected &&
      state.input && state.input.value.trim() === term &&
      form.contains(document.activeElement) && $(form).is(':visible');
  },
  getResults: function (term, $this) {
    const {
      header_layout
    } = window.PXUTheme.theme_settings;
    const form = $this[0];
    const state = form && this.invalidateResults(form);
    if (!state) return;
    const generation = state.generation;
    if (term.length === 0) {
      if (header_layout === 'vertical' || header_layout === 'search_focus') {
        window.PXUTheme.predictiveSearch.unlockBodyScroll();
      }
      this.clearResults($this);
      return;
    }
    if (!this.isCurrentResult(form, state, generation, term)) return;
    const {
      searchResourceType
    } = window.PXUTheme.predictiveSearch.vars;
    const restrictResourceCondition = searchResourceType && 'searchResourceType' in $this[0].dataset;
    return fetch(`${window.PXUTheme.routes.predictive_search_url}?q=${encodeURIComponent(term)}&section_id=predictive-search${restrictResourceCondition ? `&resources[type]=${searchResourceType}` : ''}`).then(response => {
      if (!response.ok) {
        throw new Error(response.status);
      }
      return response.text();
    }).then(text => {
      if (!this.isCurrentResult(form, state, generation, term)) return;
      window.PXUTheme.predictiveSearch.displayResults(text, $this);

      // This is for when the 'Vertical' header layout or the 'Search focus' header layout is in use,
      // since lockBodyScroll won't get called in jsHeader (due to the search icon trigger not being present).
      // lockBodyScroll has to be called here so the overlay appears at about the same time as the results.
      if ((header_layout === 'vertical' || header_layout === 'search_focus') && $this.closest('.jsHeader').length > 0) {
        window.PXUTheme.predictiveSearch.lockBodyScroll();
      }
    }).catch(error => {
      if (this.isCurrentResult(form, state, generation, term)) throw error;
    });
  },
  displayResults: function (results, $this) {
    const $fields = $this.find('.search__fields');
    const $resultsWrapper = $this.find('.search__results-wrapper');
    $resultsWrapper.show();
    $resultsWrapper.empty();
    $resultsWrapper.append(results);
    const state = this.resultStates.get($this[0]);
    const noResults = $resultsWrapper[0].querySelector('.no-results');
    if (state) {
      // Use the rendered locale text. Do not announce product lists or the
      // Search submit button, and never interpret the message as HTML.
      state.status.textContent = noResults ? noResults.textContent.trim() : '';
    }
    const inputFieldEls = $fields.length > 0 ? Array.from($fields) : document.querySelectorAll('[data-autocomplete-true]');

    // Calculate resultsWrapper max height for header search (exclude blog sidebar)
    inputFieldEls.forEach(el => {
      if (el.closest('.search-popup__form') || el.closest('.mobile-search')) {
        this.resizeSearchResults(el);
      }
    });
    if ($this.parents('.vertical-header__content').length && window.PXUTheme.jsHeader.header_layout === 'vertical') {
      window.PXUTheme.predictiveSearch.alignVerticalSearch();
    }
  },
  clearResults: function ($forms) {
    ($forms || $('[data-autocomplete-true] form')).each((index, form) => {
      this.invalidateResults(form);
      $(form).find('.search__results-wrapper').hide().empty();
    });
  },
  showMobileSearch: function (formType) {
    if (this.setupClassicMobileSearch) this.setupClassicMobileSearch();
    if (this.classicMobileSearch) return this.classicMobileSearch.open(formType, arguments[1]);
    if (document.body && document.body.getAttribute('data-site-header-layout') === 'classic') return;
    let position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (this.mobileSearchIsOpen) {
      return;
    }

    this.mobileSearchIsOpen = true;

    if (this.mobileSearchFocusTimer !== null) {
      clearTimeout(this.mobileSearchFocusTimer);
      this.mobileSearchFocusTimer = null;
    }

    const focusGeneration = this.mobileSearchFocusGeneration;

    $('body').css('max-height', window.innerHeight);
    $('.mobile-search').stop(true, false).fadeIn(200, function () {
      $(this).addClass('mobile-search--visible');
    });
    if (/iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
      $('.mobile-search input[data-q]').focus();
    } else {
      //Set delay to ensure focus triggers on android
      this.mobileSearchFocusTimer = setTimeout(function () {
        window.PXUTheme.predictiveSearch.mobileSearchFocusTimer = null;
        if (window.PXUTheme.predictiveSearch.mobileSearchIsOpen &&
            window.PXUTheme.predictiveSearch.mobileSearchFocusGeneration === focusGeneration) {
          $('.mobile-search input[data-q]').focus();
        }
      }, 205);
    }
    const bodyStyle = document.body.style;
    this.mobileSearchBodyWidth = {
      value: bodyStyle.getPropertyValue('width'),
      priority: bodyStyle.getPropertyPriority('width')
    };
    bodyStyle.setProperty('width', '100%');
    bodyStyle.position = 'fixed';
    bodyStyle.top = '-' + position + 'px';
    $('.mobile-search').css('top', position);
    if (formType) {
      $('.mobile-search [name="type"]').val(formType);
    }
    $('.search-form .close-search')
      .off('click.pxuMobileSearch touchstart.pxuMobileSearch')
      .on('click.pxuMobileSearch touchstart.pxuMobileSearch', function (e) {
      e.preventDefault();
      e.stopPropagation();
      window.PXUTheme.predictiveSearch.hideMobileSearch(position);
      $('[data-autocomplete-true] .search__results-wrapper').hide();
      });
    $('.search-form .submit-search')
      .off('click.pxuMobileSearch touchstart.pxuMobileSearch')
      .on('click.pxuMobileSearch touchstart.pxuMobileSearch', function (e) {
      $(this).parents('form').submit();
      });
    $(document).off('click.pxuMobileSearch').on('click.pxuMobileSearch', e => {
      if (!e.target.closest('.search-form') && $('.mobile-search').is('.mobile-search--visible')) {
        window.PXUTheme.predictiveSearch.hideMobileSearch();
      }
    });
  },
  hideMobileSearch: function () {
    if (this.classicMobileSearch) return this.classicMobileSearch.close();
    if (document.body && document.body.getAttribute('data-site-header-layout') === 'classic') return;
    let position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    if (!this.mobileSearchIsOpen) {
      return;
    }

    this.mobileSearchIsOpen = false;
    this.clearResults($('.mobile-search form'));
    const focusGeneration = this.mobileSearchFocusGeneration;

    if (this.mobileSearchFocusTimer !== null) {
      clearTimeout(this.mobileSearchFocusTimer);
      this.mobileSearchFocusTimer = null;
    }
    $('body').css('max-height', 'none');
    document.body.style.position = '';
    document.body.style.top = '';
    this.restoreMobileSearchBodyWidth();
    window.scrollTo(0, position);
    $('.mobile-search').stop(true, false).fadeOut(200, function () {
      if (window.PXUTheme.predictiveSearch.mobileSearchFocusGeneration === focusGeneration) {
        window.PXUTheme.predictiveSearch.mobileSearchFocusGeneration = null;
      }
      window.PXUTheme.jsHeader.restoreSearchReturnFocus(focusGeneration);
    }).removeClass('mobile-search--visible');
    $('.search-form .close-search, .search-form .submit-search').off('.pxuMobileSearch');
    $(document).off('.pxuMobileSearch');
    $('body').off('focus', '.search-form .close-search');
    $('body').off('focus', '.search-form .submit-search');
    window.PXUTheme.predictiveSearch.unlockBodyScroll();
  },
  restoreMobileSearchBodyWidth: function () {
    if (this.mobileSearchBodyWidth === null) {
      return;
    }

    const bodyStyle = document.body.style;
    if (this.mobileSearchBodyWidth.value === '') {
      bodyStyle.removeProperty('width');
    } else {
      bodyStyle.setProperty('width', this.mobileSearchBodyWidth.value, this.mobileSearchBodyWidth.priority);
    }
    this.mobileSearchBodyWidth = null;
  },
  lockBodyScroll: function () {
    document.documentElement.classList.add('scroll-locked');
    document.querySelector('[data-site-overlay]').classList.remove('site-overlay--hidden');
  },
  unlockBodyScroll: function () {
    document.documentElement.classList.remove('scroll-locked');
    document.querySelector('[data-site-overlay]').classList.add('site-overlay--hidden');
  },
  alignVerticalSearch: function () {
    const $resultsList = $('.header--vertical .search__results');
    const headerWidth = $('.header--vertical').innerWidth();
    $resultsList.parents('.search__results-wrapper').css({
      'position': 'fixed',
      'left': headerWidth,
      'top': '0'
    });
  },
  unload: function () {
    if (this.classicSearchResultsResize) {
      window.removeEventListener('resize', this.classicSearchResultsResize);
      this.classicSearchResultsResize = null;
    }
    if (this.classicMobileSearch) this.classicMobileSearch.unload();
    this.clearResults();
    this.resultStates = new WeakMap();
    $('.search__status').remove();
    $(document).off('.pxuSearchResults');
    const classicMobileOwner = document.body && document.body.getAttribute('data-site-header-layout') === 'classic';
    const hadMobileSearchSession = !classicMobileOwner && (this.mobileSearchFocusGeneration !== null || this.mobileSearchIsOpen);
    if (classicMobileOwner && this.mobileSearchFocusGeneration !== null && window.PXUTheme.jsHeader &&
        this.mobileSearchFocusGeneration === window.PXUTheme.jsHeader.searchReturnFocusGeneration) {
      window.PXUTheme.jsHeader.clearSearchReturnFocus();
    }

    if (hadMobileSearchSession && window.PXUTheme.jsHeader) {
      window.PXUTheme.jsHeader.clearSearchReturnFocus();
    }

    if (this.mobileSearchFocusTimer !== null) {
      clearTimeout(this.mobileSearchFocusTimer);
      this.mobileSearchFocusTimer = null;
    }

    this.mobileSearchFocusGeneration = null;
    this.mobileSearchIsOpen = false;
    this.mobileSearchLastTouchAt = 0;
    this.mobileSearchLastTouchTarget = null;

    $('.mobile-search').stop(true, false).hide().removeClass('mobile-search--visible');

    if (hadMobileSearchSession) {
      $('body').css('max-height', 'none');
      document.body.style.position = '';
      document.body.style.top = '';
      window.PXUTheme.predictiveSearch.unlockBodyScroll();
    }

    this.restoreMobileSearchBodyWidth();

    $('body').off('focus', '[data-autocomplete-true] input');
    $('body').off('.pxuPredictiveSearch');
    $('input[name="q"]').off();
    $('[data-show-search-trigger], [data-autocomplete-true] input').off('.pxuMobileSearchOpen');
    $('[data-dropdown-rel="search"], [data-autocomplete-true] input').off();
    $('.search-form .close-search, .search-form .submit-search').off('.pxuMobileSearch');
    $(document).off('.pxuMobileSearch');
    $('.search__results-wrapper').remove();
  }
};
/* B161: the classic mobile Search session owns its boundary cleanup.
 * Menu, desktop Search, other header layouts and unrelated locks keep their owners. */
window.PXUTheme.predictiveSearch.setupClassicMobileSearch = function () {
  'use strict';
  var search = window.PXUTheme.predictiveSearch;
  var body = document.body;
  if (search.classicMobileSearch) {
    if (search.classicMobileSearch.root.isConnected && body && body.getAttribute('data-site-header-layout') === 'classic') return;
    search.classicMobileSearch.destroy();
  }
  if (!body || body.getAttribute('data-site-header-layout') !== 'classic') return;
  var root = document.querySelector('.mobile-search[data-autocomplete-true]');
  if (!root) return;
  var media = window.PXUTheme.media_queries.large;
  var session = null, serial = 0, lastFocus = null, disabled = false, lastTrigger = null, desktop = media.matches;
  var OTHER_OWNER = '.fancybox-container, [role="dialog"], [role="alertdialog"], [aria-modal="true"], dialog, iframe, object, embed';
  var WIDGET_OWNER = 'select, [role="combobox"], [role="listbox"], [role="menu"], [role="tree"]';
  var properties = ['max-height', 'width', 'position', 'top'];
  var rootProperties = ['position', 'top'];

  function foreign(element) {
    if (!element || !element.closest || element.shadowRoot || element.closest(OTHER_OWNER)) return true;
    for (var node = element; node && node !== body; node = node.parentElement) {
      if (node.localName && node.localName.indexOf('-') !== -1) return true;
    }
    return false;
  }
  function owned(element) { return !!element && root.contains(element) && !foreign(element); }
  function visible(element) {
    if (!element || !element.isConnected || element.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.visibility !== 'collapse' &&
      Array.from(element.getClientRects()).some(function (rect) { return rect.width > 0 && rect.height > 0; });
  }
  function snapshotStyle(property) {
    return { value: body.style.getPropertyValue(property), priority: body.style.getPropertyPriority(property) };
  }
  function snapshotRootStyle(property) {
    return { value: root.style.getPropertyValue(property), priority: root.style.getPropertyPriority(property) };
  }
  function sameStyle(a, b) { return a.value === b.value && a.priority === b.priority; }
  function current(s) { return session === s && s.serial === serial; }
  function focusOwner(element, s) {
    return owned(element) || (s.timer !== null && element === s.opener && !foreign(element));
  }
  function triggerMode(element) {
    if (!element || !element.matches || !element.matches('[data-show-search-trigger]') || foreign(element)) return null;
    if (element.closest('.header--classic header#header.header')) return true;
    if (element.closest('.header--classic #mobile-header.mobile-header')) return false;
    return null;
  }
  function recordFocus(event) {
    if (!session) {
      var mode = triggerMode(event.target);
      lastTrigger = !disabled && mode !== null ? { element: event.target, desktop: mode, generation: window.PXUTheme.jsHeader.searchReturnFocusGeneration } : null;
      return;
    }
    if (focusOwner(event.target, session)) {
      lastFocus = { element: event.target, serial: session.serial };
      session.allowFocus = true;
    } else {
      lastFocus = null;
      session.allowFocus = false;
      session.dismissPointer = false;
    }
  }
  function recordBlur(event) {
    if (!session) {
      if (lastTrigger && event.target === lastTrigger.element && !event.relatedTarget &&
          (visible(event.target) || media.matches === lastTrigger.desktop)) lastTrigger = null;
      return;
    }
    if (!lastFocus || event.target !== lastFocus.element || event.relatedTarget) return;
    if (visible(event.target) || !media.matches) {
      lastFocus = null;
      // A non-focusable close icon/backdrop may blur the input before click.
      // This grants only that explicit dismissal, never later resize recovery.
      if (!session.dismissPointer) session.allowFocus = false;
    }
  }
  function pointer(event) {
    if (!session) {
      if (lastTrigger && event.target.closest('[data-show-search-trigger]') !== lastTrigger.element) lastTrigger = null;
      return;
    }
    session.dismissPointer = owned(event.target) && (event.target === root || !!event.target.closest('.close-search'));
    if (!focusOwner(event.target, session)) { lastFocus = null; session.allowFocus = false; }
  }
  function windowBlur() { if (session) session.allowFocus = false; lastFocus = null; lastTrigger = null; }
  function returnTarget(s) {
    if (visible(s.opener) && !foreign(s.opener)) return s.opener;
    var selector = media.matches
      ? '.header--classic header#header.header [data-show-search-trigger]'
      : '.header--classic #mobile-header.mobile-header [data-show-search-trigger]';
    var targets = document.querySelectorAll(selector);
    for (var i = 0; i < targets.length; i++) if (visible(targets[i]) && !foreign(targets[i])) return targets[i];
    return null;
  }
  function close(options) {
    options = options || {};
    var s = session;
    if (!s) return;
    var active = document.activeElement;
    var lost = focusOwner(active, s);
    if (options.dismissControl && s.dismissPointer && (active === body || active === document.documentElement)) lost = true;
    if (!lost && options.breakpoint && (active === body || active === document.documentElement) && lastFocus &&
        lastFocus.serial === s.serial && lastFocus.element.isConnected && !visible(lastFocus.element)) lost = true;
    var header = window.PXUTheme.jsHeader;
    var ownsGeneration = header.searchReturnFocusGeneration === s.generation && header.searchReturnFocusElement === s.opener;
    var shouldReturn = options.returnFocus !== false && s.allowFocus && lost && ownsGeneration && document.hasFocus();
    session = null;
    var closingSerial = ++serial;
    lastFocus = null;
    if (s.timer !== null) clearTimeout(s.timer);
    if (search.mobileSearchFocusTimer === s.timer) search.mobileSearchFocusTimer = null;
    search.mobileSearchIsOpen = false;
    if (search.mobileSearchFocusGeneration === s.generation) search.mobileSearchFocusGeneration = null;
    var restoreScroll = sameStyle(snapshotStyle('position'), s.applied.position) &&
      sameStyle(snapshotStyle('top'), s.applied.top) && s.before.position.value !== 'fixed' &&
      !s.hadMenuLock && !body.classList.contains('mobile-menu--opened');
    properties.forEach(function (property) {
      // Preserve a later owner's different inline value/priority.
      if (!sameStyle(snapshotStyle(property), s.applied[property])) return;
      var before = s.before[property];
      if (before.value === '') body.style.removeProperty(property);
      else body.style.setProperty(property, before.value, before.priority);
    });
    rootProperties.forEach(function (property) {
      // B179: release only this Search session's positioning, preserving later writes.
      if (!sameStyle(snapshotRootStyle(property), s.rootApplied[property])) return;
      var before = s.rootBefore[property];
      if (before.value === '') root.style.removeProperty(property);
      else root.style.setProperty(property, before.value, before.priority);
    });
    if (restoreScroll) window.scrollTo(0, s.scroll);
    // Clear only this return capture; synchronous blur handlers may start a newer Search.
    if (ownsGeneration && header.searchReturnFocusGeneration === s.generation && header.searchReturnFocusElement === s.opener) header.clearSearchReturnFocus();
    var clearedGeneration = header.searchReturnFocusGeneration;
    search.clearResults($(root).find('form.search-form'));
    if (session || serial !== closingSerial) return;
    // Stop both running and queued fades. A newer reentrant open keeps its own work.
    $(root).stop(true, false).hide();
    if (session || serial !== closingSerial) return;
    $(root).removeClass('mobile-search--visible');
    $(root).find('.close-search, .submit-search').off('.pxuClassicMobileSearch');
    $(document).off('.pxuClassicMobileSearch');
    // This mobile session never acquired html.scroll-locked or the site overlay.
    var now = document.activeElement;
    var stayedOwned = now === active || now === body || now === document.documentElement || owned(now);
    if (shouldReturn && stayedOwned && document.hasFocus() && header.searchReturnFocusGeneration === clearedGeneration && !header.searchReturnFocusElement) {
      var target = returnTarget(s);
      if (target) target.focus({ preventScroll: true });
    }
  }
  function open(formType, position) {
    if (disabled || session || media.matches || !root.isConnected) return;
    var header = window.PXUTheme.jsHeader;
    var s = {
      serial: ++serial, generation: search.mobileSearchFocusGeneration,
      opener: header.searchReturnFocusElement, initialFocus: document.activeElement,
      allowFocus: true, timer: null, hadMenuLock: body.classList.contains('mobile-menu--opened'), scroll: Number.isFinite(position) ? position : window.scrollY,
      before: {}, applied: {}, rootBefore: {}, rootApplied: {}
    };
    session = s;
    lastTrigger = null;
    properties.forEach(function (property) { s.before[property] = snapshotStyle(property); });
    rootProperties.forEach(function (property) { s.rootBefore[property] = snapshotRootStyle(property); });
    body.style.setProperty('max-height', window.innerHeight + 'px');
    body.style.setProperty('width', '100%');
    body.style.setProperty('position', 'fixed');
    body.style.setProperty('top', '-' + s.scroll + 'px');
    properties.forEach(function (property) { s.applied[property] = snapshotStyle(property); });
    search.mobileSearchIsOpen = true;
    // B179: this standalone Search surface belongs to the viewport. An absolute
    // child follows BODY's independent Menu scroll even when window.scrollY is zero.
    root.style.setProperty('position', 'fixed');
    root.style.setProperty('top', '0px');
    rootProperties.forEach(function (property) { s.rootApplied[property] = snapshotRootStyle(property); });
    $(root).stop(true, false).fadeIn(200, function () {
      if (current(s) && !media.matches) $(root).addClass('mobile-search--visible');
    });
    if (formType) $(root).find('[name="type"]').val(formType);
    function focusInput() {
      if (!current(s)) return;
      s.timer = null;
      search.mobileSearchFocusTimer = null;
      var active = document.activeElement;
      if (media.matches || !s.allowFocus || !document.hasFocus() || header.searchReturnFocusGeneration !== s.generation ||
          (active !== s.initialFocus && active !== s.opener && !owned(active))) return;
      var input = root.querySelector('input[data-q]');
      if (visible(input)) input.focus({ preventScroll: true });
    }
    if (/iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) focusInput();
    else { s.timer = setTimeout(focusInput, 205); search.mobileSearchFocusTimer = s.timer; }
    if (focusOwner(document.activeElement, s)) lastFocus = { element: document.activeElement, serial: s.serial };
    $(root).find('.close-search').off('.pxuClassicMobileSearch').on('click.pxuClassicMobileSearch touchstart.pxuClassicMobileSearch', function (event) {
      event.preventDefault(); event.stopPropagation(); close({ dismissControl: true });
    });
    $(root).find('.submit-search').off('.pxuClassicMobileSearch').on('click.pxuClassicMobileSearch touchstart.pxuClassicMobileSearch', function () {
      $(this).parents('form').submit();
    });
    $(document).off('.pxuClassicMobileSearch').on('click.pxuClassicMobileSearch', function (event) {
      if (session && !foreign(event.target) && !event.target.closest('form.search-form')) close({ returnFocus: root.contains(event.target), dismissControl: root.contains(event.target) });
    });
  }
  function resize() {
    var next = media.matches, crossed = next !== desktop;
    desktop = next;
    if (session && next) { close({ breakpoint: true }); return; }
    if (session || disabled || !crossed || !lastTrigger) return;
    var previous = lastTrigger;
    lastTrigger = null;
    var active = document.activeElement;
    var header = window.PXUTheme.jsHeader;
    if (previous.desktop === next || !previous.element.isConnected || visible(previous.element) ||
        (active !== previous.element && active !== body && active !== document.documentElement) ||
        !document.hasFocus() || header.searchReturnFocusGeneration !== previous.generation ||
        header.searchReturnFocusElement || header.searchReturnFocusFrame != null) return;
    // A desktop Search popup/overlay or pending return keeps its own focus.
    var surfaces = document.querySelectorAll('.search__lightbox, [data-search-type="overlay"].is-opened');
    if (Array.from(surfaces).some(visible)) return;
    var target = returnTarget({ opener: null });
    if (target) target.focus({ preventScroll: true });
  }
  function deferEscape(event) {
    if (!session || !root.contains(event.target)) return false;
    return foreign(event.target) || !!event.target.closest(WIDGET_OWNER) || event.isComposing ||
      (event.originalEvent && event.originalEvent.isComposing) || !!document.fullscreenElement || !!document.webkitFullscreenElement ||
      !!(event.composedPath && event.composedPath().some(function (node) { return node.nodeType === 11; }));
  }
  function unload() {
    disabled = true;
    lastTrigger = null;
    close({ returnFocus: false });
    var header = window.PXUTheme.jsHeader;
    if (search.mobileSearchFocusGeneration !== null && search.mobileSearchFocusGeneration === header.searchReturnFocusGeneration) header.clearSearchReturnFocus();
    search.mobileSearchFocusGeneration = null;
  }
  function destroy() {
    unload();
    document.removeEventListener('focusin', recordFocus);
    document.removeEventListener('focusout', recordBlur);
    document.removeEventListener('pointerdown', pointer, true);
    window.removeEventListener('blur', windowBlur);
    window.removeEventListener('resize', resize);
    if (media.removeEventListener) media.removeEventListener('change', resize);
    else if (media.removeListener) media.removeListener(resize);
    search.classicMobileSearch = null;
  }
  search.classicMobileSearch = { root: root, open: open, close: close, unload: unload, resume: function () { disabled = false; recordFocus({ target: document.activeElement }); }, deferEscape: deferEscape, destroy: destroy };
  document.addEventListener('focusin', recordFocus);
  document.addEventListener('focusout', recordBlur);
  document.addEventListener('pointerdown', pointer, true);
  window.addEventListener('blur', windowBlur);
  window.addEventListener('resize', resize);
  if (media.addEventListener) media.addEventListener('change', resize);
  else if (media.addListener) media.addListener(resize);
  recordFocus({ target: document.activeElement });
};
window.PXUTheme.predictiveSearch.setupClassicMobileSearch();

function isScreenSizeLarge() {
  if (window.PXUTheme.media_queries.large.matches) {
    return true;
  }
}
window.PXUTheme.scrollToTop = function (element, height) {
  // Check if height argument is present
  if (height != undefined) {
    $('html, body').animate({
      scrollTop: $(element).offset().top - height
    }, 1000);
  } else {
    $('html, body').animate({
      scrollTop: $(element).offset().top
    }, 1000);
  }
};
window.PXUTheme.tabs = {
  enableTabs: function () {
    let $tabs = $('.tabs li, .tabs li a');
    $tabs.on('click', function (el) {
      el.preventDefault();

      // toggle active tab
      $tabs.removeClass('is-active active');
      $(this).addClass('is-active');
      let $tabIndex = $(this).index();
      let $tabContent = $(this).parents('.tabs').next('.tabs-content');

      // toggle corresponding tab content
      $tabContent.children('li, li a').removeClass('is-active active');
      $tabContent.children('li, li a').eq($tabIndex).addClass('is-active').show().css({
        'display': 'block'
      }).siblings().hide().removeClass('is-active');
    });
  },
  unload: function () {
    $('.tabs li, .tabs li a').off();
  }
};
class ProductCard {
  enableSwatches() {
    if (window.isScreenSizeLarge()) {
      $('body').on('mouseenter', '.swatch span', _ref => {
        let {
          currentTarget
        } = _ref;
        if ($(currentTarget).data('image') && $(currentTarget).data('image').indexOf('no-image') === -1) {
          $(currentTarget).parents('.thumbnail').find('.product__imageContainer img:not(.secondary)').attr('src', $(currentTarget).data('image'));
          $(currentTarget).parents('.thumbnail').find('.product__imageContainer img:not(.secondary)').attr('srcset', $(currentTarget).data('image'));
        }
      });
    }
  }
  showVariantImage() {
    if (window.isScreenSizeLarge()) {
      $('body').on('mouseenter', '.has-secondary-image-swap', function () {
        const $primaryImage = $(this).find('.product-image__wrapper img:not(.secondary)');
        const $secondaryImage = $(this).find('.product-image__wrapper img.secondary');
        const $thumbnailVideo = $(this).find('.product-image__wrapper .video-on-hover');
        $primaryImage.addClass('swap--visible');
        $secondaryImage.removeClass('swap--visible');
        if ($thumbnailVideo) {
          $thumbnailVideo.toggleClass('swap--visible');
          window.PXUTheme.video.enableVideoOnHover($(this));
        }
      });
      $('body').on('mouseleave', '.has-secondary-image-swap', function () {
        const $primaryImage = $(this).find('.product-image__wrapper img:not(.secondary)');
        const $secondaryImage = $(this).find('.product-image__wrapper img.secondary');
        const $thumbnailVideo = $(this).find('.product-image__wrapper .video-on-hover');
        $primaryImage.removeClass('swap--visible');
        $secondaryImage.addClass('swap--visible');
        if ($thumbnailVideo) {
          $thumbnailVideo.toggleClass('swap--visible');
          window.PXUTheme.video.disableVideoOnHover($(this));
        }
      });
    }
  }
  cancelQuickShopFocusReturn() {
    if (this.quickShopFocusReturnFrame !== null && this.quickShopFocusReturnFrame !== undefined) {
      window.cancelAnimationFrame(this.quickShopFocusReturnFrame);
    }
    this.quickShopFocusReturnFrame = null;
  }
  restoreQuickShopFocus(target, generation) {
    this.cancelQuickShopFocusReturn();
    this.quickShopFocusReturnFrame = window.requestAnimationFrame(() => {
      this.quickShopFocusReturnFrame = null;
      if (this.quickShopFocusReturnGeneration !== generation || !target || !target.isConnected) return;
      if (typeof target.matches !== 'function' || !target.matches('button.js-quick-shop-link')) return;
      if (target.disabled || target.closest('[aria-hidden="true"]')) return;

      const scrollX = window.pageXOffset;
      const scrollY = window.pageYOffset;
      const productImage = target.closest('.product-image__wrapper');
      if (!productImage) return;

      productImage.classList.add('quick-shop--focus-return');
      if (!target.getClientRects().length) {
        productImage.classList.remove('quick-shop--focus-return');
        return;
      }

      try {
        try {
          target.focus({
            preventScroll: true
          });
        } catch (_error) {
          target.focus();
        }
      } finally {
        productImage.classList.remove('quick-shop--focus-return');
        if (window.pageXOffset !== scrollX || window.pageYOffset !== scrollY) {
          window.scrollTo(scrollX, scrollY);
        }
      }
    });
  }
  installQuickShopFocus(instance) {
    if (!instance || instance.msgQuickShopFocusReady) return;
    instance.msgQuickShopFocusReady = true;
    // Keep Fancybox's keyboard/lifecycle handlers; replace focus only on this
    // outer Quick View instance. Other lightboxes and provider code are untouched.
    instance.focus = (event, skipClose) => this.focusQuickShop(instance, event, skipClose);
  }
  installQuickShopEscape(instance) {
    const container = instance && instance.$refs && instance.$refs.container && instance.$refs.container[0];
    if (!container || instance.msgQuickShopEscapeReady) return;
    instance.msgQuickShopEscapeReady = true;
    $(container).on('keydown.pxuQuickShopEscape', event => {
      if ((event.key !== 'Escape' && event.code !== 'Escape') || event.repeat ||
          (event.originalEvent && event.originalEvent.repeat) || event.isComposing ||
          (event.originalEvent && event.originalEvent.isComposing) || event.defaultPrevented ||
          (event.isDefaultPrevented && event.isDefaultPrevented())) return;
      if (instance.isClosing || instance.isVisible === false || !container.isConnected ||
          $.fancybox.getInstance() !== instance) return;

      const target = event.target;
      // Fancybox skips these light-DOM controls. Preserve Quick View Escape
      // through its own instance, without touching Search or provider internals.
      if (!target || typeof target.matches !== 'function' ||
          !target.matches('input,textarea,video,audio,select') ||
          target.closest('.fancybox-container') !== container ||
          target.closest('[role="dialog"], [role="alertdialog"], [aria-modal="true"], dialog') !== container) return;
      // Native fullscreen owns its Escape. Nested dialogs also keep their own
      // handling; the normal afterClose callback remains the focus-return owner.
      if (document.fullscreenElement || document.webkitFullscreenElement || target.webkitDisplayingFullscreen) return;
      instance.close(event);
    });
  }
  quickShopTabStops(scope, includeUncheckedRadios = false) {
    // Build the shadow-including focus order only to identify the boundaries.
    // The browser still handles ordinary Tab movement, radios and widget keys.
    const isHidden = element => element.matches('[hidden], [inert], [aria-hidden="true"]')
      || window.getComputedStyle(element).display === 'none';
    const isTabStop = element => element.tabIndex >= 0
      && !element.matches(':disabled, .disabled, input[type="hidden"]')
      && window.getComputedStyle(element).visibility !== 'hidden'
      && window.getComputedStyle(element).visibility !== 'collapse'
      && Array.from(element.getClientRects()).some(rect => rect.width > 0 && rect.height > 0);
    const collect = nodes => {
      const entries = [];
      const walk = element => {
        if (isHidden(element)) return;
        const tabStop = isTabStop(element);
        const shadow = element.shadowRoot;
        const slot = element.tagName === 'SLOT';
        if (shadow || slot) {
          // A negative tabindex on a scope owner excludes its descendants from
          // sequential navigation. An absent tabindex on a host does not.
          if (element.hasAttribute('tabindex') && element.tabIndex < 0) return;
          let children = shadow ? shadow.children : element.assignedElements({ flatten: true });
          if (slot && !children.length) children = element.children;
          const nested = collect(Array.from(children));
          const targets = tabStop && !(shadow && shadow.delegatesFocus) ? [element, ...nested] : nested;
          if (targets.length) entries.push({ index: Math.max(0, element.tabIndex), targets });
          return;
        }
        if (tabStop) entries.push({ index: element.tabIndex, targets: [element] });
        Array.from(element.children).forEach(walk);
      };
      nodes.forEach(walk);
      // Positive indices are sorted inside each focus-navigation scope, before
      // zero-index stops. Equal indices keep DOM order (stable Array.sort).
      entries.sort((a, b) => (a.index || Infinity) - (b.index || Infinity));
      return entries.reduce((result, entry) => result.concat(entry.targets), []);
    };
    return collect(Array.from(scope.children)).filter(element => {
      if (includeUncheckedRadios || element.tagName !== 'INPUT' || element.type !== 'radio' || !element.name) return true;
      const radios = element.getRootNode().querySelectorAll('input[type="radio"]');
      const checked = Array.from(radios).find(radio => radio.checked
        && radio.name === element.name && radio.form === element.form && !radio.matches(':disabled'));
      return !checked || checked === element;
    });
  }
  focusQuickShop(instance, event, skipClose) {
    if (instance.isClosing || instance.isVisible === false) return;
    if (event && (event.defaultPrevented || (event.isDefaultPrevented && event.isDefaultPrevented()))) return;
    const container = instance.$refs && instance.$refs.container && instance.$refs.container[0];
    if (!container || !container.isConnected) return;
    const current = instance.current;
    const scope = !event && current && current.isComplete ? current.$slide[0] : container;
    const allTargets = this.quickShopTabStops(scope, true);
    let targets = this.quickShopTabStops(scope);
    if (skipClose) targets = targets.filter(target => !target.matches('.fancybox-close-small'));
    let active = document.activeElement;
    while (active && active.shadowRoot && active.shadowRoot.activeElement) {
      active = active.shadowRoot.activeElement;
    }
    const index = targets.indexOf(active);
    const sameRadioGroup = (a, b) => a && b && a.tagName === 'INPUT' && b.tagName === 'INPUT'
      && a.type === 'radio' && b.type === 'radio' && a.name && a.name === b.name
      && a.form === b.form && a.getRootNode() === b.getRootNode();
    const backwards = Boolean(event && event.shiftKey);
    const endpoint = targets[backwards ? 0 : targets.length - 1];
    // Treat a radio group as the boundary only when no other candidate lies
    // between the active member and the endpoint. Use unfiltered members so
    // programmatically focused unchecked radios retain the correct position.
    const activeOrderIndex = allTargets.indexOf(active);
    const endpointOrderIndex = allTargets.indexOf(endpoint);
    const atRadioBoundary = sameRadioGroup(active, endpoint) && activeOrderIndex >= 0
      && endpointOrderIndex >= 0 && allTargets.slice(
        Math.min(activeOrderIndex, endpointOrderIndex),
        Math.max(activeOrderIndex, endpointOrderIndex) + 1
      ).every(target => sameRadioGroup(active, target));
    const atBoundary = active === endpoint || atRadioBoundary;
    // Unknown contained hosts (for example closed provider roots) are not
    // outside focus. Preserve their native Tab behavior rather than restart it.
    if (event && index < 0 && !atBoundary && document.activeElement !== container
      && container.contains(document.activeElement)) return;
    if (!targets.length || index < 0 || atBoundary) {
      if (event) event.preventDefault();
      const target = targets.length ? targets[backwards ? targets.length - 1 : 0] : container;
      target.focus();
    }
  }
  prepareQuickShopEmptyGalleries(instance) {
    const container = instance.$refs && instance.$refs.container && instance.$refs.container[0];
    if (!container) return;
    // Flickity adds tabindex=0 even to a no-media gallery. It has no useful
    // keyboard interaction and can have a 0px-high focus target.
    container.querySelectorAll('.product-gallery__main[data-media-count="0"]').forEach(gallery => {
      if (!gallery.querySelector('.product-gallery__image')) gallery.setAttribute('tabindex', '-1');
    });
  }
  clearQuickShopNativeVideoFocus(instance) {
    if (!instance || !instance.msgQuickShopNativeVideoFocusCleanup) return;
    instance.msgQuickShopNativeVideoFocusCleanup();
    delete instance.msgQuickShopNativeVideoFocusCleanup;
  }
  installQuickShopNativeVideoFocus(instance) {
    this.clearQuickShopNativeVideoFocus(instance);
    const container = instance && instance.$refs && instance.$refs.container && instance.$refs.container[0];
    if (!container) return;
    const cleanups = [];
    container.querySelectorAll('.product-gallery__main.flickity-enabled').forEach(gallery => {
      const flickity = $(gallery).data('flickity');
      if (!flickity || typeof flickity.on !== 'function' || typeof flickity.off !== 'function') return;
      const videos = Array.from(gallery.querySelectorAll('[data-html5-video] video[controls]')).filter(video =>
        !video.plyr && !video.closest('.plyr') && video.closest('.product-gallery__main') === gallery
        && video.closest('.fancybox-container') === container
        && video.closest('.product-gallery__image[data-media-type="video"]')
      ).map(video => ({
        video,
        cell: video.closest('.product-gallery__image[data-media-type="video"]'),
        inert: video.getAttribute('inert'),
      }));
      if (!videos.length) return;
      const restore = ({ video, inert }) => {
        if (inert === null) video.removeAttribute('inert');
        else video.setAttribute('inert', inert);
      };
      const sync = () => {
        videos.forEach(entry => {
          const inactive = gallery.classList.contains('flickity-enabled') && gallery.contains(entry.video)
            && entry.cell.getAttribute('aria-hidden') === 'true' && !entry.cell.classList.contains('is-selected');
          if (inactive) {
            if (!entry.video.hasAttribute('inert')) entry.video.setAttribute('inert', '');
          } else restore(entry);
        });
      };
      flickity.on('select', sync);
      flickity.on('deactivate', sync);
      sync();
      cleanups.push(() => {
        flickity.off('select', sync);
        flickity.off('deactivate', sync);
        videos.forEach(restore);
      });
    });
    if (cleanups.length) instance.msgQuickShopNativeVideoFocusCleanup = () => cleanups.forEach(cleanup => cleanup());
  }
  showQuickShop() {
    // EVENT - click on quick-shop
    $('body').on('click', '.js-quick-shop-link', e => {
      e.preventDefault();
      const $currentTarget = $(e.currentTarget);
      let quickShopFocusTarget = e.currentTarget;
      const requestGeneration = (this.quickShopRequestGeneration || 0) + 1;
      this.quickShopRequestGeneration = requestGeneration;
      window.PXUTheme.jsProductClass.load($currentTarget.data('url')).then(_ref2 => {
        let {
          html
        } = _ref2;
        if (this.quickShopRequestGeneration !== requestGeneration || $('.fancybox-active').length) {
          quickShopFocusTarget = null;
          return;
        }

        $('.js-quick-shop').html(html.content);
        const quickShopRoot = $('.js-quick-shop')[0];
        let quickShopMusicVideos = [];
        $('.js-quick-shop [data-section-data]').attr('data-section-id', 'quickshop');
        $('.js-quick-shop .js-product_section').addClass('quickshop');
        const quickShopTitle = $('.js-quick-shop .product-title').first().text().trim();
        this.cancelQuickShopFocusReturn();
        const focusGeneration = (this.quickShopFocusReturnGeneration || 0) + 1;
        this.quickShopFocusReturnGeneration = focusGeneration;
        let quickShopFancyboxInstance = null;
        quickShopFancyboxInstance = $.fancybox.open($('.js-quick-shop'), {
            baseClass: `quick-shop__lightbox product-${$currentTarget.data('id')}`,
            hash: false,
            infobar: false,
            toolbar: false,
            loop: true,
            smallBtn: true,
            touch: false,
            video: {
              autoStart: false
            },
            mobile: {
              preventCaptionOverlap: false,
              toolbar: true
            },
            onInit: instance => {
              this.installQuickShopFocus(instance);
              this.installQuickShopEscape(instance);
            },
            beforeShow: (_e, instance) => {
              const $quickshopDialog = instance.$slide.closest('.quick-shop__lightbox[role="dialog"]');
              if ($quickshopDialog.length && quickShopTitle) {
                $quickshopDialog.attr('aria-label', quickShopTitle);
              }
              // Enable tabs
              if (document.querySelectorAll('.tabs').length > 0) {
                window.PXUTheme.tabs.enableTabs();
              }
              // Enable accordions
              if (document.querySelectorAll('.accordion').length > 0) {
                window.PXUTheme.contentCreator.accordion.init();
              }
            },
            afterShow: (_e, instance) => {
              // Use unique identifier for the product gallery
              const {
                src
              } = instance;
              const $quickshop = $(src).find('.quick-shop');
              window.PXUTheme.jsProduct.init($('.js-quick-shop'));
              if (quickShopRoot) {
                quickShopMusicVideos = Array.from(quickShopRoot.querySelectorAll('[data-html5-video][data-msg-music-caption] video')).filter(video => !video.plyr);
                quickShopMusicVideos.forEach(video => {
                  const title = window.PXUTheme.video.getVideoTitle(video);
                  if (title && !video.getAttribute('aria-label') && !video.getAttribute('aria-labelledby')) video.setAttribute('aria-label', title);
                  window.PXUTheme.video.prepareVideoPlayer(video);
                });
              }
              this.prepareQuickShopEmptyGalleries(_e);
              this.installQuickShopNativeVideoFocus(_e);
              $quickshop.addClass('quick-shop--loaded');
              $quickshop.addClass('content-loaded');
            },
            beforeClose: (_e, instance) => {
              quickShopMusicVideos.forEach(video => {
                if (quickShopRoot && quickShopRoot.contains(video)) video.pause();
              });
              // Use unique identifier for the product gallery
              const {
                src
              } = instance;
              const $quickshop = $(src).find('.quick-shop');
              $quickshop.removeClass('quick-shop--loaded');
              $quickshop.removeClass('content-loaded');
            },
            afterClose: instance => {
              if (instance !== quickShopFancyboxInstance) return;

              this.clearQuickShopNativeVideoFocus(instance);
              quickShopMusicVideos = [];
              const focusTarget = quickShopFocusTarget;
              quickShopFocusTarget = null;
              quickShopFancyboxInstance = null;
              this.restoreQuickShopFocus(focusTarget, focusGeneration);
            }
        });
      }).catch(error => {
        quickShopFocusTarget = null;
        console.error(error);
      });
    });
  }
}
window.PXUTheme.thumbnail = new ProductCard();
const videoEl = {
  playButtonIcon: '<button type="button" class="plyr__control plyr__control--overlaid" aria-label="Play, {title}" data-plyr="play"><svg class="play-icon-button-control" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="60" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23 20V40L39 29.4248L23 20Z" fill="#323232"/></svg><span class="plyr__sr-only">Play</span></button>',
  playButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Play, {title}" data-plyr="play"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Pause</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span></button>',
  muteButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Mute" data-plyr="mute"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-muted"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-volume"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span></button>',
  progressInput: '<div class="plyr__controls__item plyr__progress__container"><div class="plyr__progress"><input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek"><progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress><span role="tooltip" class="plyr__tooltip">00:00</span></div></div>',
  volume: '<div class="plyr__controls__item plyr__volume"><input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume"></div>',
  fullscreen: '<button type="button" class="plyr__controls__item plyr__control" data-plyr="fullscreen"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-exit-fullscreen"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-enter-fullscreen"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Exit fullscreen</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Enter fullscreen</span></button>'
};
const videoControls = `${videoEl.playButtonIcon}<div class="plyr__controls"> ${videoEl.playButton} ${videoEl.progressInput} ${videoEl.muteButton} ${videoEl.volume} ${videoEl.fullscreen}</div>`;
let videoPlayers = [];
let videosInRecommendedProductsPlayer;
window.PXUTheme.video = {
  init: function () {
    this.setupVideoPlayer();
  },
  getVideoTitle: function (video) {
    if (!video) return '';
    const slide = video.closest('.product-gallery__image[data-title]');
    const iframe = video.querySelector && video.querySelector('iframe[title]');
    const title = slide && slide.getAttribute('data-title') || video.getAttribute('aria-label') || video.getAttribute('title') || iframe && iframe.getAttribute('title') || '';
    return title.trim();
  },
  prepareVideoPlayer: function (video) {
    const title = this.getVideoTitle(video);
    if (!title) return;
    let config = {};
    const configJSON = video.getAttribute('data-plyr-config');
    if (configJSON) {
      try {
        const parsedConfig = JSON.parse(configJSON);
        if (parsedConfig && typeof parsedConfig === 'object' && !Array.isArray(parsedConfig)) {
          config = parsedConfig;
        }
      } catch (_error) {
        config = {};
      }
    }
    config.title = title;
    const musicCaption = video.closest('[data-msg-music-caption]');
    if (musicCaption && typeof video.addTextTrack === 'function' && typeof window.VTTCue === 'function') {
      this.prepareMusicCaptions(video, musicCaption, config);
    }
    video.setAttribute('data-plyr-config', JSON.stringify(config));
  },
  prepareMusicCaptions: function (video, wrapper, config) {
    const end = Number(wrapper.getAttribute('data-msg-caption-end'));
    if (!Number.isFinite(end) || end <= 0) return;
    if (!video.__msgMusicCaptions) {
      const track = video.addTextTrack('captions', wrapper.getAttribute('data-msg-caption-label'), 'en');
      const cue = new window.VTTCue(0, end, wrapper.getAttribute('data-msg-music-caption'));
      track.addCue(cue);
      track.mode = 'showing';
      video.__msgMusicCaptions = { track: track, cue: cue };
    }
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'plyr__controls__item plyr__control';
    button.setAttribute('data-plyr', 'captions');
    button.setAttribute('aria-label', wrapper.getAttribute('data-msg-caption-control'));
    button.setAttribute('aria-pressed', 'true');
    button.innerHTML = '<svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-captions-on"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-captions-off"></use></svg><span class="plyr__sr-only"></span>';
    button.querySelector('span').textContent = wrapper.getAttribute('data-msg-caption-control');
    config.controls = videoControls.replace(videoEl.fullscreen, button.outerHTML + videoEl.fullscreen);
    config.captions = Object.assign({}, config.captions, { active: true, language: 'en', update: false });
  },
  setupPlayerAccessibility: function (player) {
    if (!player || player.__pxuMediaAccessibilityReady) return;
    const container = player.elements && player.elements.container;
    const title = player.config && typeof player.config.title === 'string' ? player.config.title.trim() : '';
    if (!container || !title) return;
    player.__pxuMediaAccessibilityReady = true;
    const musicCaptions = player.media && player.media.__msgMusicCaptions;
    if (musicCaptions) {
      player.media.addEventListener('webkitbeginfullscreen', () => {
        musicCaptions.track.mode = player.captions.toggled ? 'showing' : 'disabled';
      });
      player.media.addEventListener('webkitendfullscreen', () => {
        const active = musicCaptions.track.mode === 'showing';
        musicCaptions.track.mode = 'hidden';
        player.toggleCaptions(active);
      });
    }
    const frameTitleTemplate = player.config.i18n && player.config.i18n.frameTitle || 'Player for {title}';
    const playerLabel = frameTitleTemplate.replace('{title}', title);
    const updateAccessibility = () => {
      const playAction = player.config.i18n && player.config.i18n.play || 'Play';
      const pauseAction = player.config.i18n && player.config.i18n.pause || 'Pause';
      const action = player.playing ? pauseAction : playAction;
      container.querySelectorAll('[data-plyr="play"]').forEach(button => {
        button.setAttribute('aria-label', `${action}, ${title}`);
      });
      container.querySelectorAll('[data-plyr="mute"]').forEach(button => {
        button.setAttribute('aria-pressed', player.muted ? 'true' : 'false');
      });
      if (musicCaptions) {
        container.querySelectorAll('[data-plyr="captions"]').forEach(button => {
          button.setAttribute('aria-pressed', player.captions.toggled ? 'true' : 'false');
        });
      }
      const iframe = container.querySelector('iframe');
      if (iframe) {
        iframe.setAttribute('title', playerLabel);
      }
    };
    container.setAttribute('role', 'group');
    container.setAttribute('aria-label', playerLabel);
    player.on('ready', updateAccessibility);
    player.on('play', updateAccessibility);
    player.on('pause', updateAccessibility);
    player.on('ended', updateAccessibility);
    player.on('volumechange', updateAccessibility);
    if (musicCaptions) {
      player.on('captionsenabled', updateAccessibility);
      player.on('captionsdisabled', updateAccessibility);
    }
    updateAccessibility();
    // Provider iframes (e.g. YouTube) are created and repeatedly re-titled by the
    // provider after Plyr's own lifecycle events; re-apply the product name whenever
    // it drifts. Bounded to 30 s and to this container's lifetime.
    if (typeof MutationObserver === 'function') {
      const iframeObserver = new MutationObserver(() => {
        if (!container.isConnected) {
          iframeObserver.disconnect();
          return;
        }
        const iframe = container.querySelector('iframe');
        if (iframe && iframe.getAttribute('title') !== playerLabel) {
          updateAccessibility();
        }
      });
      iframeObserver.observe(container, { childList: true, subtree: true, attributes: true, attributeFilter: ['title'] });
      window.setTimeout(() => iframeObserver.disconnect(), 30000);
    }
  },
  setupVideoPlayer: function () {
    const productVideos = document.querySelectorAll('[data-html5-video] video, [data-youtube-video]');
    Array.from(productVideos).forEach(video => this.prepareVideoPlayer(video));
    let setupVideoPlayers = Plyr.setup(productVideos, {
      controls: videoControls,
      ratio: this.aspect_ratio,
      fullscreen: {
        enabled: true,
        fallback: true,
        iosNative: true
      },
      storage: {
        enabled: false
      }
    });
    let videoLooping = $('[data-video-loop]').data('video-loop') || false;
    $.each(setupVideoPlayers, (index, player) => {
      player.loop = videoLooping;
      this.setupPlayerAccessibility(player);
      videoPlayers.push(player);
    });
    this.setupListeners();
  },
  setupListeners: function () {
    // Adds plyr video id to video wrapper
    $.each(videoPlayers, function (index, player) {
      const id = player.id;
      let $video;
      if (player.isHTML5) {
        $video = $(player.elements.wrapper).find('video');
        $video.attr('data-plyr-video-id', id);
      }

      // When a video is playing, pause any other instances
      player.on('play', function (event) {
        var instance = event.detail.plyr;
        $.each(videoPlayers, function (index, player) {
          var playerID = player.id || player.media.dataset.plyrVideoId;
          if (instance.id != playerID) {
            player.pause();
          }
        });
      });
    });
  },
  enableVideoOnHover: function ($thumbnail) {
    var $html5Video = $thumbnail.find('[data-html5-video]');
    var $youtubeVideo = $thumbnail.find('[data-youtube-video]');
    var videoID;
    if ($html5Video.length > 0) {
      videoID = $html5Video.find('[data-plyr-video-id]').data('plyr-video-id');
    } else if ($youtubeVideo.length > 0) {
      videoID = $youtubeVideo.find('iframe').attr('id');
    }
    if (videoID) {
      $.each(videoPlayers, function (index, player) {
        if (player.id == videoID || player.media.id == videoID) {
          player.toggleControls(false);
          player.muted = true;
          player.play();
        }
      });
    }
  },
  disableVideoOnHover: function ($thumbnail) {
    var $html5Video = $thumbnail.find('[data-html5-video]');
    var $youtubeVideo = $thumbnail.find('[data-youtube-video]');
    var videoID;
    if ($html5Video.length > 0) {
      videoID = $html5Video.find('[data-plyr-video-id]').data('plyr-video-id');
    } else if ($youtubeVideo.length > 0) {
      videoID = $youtubeVideo.find('iframe').attr('id');
    }
    if (videoID) {
      $.each(videoPlayers, function (index, player) {
        if (player.id == videoID || player.media.id == videoID) {
          if (player.playing) {
            player.pause();
          }
        }
      });
    }
  }
};

/* R37 CART DISCOUNT RECOVERY — Ultimate Special Offers SECTION renderer.
 * Provider reloads the cart on Apply and renders a blank input with no error,
 * no value retention, and no focus return. This controller preserves the
 * attempted code, surfaces the provider's own computed result (summary_html
 * verbatim), restores value and focus for correction, and never announces a
 * state the provider did not compute. USO keeps full ownership of validation
 * and discount application. Inspected 2026-09-25; remove if Orbit ships a
 * native fix. */
(function () {
  'use strict';

  var CONTROLLER_ID = 'msgR37DiscountRecovery';
  var STORAGE_KEY = 'msgR37DiscountAttempt';
  var MAX_ATTEMPT_AGE_MS = 120000;
  var RENDER_TIMEOUT_MS = 10000;

  function isCartPage() {
    return /^\/cart(\.html)?([/?#]|$)/.test(window.location.pathname);
  }

  function findApplyButtons(scope) {
    var root = scope || document;
    return root.querySelectorAll(
      '.saso-use-discount-code-cart-apply, #saso-use-discount-code-cart-apply',
    );
  }

  function inputForApply(button) {
    if (!button || typeof button.closest !== 'function') return null;
    var container = button.closest(
      '.saso-use-discount-code-cart-container, #saso-use-discount-code-cart, form, div',
    );
    if (!container) return null;
    return container.querySelector(
      '.saso-use-discount-code-cart-code, #saso-use-discount-code-cart-code',
    );
  }

  function currentDiscountInput() {
    var buttons = findApplyButtons(document);
    for (var i = 0; i < buttons.length; i += 1) {
      var input = inputForApply(buttons[i]);
      if (input) return input;
    }
    return document.querySelector(
      '.saso-use-discount-code-cart-code, #saso-use-discount-code-cart-code',
    );
  }

  function readAttempt() {
    try {
      var raw = window.sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var attempt = JSON.parse(raw);
      if (!attempt || attempt.pathname !== window.location.pathname) return null;
      if (Date.now() - attempt.attemptedAt > MAX_ATTEMPT_AGE_MS) return null;
      return attempt;
    } catch (_error) {
      return null;
    }
  }

  function clearAttempt() {
    try {
      window.sessionStorage.removeItem(STORAGE_KEY);
    } catch (_error) { /* noop */ }
  }

  function ensureLabel(input) {
    if (!input.id) input.id = CONTROLLER_ID + 'Code';
    var labelId = CONTROLLER_ID + 'Label';
    if (document.getElementById(labelId)) return;
    var labelledby = input.getAttribute('aria-labelledby') || '';
    var hasLabel = labelledby || (input.getAttribute('aria-label') || '') ||
      (input.id && document.querySelector('label[for="' + input.id + '"]'));
    if (hasLabel) return;
    var label = document.createElement('label');
    label.id = labelId;
    label.className = 'is-sr-only';
    label.setAttribute('for', input.id);
    label.textContent = 'Discount code';
    input.setAttribute('aria-labelledby', labelId);
    input.parentNode.insertBefore(label, input);
  }

  function ensureStatusNode(input) {
    var statusId = CONTROLLER_ID + 'Status';
    var existing = document.getElementById(statusId);
    if (existing) return existing;
    var status = document.createElement('p');
    status.id = statusId;
    status.className = 'cart-warning';
    status.setAttribute('aria-atomic', 'true');
    if (input.parentNode) input.parentNode.insertBefore(status, input.nextSibling);
    return status;
  }

  function describeOutcome(data) {
    var discounts = data && data.discounts ? data.discounts : {};
    var summary = typeof discounts.summary_html === 'string' ? discounts.summary_html : '';
    var text = summary.replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
    var validField = discounts.discount_code_cart_valid;
    var total = typeof discounts.total_discount_amount === 'number'
      ? discounts.total_discount_amount
      : parseFloat(discounts.total_discount_amount) || 0;

    if (validField === true || total > 0) {
      return { kind: 'success', message: text || 'Discount code applied.' };
    }
    if (validField === false || /did not match/i.test(text)) {
      return { kind: 'invalid', message: text || "We couldn't apply this discount code. Check the code and try again." };
    }
    if (text) {
      // Provider computed something we do not recognize; surface it verbatim as a
      // neutral status instead of guessing validity.
      return { kind: 'neutral', message: text };
    }
    return { kind: 'unconfirmed', message: "We couldn't confirm this discount code. Check the code and try again." };
  }

  function exposeOutcome(input, attempt, outcome) {
    ensureLabel(input);
    var status = ensureStatusNode(input);
    status.textContent = outcome.message;

    if (outcome.kind === 'invalid' || outcome.kind === 'unconfirmed') {
      status.setAttribute('role', 'alert');
      status.setAttribute('aria-live', 'assertive');
      input.setAttribute('aria-invalid', 'true');
      input.setAttribute('aria-describedby', status.id);
    } else {
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      input.removeAttribute('aria-invalid');
      if (outcome.kind === 'success') {
        input.removeAttribute('aria-describedby');
      }
    }

    if (outcome.kind === 'invalid' || outcome.kind === 'unconfirmed') {
      input.value = attempt.value;
      if (typeof input.focus === 'function') {
        try {
          input.focus({ preventScroll: true });
        } catch (_error) {
          input.focus();
        }
      }
    }
  }

  function start() {
    if (!isCartPage()) return;
    if (window[CONTROLLER_ID]) return;
    window[CONTROLLER_ID] = true;

    // 1. Capture the attempt (capture phase; never intercepts the provider's click).
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      var button = target.closest(
        '.saso-use-discount-code-cart-apply, #saso-use-discount-code-cart-apply',
      );
      if (!button) return;
      var input = inputForApply(button);
      if (!input || !input.value || !input.value.trim()) return;
      try {
        window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
          value: input.value,
          attemptedAt: Date.now(),
          pathname: window.location.pathname,
        }));
      } catch (_error) { /* noop */ }
    }, true);

    // 2. Chain the provider completion hook; never alter its response.
    var priorHook = typeof window.SASOComplete === 'function' ? window.SASOComplete : null;
    var recoveryDone = false;

    function recover(data) {
      if (recoveryDone) return data;
      var attempt = readAttempt();
      if (!attempt) return data;

      var outcome = describeOutcome(data);
      var deadline = Date.now() + RENDER_TIMEOUT_MS;

      function finish() {
        var input = currentDiscountInput();
        if (!input) {
          if (Date.now() < deadline) {
            window.setTimeout(finish, 200);
          } else {
            clearAttempt();
          }
          return;
        }
        recoveryDone = true;
        exposeOutcome(input, attempt, outcome);
        clearAttempt();
      }

      window.setTimeout(finish, 0);
      return data;
    }

    window.SASOComplete = function (data) {
      var result = data;
      if (priorHook) {
        try {
          var returned = priorHook(data);
          if (returned) result = returned;
        } catch (error) {
          window.setTimeout(function () { throw error; }, 0);
        }
      }
      try {
        recover(result);
      } catch (_error) { /* never break the provider hook */ }
      return result;
    };

    // 3. Clean up across Shopify section reloads and page navigations.
    document.addEventListener('shopify:section:unload', function () {
      if (event.target && event.target.querySelector && event.target.querySelector('.saso-use-discount-code-cart-code')) {
        clearAttempt();
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* R17 CHECKOUT ACTIVATION WATCHDOG — Ultimate Special Offers checkout interception.
 * USO preventDefault()s the Checkout button and replaces submission with an async
 * POST plus a scripted redirect; its 4-second checkout_start guard and any
 * stalled/failed request silently leave keyboard users on /cart with no feedback
 * (WCAG 2.1.1). Both provider branches (discount_code and draft_order) always end
 * in navigation on success, so if we are still on /cart WATCHDOG_MS after an
 * activation, the attempt has failed. This controller only observes activations
 * (capture phase; never preventDefault/stopPropagation) and, on failure, navigates
 * to the provider's own fallback target /checkout. It never fires while a legit
 * flow is in flight: normal provider redirects disarm it via pagehide, and timers
 * that fire late (bfcache restore) are ignored. Inspected 2026-09-28; remove if
 * Orbit ships a native failure-safe fix. */
(function () {
  'use strict';

  var WATCHDOG_ID = 'msgR17CheckoutWatchdog';
  var WATCHDOG_MS = 5000; // provider: ajax (~0.3-2s) + delay_checkout (1s live); guard is 4s
  var LATE_FIRE_MS = 2500; // ignore timers that fire well past their deadline
  var CHECKOUT_SELECTOR = "button[name='checkout'], input[name='checkout']";

  function isCartPage() {
    return /^\/cart(\.html)?([/?#]|$)/.test(window.location.pathname);
  }

  function start() {
    if (!isCartPage()) return;
    if (window[WATCHDOG_ID]) return;
    window[WATCHDOG_ID] = true;

    var timer = null;
    var armedAt = 0;
    var attempts = 0;

    function disarm() {
      if (timer) {
        window.clearTimeout(timer);
        timer = null;
      }
    }

    function fire(expectedAttempt) {
      timer = null;
      if (expectedAttempt !== attempts) return; // superseded by a newer activation
      if (Date.now() - armedAt > WATCHDOG_MS + LATE_FIRE_MS) return; // late fire (bfcache)
      if (!isCartPage()) return; // already navigated
      if (document.visibilityState === 'hidden') return; // never navigate a hidden page
      // Provider's own fallback target; Shopify resumes/creates checkout for the cart.
      window.location.assign('/checkout');
    }

    function arm(event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      if (!target.closest(CHECKOUT_SELECTOR)) return;
      attempts += 1;
      armedAt = Date.now();
      disarm();
      var myAttempt = attempts;
      timer = window.setTimeout(function () {
        fire(myAttempt);
      }, WATCHDOG_MS);
    }

    // Observe pointer and keyboard activation; never intercept either.
    document.addEventListener('click', arm, true);
    document.addEventListener('keydown', function (event) {
      var key = event.key || event.keyCode;
      if (key === 'Enter' || key === ' ' || key === 'Spacebar' || key === 13 || key === 32) {
        arm(event);
      }
    }, true);

    // Any real navigation unloads the page and disarms the watchdog.
    window.addEventListener('pagehide', disarm, true);
    window.addEventListener('beforeunload', disarm, true);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') disarm();
    }, true);
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) disarm();
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* R25 NAV DROPDOWN ARIA SYNC — desktop header dropdown triggers.
 * The theme printed aria-haspopup/aria-expanded on generic wrapper DIVs (invalid;
 * axe aria-allowed-attr) and never updated the state. The attributes now live on
 * the real trigger links; this controller keeps aria-expanded truthful against the
 * three ways a dropdown can open: CSS :hover, JS-added is-opened/show-dropdown
 * classes, and the no-js radio. Zero visual impact; observers are attribute-scoped. */
(function () {
  'use strict';

  var SYNC_ID = 'msgR25NavAriaSync';
  var TRIGGER_SELECTOR = 'a.navbar-link[aria-haspopup="true"]';

  function wrappers() {
    var links = document.querySelectorAll(TRIGGER_SELECTOR);
    var seen = [];
    for (var i = 0; i < links.length; i += 1) {
      var wrap = links[i].closest('.has-dropdown, .has-mega-menu');
      if (wrap && seen.indexOf(wrap) === -1) {
        seen.push(wrap);
      }
    }
    return seen;
  }

  function isOpen(wrap) {
    if (!wrap || wrap.classList.contains('msg-nav-escape-closed')) return false;
    if (wrap.classList.contains('is-opened') || wrap.classList.contains('show-dropdown')) return true;
    var radio = wrap.querySelector('input.no-js-main-navigation[type="radio"]');
    if (radio && radio.checked) return true;
    return wrap.matches(':hover');
  }

  function sync(wrap) {
    var link = wrap.querySelector(TRIGGER_SELECTOR);
    if (!link) return;
    var wanted = isOpen(wrap) ? 'true' : 'false';
    if (link.getAttribute('aria-expanded') !== wanted) {
      link.setAttribute('aria-expanded', wanted);
    }
  }

  function syncAll() {
    wrappers().forEach(sync);
  }

  function start() {
    if (window[SYNC_ID]) return;
    window[SYNC_ID] = true;

    // Hover opens (delegated; mouseover/out bubble).
    document.addEventListener('mouseover', function (event) {
      var wrap = event.target && event.target.closest ? event.target.closest('.has-dropdown, .has-mega-menu') : null;
      if (wrap) sync(wrap);
    }, true);
    document.addEventListener('mouseout', function (event) {
      var wrap = event.target && event.target.closest ? event.target.closest('.has-dropdown, .has-mega-menu') : null;
      if (wrap) window.setTimeout(function () { sync(wrap); }, 0);
    }, true);

    // JS class-driven opens (click mode is-opened / show-dropdown) and radio state.
    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches && event.target.matches('input.no-js-main-navigation[type="radio"]')) {
        syncAll();
      }
    }, true);

    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.target && record.target.classList &&
            (record.target.classList.contains('has-dropdown') || record.target.classList.contains('has-mega-menu'))) {
          sync(record.target);
        }
      });
    });
    wrappers().forEach(function (wrap) {
      observer.observe(wrap, { attributes: true, attributeFilter: ['class'] });
    });

    // Initial truth pass after everything settles.
    window.setTimeout(syncAll, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* R23 SHOGUN IMAGE-LINK NAMER — /pages/kitchen category tiles.
 * Shogun renders image-only collection links with empty alt and no accessible name
 * (WCAG 2.4.4/4.1.2). Content-side fix belongs in Shogun; until then, name each
 * unnamed image-only link from its exact destination pathname using the store's
 * real collection titles. Keyed by pathname: no pattern guessing, no false positives. */
(function () {
  'use strict';

  var NAMER_ID = 'msgR23ShogunLinkNamer';
  var LINK_NAMES = {
    '/collections/online-dips': 'Online Dips',
    '/collections/online-mixes': 'Online Mixes',
    '/collections/kitchen-gadgets': 'Kitchen Gadgets',
    '/collections/online-chocolate-and-candies': 'Online chocolate and Candies',
    '/collections/online-salsa': 'Online Salsa'
  };

  function hasAccessibleName(link) {
    if ((link.getAttribute('aria-label') || '').trim()) return true;
    if ((link.getAttribute('aria-labelledby') || '').trim()) return true;
    if ((link.getAttribute('title') || '').trim()) return true;
    if ((link.textContent || '').trim()) return true;
    var imgs = link.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i += 1) {
      if ((imgs[i].getAttribute('alt') || '').trim()) return true;
    }
    return false;
  }

  function nameLinks() {
    var fixed = 0;
    var links = document.querySelectorAll('a[href*="/collections/"]');
    for (var i = 0; i < links.length; i += 1) {
      var link = links[i];
      var pathname;
      try {
        pathname = new URL(link.href, window.location.origin).pathname;
      } catch (_error) {
        continue;
      }
      var name = LINK_NAMES[pathname];
      if (!name || hasAccessibleName(link)) continue;
      if (!link.querySelector('img')) continue; // only image-only links are in scope
      link.setAttribute('aria-label', name);
      fixed += 1;
    }
    return fixed;
  }

  function start() {
    if (window[NAMER_ID]) return;
    window[NAMER_ID] = true;
    nameLinks();
    // One bounded retry for any late-appended Shogun nodes.
    var retries = 0;
    var timer = window.setInterval(function () {
      retries += 1;
      nameLinks();
      if (retries >= 6) window.clearInterval(timer);
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* B80 DESKTOP NAV ESCAPE — the classic header's ordinary dropdown owns dismissal.
 * A closed class overrides CSS hover until a new pointer entry or trigger action.
 * Search, dialogs, mobile navigation and mega menus retain their own handlers. */
(function () {
  'use strict';

  var CONTROLLER_ID = 'msgB80DesktopNavEscape';
  if (window[CONTROLLER_ID]) return;
  window[CONTROLLER_ID] = { sync: syncTrigger };

  var OWNER = '.header--classic #header .header__menu-items > .navbar-item.has-dropdown:not(.has-mega-menu)';
  var CLOSED = 'msg-nav-escape-closed';
  var OTHER_OWNER = '.has-mega-menu, .mega-menu, .fancybox-container, [role="dialog"], [role="alertdialog"], [aria-modal="true"], dialog, ' +
    'form, [data-disclosure], [data-show-search-trigger], .mobile-search, [data-search-type="overlay"], ' +
    '#mobile-header, #mobile-menu, input, textarea, select, video, audio, [contenteditable="true"], ' +
    '[role="combobox"], [role="listbox"], [role="menu"], [role="tree"]';

  function desktop() {
    return window.matchMedia('(min-width: 799px)').matches;
  }

  function owner(target) {
    return target && target.closest ? target.closest(OWNER) : null;
  }

  function panel(wrap) {
    return Array.from(wrap.children).find(function (child) {
      return child.classList.contains('navbar-dropdown');
    });
  }

  function trigger(wrap) {
    var label = Array.from(wrap.children).find(function (child) { return child.tagName === 'LABEL'; });
    return label && label.querySelector('a.navbar-link[aria-haspopup="true"]');
  }

  function visible(element) {
    if (!element || !element.isConnected) return false;
    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.visibility !== 'collapse' &&
      Array.from(element.getClientRects()).some(function (rect) { return rect.width > 0 && rect.height > 0; });
  }

  function opened(wrap) {
    return wrap && !wrap.classList.contains(CLOSED) && visible(trigger(wrap)) && visible(panel(wrap));
  }

  function syncTrigger(link) {
    var wrap = owner(link);
    if (wrap && trigger(wrap) === link) link.setAttribute('aria-expanded', opened(wrap) ? 'true' : 'false');
  }

  function close(wrap) {
    var link = trigger(wrap);
    var returnFocus = wrap.contains(document.activeElement);
    wrap.classList.add(CLOSED);
    wrap.classList.remove('show-dropdown', 'is-opened');
    panel(wrap).classList.remove('show-nested-dropdown');
    wrap.querySelectorAll('.has-submenu input[type="checkbox"], input.no-js-main-navigation[type="radio"]').forEach(function (input) {
      input.checked = false;
    });
    link.setAttribute('aria-expanded', 'false');
    if (returnFocus && visible(link)) {
      // Placeholder links may have no href. Keep temporary programmatic focus
      // support until blur, without adding them to the sequential tab order.
      var temporaryTabIndex = link.tabIndex < 0 && !link.hasAttribute('tabindex');
      var cleanup = function () {
        if (temporaryTabIndex && link.getAttribute('tabindex') === '-1') link.removeAttribute('tabindex');
        link.removeEventListener('blur', cleanup);
      };
      if (temporaryTabIndex) {
        link.setAttribute('tabindex', '-1');
        link.addEventListener('blur', cleanup, { once: true });
      }
      link.focus({ preventScroll: true });
      if (temporaryTabIndex && document.activeElement !== link) cleanup();
    }
  }

  // Bubble at window: descendants and Search get the first chance to own Escape.
  window.addEventListener('keydown', function (event) {
    if ((event.key !== 'Escape' && event.code !== 'Escape') || event.repeat || event.isComposing ||
        event.defaultPrevented || !desktop() || document.fullscreenElement || document.webkitFullscreenElement) return;
    var target = event.target;
    if (!target || !target.isConnected || !target.closest || target.isContentEditable || target.closest(OTHER_OWNER) ||
        (event.composedPath && event.composedPath()[0] !== target)) return;
    // Closed-shadow widgets can retarget Escape to their host; leave them alone.
    for (var ancestor = target; ancestor; ancestor = ancestor.parentElement) {
      if (ancestor.localName && ancestor.localName.indexOf('-') !== -1) return;
    }
    var wrap = owner(target);
    var nearestDropdown = target.closest('.has-dropdown');
    if (nearestDropdown && nearestDropdown !== wrap) return;
    if (!opened(wrap)) {
      // Only a truly hovered, visible classic dropdown may dismiss from elsewhere.
      wrap = Array.from(document.querySelectorAll(OWNER)).find(function (candidate) {
        return candidate.matches(':hover') && opened(candidate);
      });
    }
    if (!wrap) return;
    event.preventDefault();
    close(wrap);
  });

  // Moving among descendants is not a new pointer entry after Escape.
  document.addEventListener('mouseover', function (event) {
    var wrap = owner(event.target);
    if (!desktop() || !wrap || wrap.contains(event.relatedTarget)) return;
    wrap.classList.remove(CLOSED);
    if (opened(wrap)) trigger(wrap).setAttribute('aria-expanded', 'true');
  }, true);

  // Explicit trigger clicks retain the theme's original navigation/click-mode logic.
  document.addEventListener('click', function (event) {
    var wrap = owner(event.target);
    var link = wrap && trigger(wrap);
    if (desktop() && link && link.contains(event.target) && wrap.classList.contains(CLOSED)) {
      wrap.classList.remove(CLOSED);
      window.setTimeout(function () { if (link.isConnected) syncTrigger(link); }, 0);
    }
  }, true);

  function reset(root) {
    root.querySelectorAll(OWNER).forEach(function (wrap) { wrap.classList.remove(CLOSED); });
  }

  // Delegation retains no detached menu nodes and covers replacement sections.
  document.addEventListener('shopify:section:unload', function (event) { reset(event.target); }, true);
  window.addEventListener('resize', function () { if (!desktop()) reset(document); });
})();

/* R55: measured Text Club focus-scroll clearance. Provider nodes are read-only. */
(function () {
  'use strict';
  var ID = 'msgR55TextClubClearance';
  if (window[ID]) return;
  window[ID] = true;

  var HOST = '#template-page .klaviyo-form-KARvdB';
  var TEASER = '.kl-teaser-WUte2K';
  var PROPERTY = '--msg-textclub-teaser-clearance';
  var running = false;
  var host = null;
  var teasers = [];
  var body = null;
  var root = null;
  var media = null;
  var viewport = null;
  var discovery = null;
  var attributes = null;
  var sizes = null;
  var frame = null;
  var dirty = true;
  var animationUntil = 0;
  var owned = false;
  var displaced = false;
  var previousValue = '';
  var previousPriority = '';
  var lastValue = '';

  function release() {
    if (owned && root.style.getPropertyValue(PROPERTY) === lastValue &&
        root.style.getPropertyPriority(PROPERTY) === '') {
      if (previousValue) root.style.setProperty(PROPERTY, previousValue, previousPriority);
      else root.style.removeProperty(PROPERTY);
    } else if (owned) {
      displaced = true;
    }
    owned = false;
    previousValue = previousPriority = lastValue = '';
  }

  function write(value) {
    var current = root.style.getPropertyValue(PROPERTY);
    var priority = root.style.getPropertyPriority(PROPERTY);
    // Yield ownership if another author changes this property while we own it.
    if (owned && (current !== lastValue || priority !== '')) {
      owned = false;
      displaced = true;
    }
    if (displaced) return;
    if (!owned) {
      previousValue = current;
      previousPriority = priority;
      owned = true;
    }
    lastValue = value;
    if (current !== value || priority !== '') root.style.setProperty(PROPERTY, value);
  }

  function sameNodes(a, b) {
    return a.length === b.length && a.every(function (node, index) { return node === b[index]; });
  }

  function schedule(rescan) {
    if (!running) return;
    if (rescan === true) dirty = true;
    if (frame === null) frame = window.requestAnimationFrame(function () { frame = null; flush(); });
  }

  function refresh() {
    dirty = false;
    var nextHost = document.querySelector(HOST);
    var nextTeasers = nextHost ? Array.from(document.querySelectorAll(TEASER)).filter(function (node) {
      return node.isConnected;
    }) : [];
    var identityChanged = nextHost !== host || !sameNodes(nextTeasers, teasers);
    host = nextHost;
    teasers = nextTeasers;
    if (identityChanged) animationUntil = 0;
    // Rebind after reparenting even when the teaser node itself is unchanged.
    if (identityChanged) sizes.disconnect();
    attributes.disconnect();
    // Root style is deliberately not observed: writing our property cannot loop.
    attributes.observe(body, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    var seen = [body];
    if (host) {
      attributes.observe(host, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
      seen.push(host);
    }
    teasers.forEach(function (teaser) {
      if (identityChanged) sizes.observe(teaser);
      for (var node = teaser; node && node !== body && node !== root; node = node.parentElement) {
        if (seen.indexOf(node) !== -1) continue;
        seen.push(node);
        attributes.observe(node, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
      }
    });
    if (!host) release();
  }

  function measure() {
    if (!host || !host.isConnected || !host.matches(HOST) || !media.matches) {
      animationUntil = 0;
      release();
      return;
    }
    if (body.classList.contains('klaviyo-prevent-body-scrolling')) {
      animationUntil = 0;
      write('0px');
      return;
    }
    var height = window.innerHeight;
    var width = window.innerWidth;
    var top = 0;
    var bottom = height;
    var left = 0;
    var right = width;
    if (viewport && Number.isFinite(viewport.height) && viewport.height > 0 &&
        Number.isFinite(viewport.offsetTop)) {
      top = Math.max(0, viewport.offsetTop);
      bottom = Math.min(height, viewport.offsetTop + viewport.height);
    }
    if (viewport && Number.isFinite(viewport.width) && viewport.width > 0 &&
        Number.isFinite(viewport.offsetLeft)) {
      left = Math.max(0, viewport.offsetLeft);
      right = Math.min(width, viewport.offsetLeft + viewport.width);
    }
    if (!Number.isFinite(height) || !Number.isFinite(width) || height <= 0 || width <= 0 || bottom <= top || right <= left) {
      write('0px');
      return;
    }
    var occupied = 0;
    teasers.forEach(function (teaser) {
      if (!teaser.isConnected || !teaser.matches(TEASER)) return;
      var rect = teaser.getBoundingClientRect();
      var style = window.getComputedStyle(teaser);
      if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' ||
          !Number.isFinite(rect.top) || !Number.isFinite(rect.bottom) || !Number.isFinite(rect.left) ||
          !Number.isFinite(rect.right) || rect.width <= 0 || rect.height <= 0 ||
          rect.right <= left || rect.left >= right || rect.bottom <= top || rect.top >= bottom) return;
      // Reserve the painted rectangle through opacity fades, including delayed fades.
      occupied = Math.max(occupied, bottom - Math.max(top, rect.top));
    });
    // Preserve the tested 80px normal-teaser floor; grow from actual lower-view occupancy.
    // The viewport cap limits impossible/full-screen obstructions, not a visibility claim.
    var clearance = occupied > 0 ? Math.min(bottom - top, Math.max(80, Math.ceil(occupied) + 8)) : 0;
    write(clearance + 'px');
  }

  function flush() {
    if (frame !== null) { window.cancelAnimationFrame(frame); frame = null; }
    if (!running) return;
    if (dirty) refresh();
    measure();
    if (host && media.matches && teasers.length && Date.now() < animationUntil) schedule(false);
  }

  function relevant(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node === host || node.matches(HOST + ', ' + TEASER)) return true;
    if (host && node.contains(host)) return true;
    if (teasers.some(function (teaser) { return node === teaser || node.contains(teaser); })) return true;
    return Boolean(node.querySelector(HOST + ', ' + TEASER));
  }

  function changed(records) {
    if ((host && !host.isConnected) || teasers.some(function (node) { return !node.isConnected; })) {
      schedule(true);
      return;
    }
    // Child-list discovery only. No document-wide attribute observer or polling loop.
    for (var i = 0; i < records.length; i += 1) {
      var record = records[i];
      if ((record.target.matches && record.target.matches(TEASER)) ||
          Array.from(record.addedNodes).some(relevant) || Array.from(record.removedNodes).some(relevant)) {
        schedule(true);
        return;
      }
    }
  }

  function motionTarget(node) {
    return node && node.nodeType === 1 && teasers.some(function (teaser) {
      return node === teaser || node.contains(teaser);
    });
  }

  function milliseconds(value) {
    return String(value || '').split(',').map(function (part) {
      var parsed = parseFloat(part);
      return Number.isFinite(parsed) ? Math.max(0, parsed * (part.trim().endsWith('ms') ? 1 : 1000)) : 0;
    });
  }

  function motionStart(event) {
    if (!motionTarget(event.target)) return;
    var style = window.getComputedStyle(event.target);
    var duration = Math.max.apply(Math, milliseconds(style.transitionDuration).concat(milliseconds(style.animationDuration)));
    var delay = Math.max.apply(Math, milliseconds(style.transitionDelay).concat(milliseconds(style.animationDelay)));
    // A short, event-started exact-teaser geometry watch covers finite UI transitions.
    // Long/infinite provider animation is not treated as permission for permanent polling.
    animationUntil = Math.max(animationUntil, Date.now() + Math.min(2000, duration + delay + 50));
    schedule(false);
  }

  function motionEnd(event) {
    if (motionTarget(event.target)) schedule(false);
  }

  function tab(event) {
    // Refresh before the browser's native Tab scroll, never move focus or cancel the key.
    if (event.key === 'Tab' && !event.isComposing) {
      // Also recover class-only provider promotion without watching all page attributes.
      dirty = true;
      flush();
    }
  }

  function resized() { schedule(false); }
  function viewportChanged() { schedule(true); }
  function appearance(records) {
    schedule(records.some(function (record) { return record.attributeName === 'class'; }));
  }

  function start() {
    var textClubRoute = /\/pages\/text-club\/?$/.test(window.location.pathname);
    if (running || !document.body || (!document.querySelector(HOST) && !textClubRoute) ||
        typeof window.ResizeObserver !== 'function' || typeof window.MutationObserver !== 'function' ||
        typeof window.requestAnimationFrame !== 'function' || typeof window.matchMedia !== 'function') return;
    body = document.body;
    root = document.documentElement;
    media = window.matchMedia('(max-width: 798px)');
    viewport = window.visualViewport || null;
    displaced = false;
    running = true;
    dirty = true;
    discovery = new window.MutationObserver(changed);
    attributes = new window.MutationObserver(appearance);
    sizes = new window.ResizeObserver(resized);
    discovery.observe(body, { childList: true, subtree: true });
    window.addEventListener('resize', viewportChanged);
    window.addEventListener('scroll', resized, { passive: true });
    document.addEventListener('keydown', tab, true);
    document.addEventListener('transitionrun', motionStart, true);
    document.addEventListener('animationstart', motionStart, true);
    document.addEventListener('transitionend', motionEnd, true);
    document.addEventListener('transitioncancel', motionEnd, true);
    document.addEventListener('animationend', motionEnd, true);
    document.addEventListener('animationcancel', motionEnd, true);
    if (media.addEventListener) media.addEventListener('change', viewportChanged);
    else media.addListener(viewportChanged);
    if (viewport) {
      viewport.addEventListener('resize', viewportChanged);
      viewport.addEventListener('scroll', viewportChanged);
    }
    flush();
  }

  function stop() {
    if (!running) return;
    running = false;
    if (frame !== null) { window.cancelAnimationFrame(frame); frame = null; }
    discovery.disconnect();
    attributes.disconnect();
    sizes.disconnect();
    window.removeEventListener('resize', viewportChanged);
    window.removeEventListener('scroll', resized);
    document.removeEventListener('keydown', tab, true);
    document.removeEventListener('transitionrun', motionStart, true);
    document.removeEventListener('animationstart', motionStart, true);
    document.removeEventListener('transitionend', motionEnd, true);
    document.removeEventListener('transitioncancel', motionEnd, true);
    document.removeEventListener('animationend', motionEnd, true);
    document.removeEventListener('animationcancel', motionEnd, true);
    if (media.removeEventListener) media.removeEventListener('change', viewportChanged);
    else media.removeListener(viewportChanged);
    if (viewport) {
      viewport.removeEventListener('resize', viewportChanged);
      viewport.removeEventListener('scroll', viewportChanged);
    }
    release();
    host = body = root = media = viewport = discovery = attributes = sizes = null;
    teasers = [];
    animationUntil = 0;
  }

  document.addEventListener('shopify:section:unload', function (event) {
    if (host && event.target && (event.target === host || event.target.contains(host))) stop();
  }, true);
  document.addEventListener('shopify:section:load', start, true);
  window.addEventListener('pagehide', stop);
  window.addEventListener('pageshow', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

/* B117: remember a presented footer email error during this form's focus session.
 * Native validity is only a release signal. Provider validation/requests stay owned
 * by Klaviyo; this helper never submits, validates, focuses, or changes field data. */
(function () {
  'use strict';
  var ID = 'msgB117FooterErrorLifecycle';
  if (window[ID]) return;
  window[ID] = true;

  var FORM = 'footer.footer__container form[data-testid="klaviyo-form-TVVGYP"]';
  var EMAIL = 'input[type="email"][name="email"]';
  var MARKER = 'data-msg-footer-email-correcting';
  var markerRoot = document.documentElement;
  var running = false;
  var form = null;
  var footer = null;
  var email = null;
  var observer = null;
  var ancestors = [];
  var latched = false;
  var lastInvalid = false;
  var owned = false;
  var displaced = false;
  var queued = false;
  var generation = 0;
  var focusTimer = null;
  var pendingRecords = [];

  function releaseMarker() {
    if (owned && markerRoot && markerRoot.getAttribute(MARKER) === 'true') markerRoot.removeAttribute(MARKER);
    owned = false;
  }

  function mark() {
    if (owned && markerRoot.getAttribute(MARKER) !== 'true') {
      owned = false;
      displaced = true;
    }
    if (!latched || displaced) { releaseMarker(); return; }
    if (!owned) {
      // This private attribute is ours only when absent. Never replace another value.
      if (markerRoot.hasAttribute(MARKER)) { displaced = true; return; }
      markerRoot.setAttribute(MARKER, 'true');
      owned = true;
    }
  }

  function reset() {
    cancelFocusWait();
    releaseMarker();
    if (observer) observer.disconnect();
    form = footer = email = null;
    ancestors = [];
    pendingRecords = [];
    latched = lastInvalid = displaced = false;
  }

  function parentChain(node) {
    var chain = [];
    for (var parent = node.parentElement; parent; parent = parent.parentElement) chain.push(parent);
    return chain;
  }

  function bind(chain) {
    observer.disconnect();
    observer.observe(form, {
      childList: true, subtree: true, attributes: true, attributeOldValue: true,
      attributeFilter: ['aria-invalid', 'type', 'name', 'data-testid']
    });
    // Direct ancestor child lists catch removal/reparenting without observing the
    // whole document subtree. Attribute observation stays in the exact footer.
    chain.forEach(function (node) {
      var options = { childList: true };
      if (node === footer) { options.attributes = true; options.attributeFilter = ['class']; }
      observer.observe(node, options);
    });
    ancestors = chain;
  }

  function nativelyValid(input) {
    return input.value.trim() !== '' && input.validity && input.validity.valid;
  }

  function newErrorFor(input, previous, records) {
    var newError = false;
    var precedingInvalid = previous;
    // Reconstruct intervening error states, including true->false before delivery.
    records.forEach(function (record) {
      if (record.type !== 'attributes' || record.target !== input || record.attributeName !== 'aria-invalid') return;
      var wasInvalid = record.oldValue === 'true';
      if (wasInvalid && !precedingInvalid) newError = true;
      precedingInvalid = wasInvalid;
    });
    return newError || (input.getAttribute('aria-invalid') === 'true' && !precedingInvalid);
  }

  function sync(records, settled) {
    if (!running) return;
    records = pendingRecords.concat(records || [], observer.takeRecords());
    pendingRecords = [];
    // Native blur/focus delivery can drain microtasks while activeElement is BODY,
    // before the next focusin. Keep records and state until that transition settles.
    if (focusTimer !== null) { pendingRecords = records; return; }
    var active = document.activeElement;
    var nextForm = active && active.closest ? active.closest('footer.footer__container form') : null;
    if (!nextForm || !nextForm.isConnected) {
      // An earlier provider blur listener can queue a mutation before our focusout
      // listener runs. BODY/null alone cannot prove this focus session has ended.
      if (!settled && form && (!active || active === document.body || active === markerRoot)) {
        pendingRecords = records;
        focusTimer = window.setTimeout(function () {
          focusTimer = null;
          sync(null, true); // Forced settlement cannot defer itself again.
        }, 0);
        return;
      }
      reset();
      return;
    }
    var forms = nextForm.matches(FORM) ? document.querySelectorAll(FORM) : [];
    var inputs = nextForm.querySelectorAll(EMAIL);
    var nextFooter = nextForm.closest('footer.footer__container');
    var nextEmail = inputs[0];
    // An old bound Email can present and clear an error just before replacement.
    // Preserve those pending records only across this uninterrupted focus session.
    var remembered = latched || (email && email !== nextEmail &&
      newErrorFor(email, lastInvalid, records) && !nativelyValid(email));
    var chain = parentChain(nextForm);
    var rebind = nextForm !== form || chain.length !== ancestors.length ||
      chain.some(function (node, index) { return node !== ancestors[index]; });
    if (nextForm !== form) {
      // Preserve a same-footer atomic provider replacement only when focus is
      // already in its replacement. A settled departure/removal ends the session.
      var carry = remembered && form && !form.isConnected && nextFooter === footer;
      reset();
      form = nextForm;
      footer = nextFooter;
      latched = Boolean(carry);
    } else {
      latched = Boolean(remembered);
    }
    footer = nextFooter;
    if (rebind) bind(chain);
    // Watch a focused footer form during provider identity hydration, but never
    // latch or write until both the exact form and its Email are unambiguous.
    if (forms.length !== 1 || inputs.length !== 1) {
      releaseMarker();
      email = null;
      latched = lastInvalid = false;
      return;
    }
    if (nextEmail !== email) { email = nextEmail; lastInvalid = false; }
    var invalid = email.getAttribute('aria-invalid') === 'true';
    var newError = newErrorFor(email, lastInvalid, records);
    lastInvalid = invalid;
    // A stale true attribute after native-valid release is not a new error.
    if (nativelyValid(email)) latched = false;
    else if (newError) latched = true;
    mark();
  }

  function changed(records) { sync(records); }

  function schedule() {
    if (!running || queued) return;
    queued = true;
    var token = generation;
    Promise.resolve().then(function () {
      if (token !== generation) return;
      queued = false;
      sync();
    });
  }

  function cancelFocusWait() {
    if (focusTimer !== null) window.clearTimeout(focusTimer);
    focusTimer = null;
  }

  function focusIn() { cancelFocusWait(); sync(); }
  function focusOut(event) {
    // A known destination outside the exact form is a completed departure, even
    // when script sends focus back later in the same task. Internal Tab is retained.
    if (form && event.relatedTarget && !form.contains(event.relatedTarget)) reset();
    schedule();
  }
  function edited(event) {
    if (!event.target || !event.target.closest || !event.target.closest('footer.footer__container form')) return;
    // Capture sees presented error before a bubbling provider input handler clears
    // it. The deferred pass reads the provider's resulting state without mutation.
    sync();
    schedule();
  }

  function start() {
    if (running || !document.body || typeof window.MutationObserver !== 'function') return;
    observer = new window.MutationObserver(changed);
    running = true;
    document.addEventListener('focusin', focusIn, true);
    document.addEventListener('focusout', focusOut, true);
    document.addEventListener('input', edited, true);
    document.addEventListener('change', edited, true);
    document.addEventListener('invalid', edited, true);
    sync();
  }

  function stop() {
    if (!running) return;
    running = false;
    generation += 1;
    queued = false;
    reset();
    observer = null;
    document.removeEventListener('focusin', focusIn, true);
    document.removeEventListener('focusout', focusOut, true);
    document.removeEventListener('input', edited, true);
    document.removeEventListener('change', edited, true);
    document.removeEventListener('invalid', edited, true);
  }

  window.addEventListener('pagehide', stop);
  window.addEventListener('pageshow', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

/* B162: recover only disappearing classic-footer country focus at min799.
 * Country values, submissions, locale/currency and other disclosure owners stay
 * with the existing theme. Recovery returns to the new, closed country toggle. */
(function () {
  'use strict';
  var ID = 'msgB162FooterCountryResize';
  if (window[ID]) return;
  window[ID] = true;
  var media = null, desktop = null, running = false;
  var lastFocus = null, pending = null, frame = null, generation = 0;
  var COUNTRY = '.footer-classic__disclosure > form.selectors-form > .localization [data-disclosure-country] > button[data-disclosure-toggle]';
  var OTHER_OWNER = '.fancybox-container, [role="dialog"], [role="alertdialog"], [aria-modal="true"], dialog, ' +
    '.search-overlay, .mobile-search, .ajax-cart, iframe, object, embed, [contenteditable="true"]';
  var DIALOG = '.fancybox-container, [role="dialog"], [role="alertdialog"], [aria-modal="true"], dialog[open]';

  // B175: a visibility lease exists only after this helper's boundary handoff or
  // a verified shared country Escape return. It never grants focus ownership.
  var revealOwner = null, revealFrame = null, revealTicket = null, revealEpoch = 0;
  var revealViewport = null, ownScroll = null;
  function clearReveal() {
    revealEpoch += 1;
    if (revealFrame !== null) window.cancelAnimationFrame(revealFrame);
    revealFrame = null;
    revealTicket = revealOwner = revealViewport = ownScroll = null;
  }
  function viewportBox() {
    var width = window.innerWidth, height = window.innerHeight, v = window.visualViewport;
    var left = 0, top = 0, right = width, bottom = height;
    if (v) {
      if (![v.width, v.height, v.offsetLeft, v.offsetTop].every(Number.isFinite) || v.width <= 0 || v.height <= 0) return null;
      left = Math.max(0, v.offsetLeft); top = Math.max(0, v.offsetTop);
      right = Math.min(width, v.offsetLeft + v.width); bottom = Math.min(height, v.offsetTop + v.height);
    }
    if (![left, top, right, bottom].every(Number.isFinite) || right <= left || bottom <= top) return null;
    return { left: left, top: top, right: right, bottom: bottom,
      signature: [width, height, v && v.width, v && v.height, v && v.scale].join(':') };
  }
  function rootPosition() { return { x: window.scrollX, y: window.scrollY }; }
  function samePosition(a, b) { return a && b && a.x === b.x && a.y === b.y; }
  function currentRevealOwner() {
    return running && revealOwner && !blocked() && document.activeElement === revealOwner.toggle &&
      sameOwner(owner(revealOwner.toggle), revealOwner) && revealOwner.desktop === media.matches &&
      !revealOwner.toggle.disabled && visible(revealOwner.toggle) &&
      revealOwner.toggle.getAttribute('aria-expanded') === 'false' &&
      revealOwner.toggle.hasAttribute('data-msg-disclosure-escape-closed') &&
      destination(revealOwner, media.matches) === revealOwner.toggle;
  }
  function revealGeometry() {
    var target = revealOwner.toggle, box = viewportBox();
    if (!box) return null;
    var rect = target.getBoundingClientRect(), style = window.getComputedStyle(target);
    if (![rect.left, rect.top, rect.right, rect.bottom, rect.width, rect.height].every(Number.isFinite) || rect.width <= 0 || rect.height <= 0) return null;
    // A four-CSS-pixel floor also covers fractional-edge rounding. Larger author
    // outlines retain their actual positive outward extent; no CSS is changed.
    var outline = style.outlineStyle !== 'none' ? Math.max(0, (parseFloat(style.outlineWidth) || 0) + (parseFloat(style.outlineOffset) || 0)) : 0;
    var gap = Math.max(4, outline + 2), top = box.top + gap, bottom = box.bottom - gap;
    if (rect.left - gap < box.left || rect.right + gap > box.right) return null;
    // Do not make scrollIntoView move unknown nested scrollers or fixed content.
    for (var node = target; node && node !== document.body && node !== document.documentElement; node = node.parentElement) {
      var s = window.getComputedStyle(node);
      if (s.position === 'fixed' || s.position === 'sticky' ||
          (/(auto|scroll|hidden|clip)/.test(s.overflowY) && node.scrollHeight > node.clientHeight)) return null;
    }
    // Read only the already-known teaser's live paint box, never provider state.
    Array.from(document.querySelectorAll('.kl-teaser-WUte2K')).forEach(function (teaser) {
      if (!visible(teaser)) return;
      var r = teaser.getBoundingClientRect();
      if (![r.left, r.top, r.right, r.bottom].every(Number.isFinite) || r.width <= 0 || r.height <= 0 ||
          r.right <= rect.left - gap || r.left >= rect.right + gap || r.bottom <= box.top || r.top >= box.bottom) return;
      bottom = Math.min(bottom, r.top - gap);
    });
    if (bottom - top < rect.height) return null;
    var delta = rect.top < top ? rect.top - top : rect.bottom > bottom ? rect.bottom - bottom : 0;
    var root = document.scrollingElement;
    if (!root || !Number.isFinite(root.scrollHeight) || !Number.isFinite(root.clientHeight)) return null;
    var current = rootPosition(), max = Math.max(0, root.scrollHeight - root.clientHeight);
    var y = Math.max(0, Math.min(max, current.y + delta));
    // Do not pretend root-end clamping can reveal a target which cannot fit.
    if (rect.top - (y - current.y) < top || rect.bottom - (y - current.y) > bottom) return null;
    return { x: current.x, y: y, delta: y - current.y, viewport: box };
  }
  function queueReveal(reason) {
    if (!currentRevealOwner()) { clearReveal(); return; }
    var box = viewportBox(), position = rootPosition();
    if (!box || ![position.x, position.y].every(Number.isFinite)) { clearReveal(); return; }
    revealEpoch += 1;
    if (revealFrame !== null) window.cancelAnimationFrame(revealFrame);
    revealViewport = box.signature;
    var ticket = { epoch: revealEpoch, owner: revealOwner, position: position, signature: box.signature, reason: reason };
    revealTicket = ticket;
    function valid() {
      var now = viewportBox();
      return revealTicket === ticket && ticket.epoch === revealEpoch && revealOwner === ticket.owner &&
        currentRevealOwner() && now && now.signature === ticket.signature && samePosition(rootPosition(), ticket.position);
    }
    revealFrame = window.requestAnimationFrame(function () {
      revealFrame = null;
      if (revealTicket !== ticket || ticket.epoch !== revealEpoch) return;
      if (!valid()) { clearReveal(); return; }
      revealFrame = window.requestAnimationFrame(function () {
        revealFrame = null;
        if (revealTicket !== ticket || ticket.epoch !== revealEpoch) return;
        if (!valid()) { clearReveal(); return; }
        revealTicket = null;
        var geometry = revealGeometry();
        if (!geometry) { clearReveal(); return; }
        if (geometry.delta === 0) return;
        // Exactly one nearest vertical root correction, never animated/chased.
        ownScroll = { x: geometry.x, y: geometry.y };
        window.scrollTo({ left: geometry.x, top: geometry.y, behavior: 'instant' });
        var actual = rootPosition();
        // CSSOM scroll positions can quantize to device pixels. Accept only the
        // sub-pixel rounding of this one correction, then record exact results.
        if (!actual || !Number.isFinite(actual.x) || !Number.isFinite(actual.y) ||
            Math.abs(actual.x - geometry.x) > 0.5 || Math.abs(actual.y - geometry.y) > 0.5) clearReveal();
        else ownScroll = actual;
      });
    });
  }
  function armReveal(target, reason) {
    clearReveal();
    revealOwner = owner(target);
    if (!revealOwner || revealOwner.element !== revealOwner.toggle) { clearReveal(); return; }
    queueReveal(reason);
  }
  function resizeReveal() {
    if (!revealOwner) return;
    var box = viewportBox();
    if (!box || !currentRevealOwner()) { clearReveal(); return; }
    // Visual-viewport panning alone is not a resize entitlement.
    if (box.signature !== revealViewport) queueReveal('viewport-resize');
  }
  function scrollReveal() {
    if (!revealOwner) return;
    if (samePosition(rootPosition(), ownScroll)) { ownScroll = null; return; }
    // A scroll delivered after synchronous layout/focus but at the exact captured
    // position is harmless; every changed position revokes the queued request.
    if (revealTicket && samePosition(rootPosition(), revealTicket.position)) return;
    clearReveal();
  }
  function panReveal() { clearReveal(); }
  function keyReveal(event) {
    var modifier = event.key === 'Control' || event.key === 'Meta' || event.key === 'Shift';
    var zoom = (event.ctrlKey || event.metaKey) && !event.altKey && ['+', '=', '-', '_', '0'].indexOf(event.key) !== -1;
    if (!modifier && !zoom) clearReveal();
  }
  function escapeReveal(event) {
    if ((event.key !== 'Escape' && event.which !== 27) || event.repeat || event.isComposing || event.defaultPrevented ||
        event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
    // Body's retained Escape handlers have already run. event.target identifies
    // the original country owner even when its option is now collapsed/hidden.
    var source = owner(event.target);
    if (!source || document.activeElement !== source.toggle) return;
    armReveal(source.toggle, 'escape-return');
  }

  function visible(element) {
    if (!element || !element.isConnected || element.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.visibility !== 'collapse' &&
      Array.from(element.getClientRects()).some(function (rect) { return rect.width > 0 && rect.height > 0; });
  }
  function owner(element) {
    if (!element || !element.isConnected || !element.closest || element.shadowRoot || element.closest(OTHER_OWNER)) return null;
    for (var ancestor = element; ancestor && ancestor !== document.body; ancestor = ancestor.parentElement) {
      if (ancestor.localName && ancestor.localName.indexOf('-') !== -1) return null;
    }
    var disclosure = element.closest('.disclosure[data-disclosure-country]');
    var localization = disclosure && disclosure.closest('.localization');
    var form = localization && localization.parentElement;
    var group = form && form.parentElement;
    var footer = group && group.closest('.footer--classic footer.footer__container');
    if (!footer || !form.matches('form.selectors-form') || !group.matches('.footer-classic__disclosure') ||
        !localization.contains(disclosure)) return null;
    var mobile = localization.matches('.selectors-form--mobile.is-hidden-desktop-only');
    var classic = localization.matches('.footer-menu__disclosure.is-hidden-mobile-only');
    if (mobile === classic) return null;
    var toggle = disclosure.querySelector(':scope > button.disclosure__toggle--country[data-disclosure-toggle][type="button"]');
    if (!toggle || (element !== toggle && !element.matches('button.disclosure__button[type="submit"][name="country_code"]'))) return null;
    return { element: element, toggle: toggle, localization: localization, footer: footer, desktop: classic };
  }
  function sameOwner(a, b) {
    return a && b && a.element === b.element && a.toggle === b.toggle && a.localization === b.localization &&
      a.footer === b.footer && a.desktop === b.desktop;
  }
  function cancelPending() {
    generation += 1;
    if (frame !== null) window.cancelAnimationFrame(frame);
    frame = null;
    pending = null;
  }
  function forget() { lastFocus = null; cancelPending(); clearReveal(); }
  function remember(event) {
    clearReveal();
    // A new focus owner always wins over any queued resize recovery.
    cancelPending();
    var current = owner(event.target);
    lastFocus = current && current.desktop === media.matches && visible(current.toggle) ? current : null;
  }
  function focusOut(event) {
    if (revealOwner && event.target === revealOwner.toggle) clearReveal();
    if (!lastFocus || event.target !== lastFocus.element) return;
    if (event.relatedTarget || visible(lastFocus.toggle) || lastFocus.desktop === media.matches) forget();
    // Only native loss to BODY while the remembered branch disappears survives.
  }
  function blocked() {
    return !document.hasFocus() || document.fullscreenElement || document.webkitFullscreenElement ||
      document.body.classList.contains('klaviyo-prevent-body-scrolling') ||
      Array.from(document.querySelectorAll(DIALOG)).some(visible);
  }
  function destination(source, next) {
    var targets = Array.from(source.footer.querySelectorAll(COUNTRY)).filter(function (toggle) {
      var current = owner(toggle);
      return current && current.desktop === next && !toggle.disabled && visible(toggle);
    });
    // Hidden row copies and malformed/multiple visible owners cannot be guessed.
    return targets.length === 1 ? targets[0] : null;
  }
  function collapse(toggle) {
    toggle.classList.remove('is-clicked');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('data-msg-disclosure-escape-closed', '');
    var wrap = toggle.nextElementSibling;
    if (wrap && wrap.matches('.disclosure__list-wrap')) wrap.classList.remove('disclosure--left');
  }
  function recover(ticket) {
    if (pending !== ticket) return true;
    var active = document.activeElement;
    var bodyFallback = active === document.body || active === document.documentElement;
    if (!running || media.matches !== ticket.next || blocked() ||
        !sameOwner(owner(ticket.source.element), ticket.source) || visible(ticket.source.toggle) ||
        (active !== ticket.source.element && !bodyFallback)) { forget(); return true; }
    var target = destination(ticket.source, ticket.next);
    if (!target) return false;
    cancelPending();
    collapse(ticket.source.toggle);
    collapse(target);
    // Reuse the existing Escape-focus guard, including repeated disclosure.enable
    // bindings. Do not call shared closeDisclosures or synthesize a click/change.
    var $target = $(target);
    $target.data('msgEscapeFocusReturn', true);
    try { target.focus(); } finally { $target.removeData('msgEscapeFocusReturn'); }
    if (document.activeElement === target) armReveal(target, 'boundary-handoff');
    return true;
  }
  function resize() {
    var next = media.matches;
    if (next === desktop) { resizeReveal(); return; }
    clearReveal();
    var previous = desktop;
    desktop = next;
    cancelPending();
    var active = document.activeElement;
    var source = owner(active);
    if (!source && (active === document.body || active === document.documentElement)) source = lastFocus;
    lastFocus = null;
    if (!source || source.desktop !== previous || !sameOwner(owner(source.element), source) || visible(source.toggle) || blocked()) return;
    var ticket = { source: source, next: next };
    pending = ticket;
    if (recover(ticket)) return;
    // One cancellable layout-frame retry only; no persistent focus request.
    var token = generation;
    frame = window.requestAnimationFrame(function () {
      frame = null;
      if (token !== generation || pending !== ticket) return;
      recover(ticket);
      if (pending === ticket) forget();
    });
  }
  function pointer(event) {
    clearReveal();
    if (!lastFocus || !lastFocus.element.contains(event.target)) forget();
  }
  function key(event) {
    keyReveal(event);
    if (pending || (lastFocus && document.activeElement !== lastFocus.element)) forget();
  }
  function sectionChanged(event) {
    var root = event.target;
    if (revealOwner && root && root.contains && root.contains(revealOwner.footer)) clearReveal();
    if (root && root.contains && ((lastFocus && root.contains(lastFocus.footer)) ||
        (pending && root.contains(pending.source.footer)))) forget();
  }
  function start() {
    if (running || !document.body || typeof window.matchMedia !== 'function' ||
        typeof window.requestAnimationFrame !== 'function') return;
    media = window.matchMedia('(min-width: 799px)');
    desktop = media.matches;
    running = true;
    document.addEventListener('focusin', remember, true);
    document.addEventListener('focusout', focusOut, true);
    document.addEventListener('pointerdown', pointer, true);
    document.addEventListener('keydown', key, true);
    document.addEventListener('shopify:section:unload', sectionChanged, true);
    document.addEventListener('shopify:section:load', sectionChanged, true);
    window.addEventListener('blur', forget);
    window.addEventListener('resize', resize);
    document.addEventListener('keyup', escapeReveal);
    document.addEventListener('wheel', panReveal, { passive: true, capture: true });
    document.addEventListener('touchstart', panReveal, { passive: true, capture: true });
    window.addEventListener('scroll', scrollReveal, true);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', resizeReveal);
      window.visualViewport.addEventListener('scroll', panReveal);
    }
    if (media.addEventListener) media.addEventListener('change', resize);
    else media.addListener(resize);
    remember({ target: document.activeElement });
  }
  function stop() {
    if (!running) return;
    running = false;
    forget();
    document.removeEventListener('focusin', remember, true);
    document.removeEventListener('focusout', focusOut, true);
    document.removeEventListener('pointerdown', pointer, true);
    document.removeEventListener('keydown', key, true);
    document.removeEventListener('shopify:section:unload', sectionChanged, true);
    document.removeEventListener('shopify:section:load', sectionChanged, true);
    window.removeEventListener('blur', forget);
    window.removeEventListener('resize', resize);
    document.removeEventListener('keyup', escapeReveal);
    document.removeEventListener('wheel', panReveal, true);
    document.removeEventListener('touchstart', panReveal, true);
    window.removeEventListener('scroll', scrollReveal, true);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', resizeReveal);
      window.visualViewport.removeEventListener('scroll', panReveal);
    }
    if (media.removeEventListener) media.removeEventListener('change', resize);
    else media.removeListener(resize);
    media = null;
  }
  window.addEventListener('pagehide', stop);
  window.addEventListener('pageshow', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
